{
  "minecraftVersion": "26.1.2",
  "source": "https://piston-meta.mojang.com/v1/packages/6f2c56190a59d4920b82d73ebbf7969c260f3f36/26.1.2.json",
  "iconSource": "https://mc-icons.com",
  "soundSource": "https://piston-meta.mojang.com/v1/packages/44d3e2c72e3aa33bd9117e1a3aa5f71e07da5c9a/30.json",
  "items": {
    "acacia_boat": {
      "name": "Acacia Boat",
      "tone": "#888888"
    },
    "acacia_button": {
      "name": "Acacia Button",
      "tone": "#888888"
    },
    "acacia_chest_boat": {
      "name": "Acacia Boat with Chest",
      "tone": "#888888"
    },
    "acacia_door": {
      "name": "Acacia Door",
      "tone": "#888888"
    },
    "acacia_fence": {
      "name": "Acacia Fence",
      "tone": "#888888"
    },
    "acacia_fence_gate": {
      "name": "Acacia Fence Gate",
      "tone": "#888888"
    },
    "acacia_hanging_sign": {
      "name": "Acacia Hanging Sign",
      "tone": "#888888"
    },
    "acacia_log": {
      "name": "Acacia Log",
      "tone": "#888888"
    },
    "acacia_planks": {
      "name": "Acacia Planks",
      "tone": "#888888"
    },
    "acacia_pressure_plate": {
      "name": "Acacia Pressure Plate",
      "tone": "#888888"
    },
    "acacia_shelf": {
      "name": "Acacia Shelf",
      "tone": "#888888"
    },
    "acacia_sign": {
      "name": "Acacia Sign",
      "tone": "#888888"
    },
    "acacia_slab": {
      "name": "Acacia Slab",
      "tone": "#888888"
    },
    "acacia_stairs": {
      "name": "Acacia Stairs",
      "tone": "#888888"
    },
    "acacia_trapdoor": {
      "name": "Acacia Trapdoor",
      "tone": "#888888"
    },
    "acacia_wood": {
      "name": "Acacia Wood",
      "tone": "#888888"
    },
    "activator_rail": {
      "name": "Activator Rail",
      "tone": "#888888"
    },
    "allium": {
      "name": "Allium",
      "tone": "#888888"
    },
    "amethyst_block": {
      "name": "Block of Amethyst",
      "tone": "#888888"
    },
    "amethyst_shard": {
      "name": "Amethyst Shard",
      "tone": "#888888"
    },
    "andesite": {
      "name": "Andesite",
      "tone": "#888888"
    },
    "andesite_slab": {
      "name": "Andesite Slab",
      "tone": "#888888"
    },
    "andesite_stairs": {
      "name": "Andesite Stairs",
      "tone": "#888888"
    },
    "andesite_wall": {
      "name": "Andesite Wall",
      "tone": "#888888"
    },
    "anvil": {
      "name": "Anvil",
      "tone": "#888888"
    },
    "apple": {
      "name": "Apple",
      "tone": "#888888"
    },
    "armadillo_scute": {
      "name": "Armadillo Scute",
      "tone": "#888888"
    },
    "armor_stand": {
      "name": "Armor Stand",
      "tone": "#888888"
    },
    "arrow": {
      "name": "Arrow",
      "tone": "#888888"
    },
    "azure_bluet": {
      "name": "Azure Bluet",
      "tone": "#888888"
    },
    "baked_potato": {
      "name": "Baked Potato",
      "tone": "#888888"
    },
    "bamboo": {
      "name": "Bamboo",
      "tone": "#888888"
    },
    "bamboo_block": {
      "name": "Block of Bamboo",
      "tone": "#888888"
    },
    "bamboo_button": {
      "name": "Bamboo Button",
      "tone": "#888888"
    },
    "bamboo_chest_raft": {
      "name": "Bamboo Raft with Chest",
      "tone": "#888888"
    },
    "bamboo_door": {
      "name": "Bamboo Door",
      "tone": "#888888"
    },
    "bamboo_fence": {
      "name": "Bamboo Fence",
      "tone": "#888888"
    },
    "bamboo_fence_gate": {
      "name": "Bamboo Fence Gate",
      "tone": "#888888"
    },
    "bamboo_hanging_sign": {
      "name": "Bamboo Hanging Sign",
      "tone": "#888888"
    },
    "bamboo_mosaic": {
      "name": "Bamboo Mosaic",
      "tone": "#888888"
    },
    "bamboo_mosaic_slab": {
      "name": "Bamboo Mosaic Slab",
      "tone": "#888888"
    },
    "bamboo_mosaic_stairs": {
      "name": "Bamboo Mosaic Stairs",
      "tone": "#888888"
    },
    "bamboo_planks": {
      "name": "Bamboo Planks",
      "tone": "#888888"
    },
    "bamboo_pressure_plate": {
      "name": "Bamboo Pressure Plate",
      "tone": "#888888"
    },
    "bamboo_raft": {
      "name": "Bamboo Raft",
      "tone": "#888888"
    },
    "bamboo_shelf": {
      "name": "Bamboo Shelf",
      "tone": "#888888"
    },
    "bamboo_sign": {
      "name": "Bamboo Sign",
      "tone": "#888888"
    },
    "bamboo_slab": {
      "name": "Bamboo Slab",
      "tone": "#888888"
    },
    "bamboo_stairs": {
      "name": "Bamboo Stairs",
      "tone": "#888888"
    },
    "bamboo_trapdoor": {
      "name": "Bamboo Trapdoor",
      "tone": "#888888"
    },
    "barrel": {
      "name": "Barrel",
      "tone": "#888888"
    },
    "basalt": {
      "name": "Basalt",
      "tone": "#888888"
    },
    "beacon": {
      "name": "Beacon",
      "tone": "#888888"
    },
    "beehive": {
      "name": "Beehive",
      "tone": "#888888"
    },
    "beetroot": {
      "name": "Beetroot",
      "tone": "#888888"
    },
    "beetroot_soup": {
      "name": "Beetroot Soup",
      "tone": "#888888"
    },
    "birch_boat": {
      "name": "Birch Boat",
      "tone": "#888888"
    },
    "birch_button": {
      "name": "Birch Button",
      "tone": "#888888"
    },
    "birch_chest_boat": {
      "name": "Birch Boat with Chest",
      "tone": "#888888"
    },
    "birch_door": {
      "name": "Birch Door",
      "tone": "#888888"
    },
    "birch_fence": {
      "name": "Birch Fence",
      "tone": "#888888"
    },
    "birch_fence_gate": {
      "name": "Birch Fence Gate",
      "tone": "#888888"
    },
    "birch_hanging_sign": {
      "name": "Birch Hanging Sign",
      "tone": "#888888"
    },
    "birch_log": {
      "name": "Birch Log",
      "tone": "#888888"
    },
    "birch_planks": {
      "name": "Birch Planks",
      "tone": "#888888"
    },
    "birch_pressure_plate": {
      "name": "Birch Pressure Plate",
      "tone": "#888888"
    },
    "birch_shelf": {
      "name": "Birch Shelf",
      "tone": "#888888"
    },
    "birch_sign": {
      "name": "Birch Sign",
      "tone": "#888888"
    },
    "birch_slab": {
      "name": "Birch Slab",
      "tone": "#888888"
    },
    "birch_stairs": {
      "name": "Birch Stairs",
      "tone": "#888888"
    },
    "birch_trapdoor": {
      "name": "Birch Trapdoor",
      "tone": "#888888"
    },
    "birch_wood": {
      "name": "Birch Wood",
      "tone": "#888888"
    },
    "black_banner": {
      "name": "Black Banner",
      "tone": "#888888"
    },
    "black_bed": {
      "name": "Black Bed",
      "tone": "#888888"
    },
    "black_bundle": {
      "name": "Black Bundle",
      "tone": "#888888"
    },
    "black_candle": {
      "name": "Black Candle",
      "tone": "#888888"
    },
    "black_carpet": {
      "name": "Black Carpet",
      "tone": "#888888"
    },
    "black_concrete_powder": {
      "name": "Black Concrete Powder",
      "tone": "#888888"
    },
    "black_dye": {
      "name": "Black Dye",
      "tone": "#888888"
    },
    "black_harness": {
      "name": "Black Harness",
      "tone": "#888888"
    },
    "black_shulker_box": {
      "name": "Black Shulker Box",
      "tone": "#888888"
    },
    "black_stained_glass": {
      "name": "Black Stained Glass",
      "tone": "#888888"
    },
    "black_stained_glass_pane": {
      "name": "Black Stained Glass Pane",
      "tone": "#888888"
    },
    "black_terracotta": {
      "name": "Black Terracotta",
      "tone": "#888888"
    },
    "black_wool": {
      "name": "Black Wool",
      "tone": "#888888"
    },
    "blackstone": {
      "name": "Blackstone",
      "tone": "#888888"
    },
    "blackstone_slab": {
      "name": "Blackstone Slab",
      "tone": "#888888"
    },
    "blackstone_stairs": {
      "name": "Blackstone Stairs",
      "tone": "#888888"
    },
    "blackstone_wall": {
      "name": "Blackstone Wall",
      "tone": "#888888"
    },
    "blast_furnace": {
      "name": "Blast Furnace",
      "tone": "#888888"
    },
    "blaze_powder": {
      "name": "Blaze Powder",
      "tone": "#888888"
    },
    "blaze_rod": {
      "name": "Blaze Rod",
      "tone": "#888888"
    },
    "blue_banner": {
      "name": "Blue Banner",
      "tone": "#888888"
    },
    "blue_bed": {
      "name": "Blue Bed",
      "tone": "#888888"
    },
    "blue_bundle": {
      "name": "Blue Bundle",
      "tone": "#888888"
    },
    "blue_candle": {
      "name": "Blue Candle",
      "tone": "#888888"
    },
    "blue_carpet": {
      "name": "Blue Carpet",
      "tone": "#888888"
    },
    "blue_concrete_powder": {
      "name": "Blue Concrete Powder",
      "tone": "#888888"
    },
    "blue_dye": {
      "name": "Blue Dye",
      "tone": "#888888"
    },
    "blue_harness": {
      "name": "Blue Harness",
      "tone": "#888888"
    },
    "blue_ice": {
      "name": "Blue Ice",
      "tone": "#888888"
    },
    "blue_orchid": {
      "name": "Blue Orchid",
      "tone": "#888888"
    },
    "blue_shulker_box": {
      "name": "Blue Shulker Box",
      "tone": "#888888"
    },
    "blue_stained_glass": {
      "name": "Blue Stained Glass",
      "tone": "#888888"
    },
    "blue_stained_glass_pane": {
      "name": "Blue Stained Glass Pane",
      "tone": "#888888"
    },
    "blue_terracotta": {
      "name": "Blue Terracotta",
      "tone": "#888888"
    },
    "blue_wool": {
      "name": "Blue Wool",
      "tone": "#888888"
    },
    "bone": {
      "name": "Bone",
      "tone": "#888888"
    },
    "bone_block": {
      "name": "Bone Block",
      "tone": "#888888"
    },
    "bone_meal": {
      "name": "Bone Meal",
      "tone": "#888888"
    },
    "book": {
      "name": "Book",
      "tone": "#888888"
    },
    "bookshelf": {
      "name": "Bookshelf",
      "tone": "#888888"
    },
    "bordure_indented_banner_pattern": {
      "name": "Bordure Indented Banner Pattern",
      "tone": "#888888"
    },
    "bow": {
      "name": "Bow",
      "tone": "#888888"
    },
    "bowl": {
      "name": "Bowl",
      "tone": "#888888"
    },
    "bread": {
      "name": "Bread",
      "tone": "#888888"
    },
    "breeze_rod": {
      "name": "Breeze Rod",
      "tone": "#888888"
    },
    "brewing_stand": {
      "name": "Brewing Stand",
      "tone": "#888888"
    },
    "brick": {
      "name": "Brick",
      "tone": "#888888"
    },
    "brick_slab": {
      "name": "Brick Slab",
      "tone": "#888888"
    },
    "brick_stairs": {
      "name": "Brick Stairs",
      "tone": "#888888"
    },
    "brick_wall": {
      "name": "Brick Wall",
      "tone": "#888888"
    },
    "bricks": {
      "name": "Bricks",
      "tone": "#888888"
    },
    "brown_banner": {
      "name": "Brown Banner",
      "tone": "#888888"
    },
    "brown_bed": {
      "name": "Brown Bed",
      "tone": "#888888"
    },
    "brown_bundle": {
      "name": "Brown Bundle",
      "tone": "#888888"
    },
    "brown_candle": {
      "name": "Brown Candle",
      "tone": "#888888"
    },
    "brown_carpet": {
      "name": "Brown Carpet",
      "tone": "#888888"
    },
    "brown_concrete_powder": {
      "name": "Brown Concrete Powder",
      "tone": "#888888"
    },
    "brown_dye": {
      "name": "Brown Dye",
      "tone": "#888888"
    },
    "brown_harness": {
      "name": "Brown Harness",
      "tone": "#888888"
    },
    "brown_mushroom": {
      "name": "Brown Mushroom",
      "tone": "#888888"
    },
    "brown_shulker_box": {
      "name": "Brown Shulker Box",
      "tone": "#888888"
    },
    "brown_stained_glass": {
      "name": "Brown Stained Glass",
      "tone": "#888888"
    },
    "brown_stained_glass_pane": {
      "name": "Brown Stained Glass Pane",
      "tone": "#888888"
    },
    "brown_terracotta": {
      "name": "Brown Terracotta",
      "tone": "#888888"
    },
    "brown_wool": {
      "name": "Brown Wool",
      "tone": "#888888"
    },
    "brush": {
      "name": "Brush",
      "tone": "#888888"
    },
    "bucket": {
      "name": "Bucket",
      "tone": "#888888"
    },
    "bundle": {
      "name": "Bundle",
      "tone": "#888888"
    },
    "cactus_flower": {
      "name": "Cactus Flower",
      "tone": "#888888"
    },
    "cake": {
      "name": "Cake",
      "tone": "#888888"
    },
    "calibrated_sculk_sensor": {
      "name": "Calibrated Sculk Sensor",
      "tone": "#888888"
    },
    "campfire": {
      "name": "Campfire",
      "tone": "#888888"
    },
    "candle": {
      "name": "Candle",
      "tone": "#888888"
    },
    "carrot": {
      "name": "Carrot",
      "tone": "#888888"
    },
    "carrot_on_a_stick": {
      "name": "Carrot on a Stick",
      "tone": "#888888"
    },
    "cartography_table": {
      "name": "Cartography Table",
      "tone": "#888888"
    },
    "carved_pumpkin": {
      "name": "Carved Pumpkin",
      "tone": "#888888"
    },
    "cauldron": {
      "name": "Cauldron",
      "tone": "#888888"
    },
    "cherry_boat": {
      "name": "Cherry Boat",
      "tone": "#888888"
    },
    "cherry_button": {
      "name": "Cherry Button",
      "tone": "#888888"
    },
    "cherry_chest_boat": {
      "name": "Cherry Boat with Chest",
      "tone": "#888888"
    },
    "cherry_door": {
      "name": "Cherry Door",
      "tone": "#888888"
    },
    "cherry_fence": {
      "name": "Cherry Fence",
      "tone": "#888888"
    },
    "cherry_fence_gate": {
      "name": "Cherry Fence Gate",
      "tone": "#888888"
    },
    "cherry_hanging_sign": {
      "name": "Cherry Hanging Sign",
      "tone": "#888888"
    },
    "cherry_log": {
      "name": "Cherry Log",
      "tone": "#888888"
    },
    "cherry_planks": {
      "name": "Cherry Planks",
      "tone": "#888888"
    },
    "cherry_pressure_plate": {
      "name": "Cherry Pressure Plate",
      "tone": "#888888"
    },
    "cherry_shelf": {
      "name": "Cherry Shelf",
      "tone": "#888888"
    },
    "cherry_sign": {
      "name": "Cherry Sign",
      "tone": "#888888"
    },
    "cherry_slab": {
      "name": "Cherry Slab",
      "tone": "#888888"
    },
    "cherry_stairs": {
      "name": "Cherry Stairs",
      "tone": "#888888"
    },
    "cherry_trapdoor": {
      "name": "Cherry Trapdoor",
      "tone": "#888888"
    },
    "cherry_wood": {
      "name": "Cherry Wood",
      "tone": "#888888"
    },
    "chest": {
      "name": "Chest",
      "tone": "#888888"
    },
    "chest_minecart": {
      "name": "Minecart with Chest",
      "tone": "#888888"
    },
    "chiseled_bookshelf": {
      "name": "Chiseled Bookshelf",
      "tone": "#888888"
    },
    "chiseled_copper": {
      "name": "Chiseled Copper",
      "tone": "#888888"
    },
    "chiseled_deepslate": {
      "name": "Chiseled Deepslate",
      "tone": "#888888"
    },
    "chiseled_nether_bricks": {
      "name": "Chiseled Nether Bricks",
      "tone": "#888888"
    },
    "chiseled_polished_blackstone": {
      "name": "Chiseled Polished Blackstone",
      "tone": "#888888"
    },
    "chiseled_quartz_block": {
      "name": "Chiseled Quartz Block",
      "tone": "#888888"
    },
    "chiseled_red_sandstone": {
      "name": "Chiseled Red Sandstone",
      "tone": "#888888"
    },
    "chiseled_resin_bricks": {
      "name": "Chiseled Resin Bricks",
      "tone": "#888888"
    },
    "chiseled_sandstone": {
      "name": "Chiseled Sandstone",
      "tone": "#888888"
    },
    "chiseled_stone_bricks": {
      "name": "Chiseled Stone Bricks",
      "tone": "#888888"
    },
    "chiseled_tuff": {
      "name": "Chiseled Tuff",
      "tone": "#888888"
    },
    "chiseled_tuff_bricks": {
      "name": "Chiseled Tuff Bricks",
      "tone": "#888888"
    },
    "clay": {
      "name": "Clay",
      "tone": "#888888"
    },
    "clay_ball": {
      "name": "Clay Ball",
      "tone": "#888888"
    },
    "clock": {
      "name": "Clock",
      "tone": "#888888"
    },
    "closed_eyeblossom": {
      "name": "Closed Eyeblossom",
      "tone": "#888888"
    },
    "coal": {
      "name": "Coal",
      "tone": "#888888"
    },
    "coal_block": {
      "name": "Block of Coal",
      "tone": "#888888"
    },
    "coarse_dirt": {
      "name": "Coarse Dirt",
      "tone": "#888888"
    },
    "cobbled_deepslate": {
      "name": "Cobbled Deepslate",
      "tone": "#888888"
    },
    "cobbled_deepslate_slab": {
      "name": "Cobbled Deepslate Slab",
      "tone": "#888888"
    },
    "cobbled_deepslate_stairs": {
      "name": "Cobbled Deepslate Stairs",
      "tone": "#888888"
    },
    "cobbled_deepslate_wall": {
      "name": "Cobbled Deepslate Wall",
      "tone": "#888888"
    },
    "cobblestone": {
      "name": "Cobblestone",
      "tone": "#888888"
    },
    "cobblestone_slab": {
      "name": "Cobblestone Slab",
      "tone": "#888888"
    },
    "cobblestone_stairs": {
      "name": "Cobblestone Stairs",
      "tone": "#888888"
    },
    "cobblestone_wall": {
      "name": "Cobblestone Wall",
      "tone": "#888888"
    },
    "cocoa_beans": {
      "name": "Cocoa Beans",
      "tone": "#888888"
    },
    "comparator": {
      "name": "Redstone Comparator",
      "tone": "#888888"
    },
    "compass": {
      "name": "Compass",
      "tone": "#888888"
    },
    "composter": {
      "name": "Composter",
      "tone": "#888888"
    },
    "conduit": {
      "name": "Conduit",
      "tone": "#888888"
    },
    "cooked_rabbit": {
      "name": "Cooked Rabbit",
      "tone": "#888888"
    },
    "cookie": {
      "name": "Cookie",
      "tone": "#888888"
    },
    "copper_axe": {
      "name": "Copper Axe",
      "tone": "#888888"
    },
    "copper_bars": {
      "name": "Copper Bars",
      "tone": "#888888"
    },
    "copper_block": {
      "name": "Block of Copper",
      "tone": "#888888"
    },
    "copper_boots": {
      "name": "Copper Boots",
      "tone": "#888888"
    },
    "copper_bulb": {
      "name": "Copper Bulb",
      "tone": "#888888"
    },
    "copper_chain": {
      "name": "Copper Chain",
      "tone": "#888888"
    },
    "copper_chest": {
      "name": "Copper Chest",
      "tone": "#888888"
    },
    "copper_chestplate": {
      "name": "Copper Chestplate",
      "tone": "#888888"
    },
    "copper_door": {
      "name": "Copper Door",
      "tone": "#888888"
    },
    "copper_golem_statue": {
      "name": "Copper Golem Statue",
      "tone": "#888888"
    },
    "copper_grate": {
      "name": "Copper Grate",
      "tone": "#888888"
    },
    "copper_helmet": {
      "name": "Copper Helmet",
      "tone": "#888888"
    },
    "copper_hoe": {
      "name": "Copper Hoe",
      "tone": "#888888"
    },
    "copper_ingot": {
      "name": "Copper Ingot",
      "tone": "#888888"
    },
    "copper_lantern": {
      "name": "Copper Lantern",
      "tone": "#888888"
    },
    "copper_leggings": {
      "name": "Copper Leggings",
      "tone": "#888888"
    },
    "copper_nugget": {
      "name": "Copper Nugget",
      "tone": "#888888"
    },
    "copper_pickaxe": {
      "name": "Copper Pickaxe",
      "tone": "#888888"
    },
    "copper_shovel": {
      "name": "Copper Shovel",
      "tone": "#888888"
    },
    "copper_spear": {
      "name": "Copper Spear",
      "tone": "#888888"
    },
    "copper_sword": {
      "name": "Copper Sword",
      "tone": "#888888"
    },
    "copper_torch": {
      "name": "Copper Torch",
      "tone": "#888888"
    },
    "copper_trapdoor": {
      "name": "Copper Trapdoor",
      "tone": "#888888"
    },
    "crafter": {
      "name": "Crafter",
      "tone": "#888888"
    },
    "crafting_table": {
      "name": "Crafting Table",
      "tone": "#888888"
    },
    "creaking_heart": {
      "name": "Creaking Heart",
      "tone": "#888888"
    },
    "creeper_banner_pattern": {
      "name": "Banner Pattern",
      "tone": "#888888"
    },
    "creeper_head": {
      "name": "Creeper Head",
      "tone": "#888888"
    },
    "crimson_button": {
      "name": "Crimson Button",
      "tone": "#888888"
    },
    "crimson_door": {
      "name": "Crimson Door",
      "tone": "#888888"
    },
    "crimson_fence": {
      "name": "Crimson Fence",
      "tone": "#888888"
    },
    "crimson_fence_gate": {
      "name": "Crimson Fence Gate",
      "tone": "#888888"
    },
    "crimson_hanging_sign": {
      "name": "Crimson Hanging Sign",
      "tone": "#888888"
    },
    "crimson_hyphae": {
      "name": "Crimson Hyphae",
      "tone": "#888888"
    },
    "crimson_planks": {
      "name": "Crimson Planks",
      "tone": "#888888"
    },
    "crimson_pressure_plate": {
      "name": "Crimson Pressure Plate",
      "tone": "#888888"
    },
    "crimson_shelf": {
      "name": "Crimson Shelf",
      "tone": "#888888"
    },
    "crimson_sign": {
      "name": "Crimson Sign",
      "tone": "#888888"
    },
    "crimson_slab": {
      "name": "Crimson Slab",
      "tone": "#888888"
    },
    "crimson_stairs": {
      "name": "Crimson Stairs",
      "tone": "#888888"
    },
    "crimson_stem": {
      "name": "Crimson Stem",
      "tone": "#888888"
    },
    "crimson_trapdoor": {
      "name": "Crimson Trapdoor",
      "tone": "#888888"
    },
    "crossbow": {
      "name": "Crossbow",
      "tone": "#888888"
    },
    "crying_obsidian": {
      "name": "Crying Obsidian",
      "tone": "#888888"
    },
    "cut_copper": {
      "name": "Cut Copper",
      "tone": "#888888"
    },
    "cut_copper_slab": {
      "name": "Cut Copper Slab",
      "tone": "#888888"
    },
    "cut_copper_stairs": {
      "name": "Cut Copper Stairs",
      "tone": "#888888"
    },
    "cut_red_sandstone": {
      "name": "Cut Red Sandstone",
      "tone": "#888888"
    },
    "cut_red_sandstone_slab": {
      "name": "Cut Red Sandstone Slab",
      "tone": "#888888"
    },
    "cut_sandstone": {
      "name": "Cut Sandstone",
      "tone": "#888888"
    },
    "cut_sandstone_slab": {
      "name": "Cut Sandstone Slab",
      "tone": "#888888"
    },
    "cyan_banner": {
      "name": "Cyan Banner",
      "tone": "#888888"
    },
    "cyan_bed": {
      "name": "Cyan Bed",
      "tone": "#888888"
    },
    "cyan_bundle": {
      "name": "Cyan Bundle",
      "tone": "#888888"
    },
    "cyan_candle": {
      "name": "Cyan Candle",
      "tone": "#888888"
    },
    "cyan_carpet": {
      "name": "Cyan Carpet",
      "tone": "#888888"
    },
    "cyan_concrete_powder": {
      "name": "Cyan Concrete Powder",
      "tone": "#888888"
    },
    "cyan_dye": {
      "name": "Cyan Dye",
      "tone": "#888888"
    },
    "cyan_harness": {
      "name": "Cyan Harness",
      "tone": "#888888"
    },
    "cyan_shulker_box": {
      "name": "Cyan Shulker Box",
      "tone": "#888888"
    },
    "cyan_stained_glass": {
      "name": "Cyan Stained Glass",
      "tone": "#888888"
    },
    "cyan_stained_glass_pane": {
      "name": "Cyan Stained Glass Pane",
      "tone": "#888888"
    },
    "cyan_terracotta": {
      "name": "Cyan Terracotta",
      "tone": "#888888"
    },
    "cyan_wool": {
      "name": "Cyan Wool",
      "tone": "#888888"
    },
    "dandelion": {
      "name": "Dandelion",
      "tone": "#888888"
    },
    "dark_oak_boat": {
      "name": "Dark Oak Boat",
      "tone": "#888888"
    },
    "dark_oak_button": {
      "name": "Dark Oak Button",
      "tone": "#888888"
    },
    "dark_oak_chest_boat": {
      "name": "Dark Oak Boat with Chest",
      "tone": "#888888"
    },
    "dark_oak_door": {
      "name": "Dark Oak Door",
      "tone": "#888888"
    },
    "dark_oak_fence": {
      "name": "Dark Oak Fence",
      "tone": "#888888"
    },
    "dark_oak_fence_gate": {
      "name": "Dark Oak Fence Gate",
      "tone": "#888888"
    },
    "dark_oak_hanging_sign": {
      "name": "Dark Oak Hanging Sign",
      "tone": "#888888"
    },
    "dark_oak_log": {
      "name": "Dark Oak Log",
      "tone": "#888888"
    },
    "dark_oak_planks": {
      "name": "Dark Oak Planks",
      "tone": "#888888"
    },
    "dark_oak_pressure_plate": {
      "name": "Dark Oak Pressure Plate",
      "tone": "#888888"
    },
    "dark_oak_shelf": {
      "name": "Dark Oak Shelf",
      "tone": "#888888"
    },
    "dark_oak_sign": {
      "name": "Dark Oak Sign",
      "tone": "#888888"
    },
    "dark_oak_slab": {
      "name": "Dark Oak Slab",
      "tone": "#888888"
    },
    "dark_oak_stairs": {
      "name": "Dark Oak Stairs",
      "tone": "#888888"
    },
    "dark_oak_trapdoor": {
      "name": "Dark Oak Trapdoor",
      "tone": "#888888"
    },
    "dark_oak_wood": {
      "name": "Dark Oak Wood",
      "tone": "#888888"
    },
    "dark_prismarine": {
      "name": "Dark Prismarine",
      "tone": "#888888"
    },
    "dark_prismarine_slab": {
      "name": "Dark Prismarine Slab",
      "tone": "#888888"
    },
    "dark_prismarine_stairs": {
      "name": "Dark Prismarine Stairs",
      "tone": "#888888"
    },
    "daylight_detector": {
      "name": "Daylight Detector",
      "tone": "#888888"
    },
    "decorated_pot": {
      "name": "Decorated Pot",
      "tone": "#888888"
    },
    "deepslate_brick_slab": {
      "name": "Deepslate Brick Slab",
      "tone": "#888888"
    },
    "deepslate_brick_stairs": {
      "name": "Deepslate Brick Stairs",
      "tone": "#888888"
    },
    "deepslate_brick_wall": {
      "name": "Deepslate Brick Wall",
      "tone": "#888888"
    },
    "deepslate_bricks": {
      "name": "Deepslate Bricks",
      "tone": "#888888"
    },
    "deepslate_tile_slab": {
      "name": "Deepslate Tile Slab",
      "tone": "#888888"
    },
    "deepslate_tile_stairs": {
      "name": "Deepslate Tile Stairs",
      "tone": "#888888"
    },
    "deepslate_tile_wall": {
      "name": "Deepslate Tile Wall",
      "tone": "#888888"
    },
    "deepslate_tiles": {
      "name": "Deepslate Tiles",
      "tone": "#888888"
    },
    "detector_rail": {
      "name": "Detector Rail",
      "tone": "#888888"
    },
    "diamond": {
      "name": "Diamond",
      "tone": "#888888"
    },
    "diamond_axe": {
      "name": "Diamond Axe",
      "tone": "#888888"
    },
    "diamond_block": {
      "name": "Block of Diamond",
      "tone": "#888888"
    },
    "diamond_boots": {
      "name": "Diamond Boots",
      "tone": "#888888"
    },
    "diamond_chestplate": {
      "name": "Diamond Chestplate",
      "tone": "#888888"
    },
    "diamond_helmet": {
      "name": "Diamond Helmet",
      "tone": "#888888"
    },
    "diamond_hoe": {
      "name": "Diamond Hoe",
      "tone": "#888888"
    },
    "diamond_leggings": {
      "name": "Diamond Leggings",
      "tone": "#888888"
    },
    "diamond_pickaxe": {
      "name": "Diamond Pickaxe",
      "tone": "#888888"
    },
    "diamond_shovel": {
      "name": "Diamond Shovel",
      "tone": "#888888"
    },
    "diamond_spear": {
      "name": "Diamond Spear",
      "tone": "#888888"
    },
    "diamond_sword": {
      "name": "Diamond Sword",
      "tone": "#888888"
    },
    "diorite": {
      "name": "Diorite",
      "tone": "#888888"
    },
    "diorite_slab": {
      "name": "Diorite Slab",
      "tone": "#888888"
    },
    "diorite_stairs": {
      "name": "Diorite Stairs",
      "tone": "#888888"
    },
    "diorite_wall": {
      "name": "Diorite Wall",
      "tone": "#888888"
    },
    "dirt": {
      "name": "Dirt",
      "tone": "#888888"
    },
    "disc_fragment_5": {
      "name": "Disc Fragment",
      "tone": "#888888"
    },
    "dispenser": {
      "name": "Dispenser",
      "tone": "#888888"
    },
    "dried_ghast": {
      "name": "Dried Ghast",
      "tone": "#888888"
    },
    "dried_kelp": {
      "name": "Dried Kelp",
      "tone": "#888888"
    },
    "dried_kelp_block": {
      "name": "Dried Kelp Block",
      "tone": "#888888"
    },
    "dripstone_block": {
      "name": "Dripstone Block",
      "tone": "#888888"
    },
    "dropper": {
      "name": "Dropper",
      "tone": "#888888"
    },
    "echo_shard": {
      "name": "Echo Shard",
      "tone": "#888888"
    },
    "egg": {
      "name": "Egg",
      "tone": "#888888"
    },
    "emerald": {
      "name": "Emerald",
      "tone": "#888888"
    },
    "emerald_block": {
      "name": "Block of Emerald",
      "tone": "#888888"
    },
    "enchanted_golden_apple": {
      "name": "Enchanted Golden Apple",
      "tone": "#888888"
    },
    "enchanting_table": {
      "name": "Enchanting Table",
      "tone": "#888888"
    },
    "end_crystal": {
      "name": "End Crystal",
      "tone": "#888888"
    },
    "end_rod": {
      "name": "End Rod",
      "tone": "#888888"
    },
    "end_stone": {
      "name": "End Stone",
      "tone": "#888888"
    },
    "end_stone_brick_slab": {
      "name": "End Stone Brick Slab",
      "tone": "#888888"
    },
    "end_stone_brick_stairs": {
      "name": "End Stone Brick Stairs",
      "tone": "#888888"
    },
    "end_stone_brick_wall": {
      "name": "End Stone Brick Wall",
      "tone": "#888888"
    },
    "end_stone_bricks": {
      "name": "End Stone Bricks",
      "tone": "#888888"
    },
    "ender_chest": {
      "name": "Ender Chest",
      "tone": "#888888"
    },
    "ender_eye": {
      "name": "Eye of Ender",
      "tone": "#888888"
    },
    "ender_pearl": {
      "name": "Ender Pearl",
      "tone": "#888888"
    },
    "exposed_chiseled_copper": {
      "name": "Exposed Chiseled Copper",
      "tone": "#888888"
    },
    "exposed_copper": {
      "name": "Exposed Copper",
      "tone": "#888888"
    },
    "exposed_copper_bars": {
      "name": "Exposed Copper Bars",
      "tone": "#888888"
    },
    "exposed_copper_bulb": {
      "name": "Exposed Copper Bulb",
      "tone": "#888888"
    },
    "exposed_copper_chain": {
      "name": "Exposed Copper Chain",
      "tone": "#888888"
    },
    "exposed_copper_chest": {
      "name": "Exposed Copper Chest",
      "tone": "#888888"
    },
    "exposed_copper_door": {
      "name": "Exposed Copper Door",
      "tone": "#888888"
    },
    "exposed_copper_golem_statue": {
      "name": "Exposed Copper Golem Statue",
      "tone": "#888888"
    },
    "exposed_copper_grate": {
      "name": "Exposed Copper Grate",
      "tone": "#888888"
    },
    "exposed_copper_lantern": {
      "name": "Exposed Copper Lantern",
      "tone": "#888888"
    },
    "exposed_copper_trapdoor": {
      "name": "Exposed Copper Trapdoor",
      "tone": "#888888"
    },
    "exposed_cut_copper": {
      "name": "Exposed Cut Copper",
      "tone": "#888888"
    },
    "exposed_cut_copper_slab": {
      "name": "Exposed Cut Copper Slab",
      "tone": "#888888"
    },
    "exposed_cut_copper_stairs": {
      "name": "Exposed Cut Copper Stairs",
      "tone": "#888888"
    },
    "exposed_lightning_rod": {
      "name": "Exposed Lightning Rod",
      "tone": "#888888"
    },
    "feather": {
      "name": "Feather",
      "tone": "#888888"
    },
    "fermented_spider_eye": {
      "name": "Fermented Spider Eye",
      "tone": "#888888"
    },
    "field_masoned_banner_pattern": {
      "name": "Field Masoned Banner Pattern",
      "tone": "#888888"
    },
    "fire_charge": {
      "name": "Fire Charge",
      "tone": "#888888"
    },
    "firework_rocket": {
      "name": "Firework Rocket",
      "tone": "#888888"
    },
    "firework_star": {
      "name": "Firework Star",
      "tone": "#888888"
    },
    "fishing_rod": {
      "name": "Fishing Rod",
      "tone": "#888888"
    },
    "fletching_table": {
      "name": "Fletching Table",
      "tone": "#888888"
    },
    "flint": {
      "name": "Flint",
      "tone": "#888888"
    },
    "flint_and_steel": {
      "name": "Flint and Steel",
      "tone": "#888888"
    },
    "flower_banner_pattern": {
      "name": "Banner Pattern",
      "tone": "#888888"
    },
    "flower_pot": {
      "name": "Flower Pot",
      "tone": "#888888"
    },
    "furnace": {
      "name": "Furnace",
      "tone": "#888888"
    },
    "furnace_minecart": {
      "name": "Minecart with Furnace",
      "tone": "#888888"
    },
    "ghast_tear": {
      "name": "Ghast Tear",
      "tone": "#888888"
    },
    "glass": {
      "name": "Glass",
      "tone": "#888888"
    },
    "glass_bottle": {
      "name": "Glass Bottle",
      "tone": "#888888"
    },
    "glass_pane": {
      "name": "Glass Pane",
      "tone": "#888888"
    },
    "glistering_melon_slice": {
      "name": "Glistering Melon Slice",
      "tone": "#888888"
    },
    "glow_ink_sac": {
      "name": "Glow Ink Sac",
      "tone": "#888888"
    },
    "glow_item_frame": {
      "name": "Glow Item Frame",
      "tone": "#888888"
    },
    "glowstone": {
      "name": "Glowstone",
      "tone": "#888888"
    },
    "glowstone_dust": {
      "name": "Glowstone Dust",
      "tone": "#888888"
    },
    "gold_block": {
      "name": "Block of Gold",
      "tone": "#888888"
    },
    "gold_ingot": {
      "name": "Gold Ingot",
      "tone": "#888888"
    },
    "gold_nugget": {
      "name": "Gold Nugget",
      "tone": "#888888"
    },
    "golden_apple": {
      "name": "Golden Apple",
      "tone": "#888888"
    },
    "golden_axe": {
      "name": "Golden Axe",
      "tone": "#888888"
    },
    "golden_boots": {
      "name": "Golden Boots",
      "tone": "#888888"
    },
    "golden_carrot": {
      "name": "Golden Carrot",
      "tone": "#888888"
    },
    "golden_chestplate": {
      "name": "Golden Chestplate",
      "tone": "#888888"
    },
    "golden_dandelion": {
      "name": "Golden Dandelion",
      "tone": "#888888"
    },
    "golden_helmet": {
      "name": "Golden Helmet",
      "tone": "#888888"
    },
    "golden_hoe": {
      "name": "Golden Hoe",
      "tone": "#888888"
    },
    "golden_leggings": {
      "name": "Golden Leggings",
      "tone": "#888888"
    },
    "golden_pickaxe": {
      "name": "Golden Pickaxe",
      "tone": "#888888"
    },
    "golden_shovel": {
      "name": "Golden Shovel",
      "tone": "#888888"
    },
    "golden_spear": {
      "name": "Golden Spear",
      "tone": "#888888"
    },
    "golden_sword": {
      "name": "Golden Sword",
      "tone": "#888888"
    },
    "granite": {
      "name": "Granite",
      "tone": "#888888"
    },
    "granite_slab": {
      "name": "Granite Slab",
      "tone": "#888888"
    },
    "granite_stairs": {
      "name": "Granite Stairs",
      "tone": "#888888"
    },
    "granite_wall": {
      "name": "Granite Wall",
      "tone": "#888888"
    },
    "gravel": {
      "name": "Gravel",
      "tone": "#888888"
    },
    "gray_banner": {
      "name": "Gray Banner",
      "tone": "#888888"
    },
    "gray_bed": {
      "name": "Gray Bed",
      "tone": "#888888"
    },
    "gray_bundle": {
      "name": "Gray Bundle",
      "tone": "#888888"
    },
    "gray_candle": {
      "name": "Gray Candle",
      "tone": "#888888"
    },
    "gray_carpet": {
      "name": "Gray Carpet",
      "tone": "#888888"
    },
    "gray_concrete_powder": {
      "name": "Gray Concrete Powder",
      "tone": "#888888"
    },
    "gray_dye": {
      "name": "Gray Dye",
      "tone": "#888888"
    },
    "gray_harness": {
      "name": "Gray Harness",
      "tone": "#888888"
    },
    "gray_shulker_box": {
      "name": "Gray Shulker Box",
      "tone": "#888888"
    },
    "gray_stained_glass": {
      "name": "Gray Stained Glass",
      "tone": "#888888"
    },
    "gray_stained_glass_pane": {
      "name": "Gray Stained Glass Pane",
      "tone": "#888888"
    },
    "gray_terracotta": {
      "name": "Gray Terracotta",
      "tone": "#888888"
    },
    "gray_wool": {
      "name": "Gray Wool",
      "tone": "#888888"
    },
    "green_banner": {
      "name": "Green Banner",
      "tone": "#888888"
    },
    "green_bed": {
      "name": "Green Bed",
      "tone": "#888888"
    },
    "green_bundle": {
      "name": "Green Bundle",
      "tone": "#888888"
    },
    "green_candle": {
      "name": "Green Candle",
      "tone": "#888888"
    },
    "green_carpet": {
      "name": "Green Carpet",
      "tone": "#888888"
    },
    "green_concrete_powder": {
      "name": "Green Concrete Powder",
      "tone": "#888888"
    },
    "green_dye": {
      "name": "Green Dye",
      "tone": "#888888"
    },
    "green_harness": {
      "name": "Green Harness",
      "tone": "#888888"
    },
    "green_shulker_box": {
      "name": "Green Shulker Box",
      "tone": "#888888"
    },
    "green_stained_glass": {
      "name": "Green Stained Glass",
      "tone": "#888888"
    },
    "green_stained_glass_pane": {
      "name": "Green Stained Glass Pane",
      "tone": "#888888"
    },
    "green_terracotta": {
      "name": "Green Terracotta",
      "tone": "#888888"
    },
    "green_wool": {
      "name": "Green Wool",
      "tone": "#888888"
    },
    "grindstone": {
      "name": "Grindstone",
      "tone": "#888888"
    },
    "gunpowder": {
      "name": "Gunpowder",
      "tone": "#888888"
    },
    "hay_block": {
      "name": "Hay Bale",
      "tone": "#888888"
    },
    "heart_of_the_sea": {
      "name": "Heart of the Sea",
      "tone": "#888888"
    },
    "heavy_core": {
      "name": "Heavy Core",
      "tone": "#888888"
    },
    "heavy_weighted_pressure_plate": {
      "name": "Heavy Weighted Pressure Plate",
      "tone": "#888888"
    },
    "honey_block": {
      "name": "Honey Block",
      "tone": "#888888"
    },
    "honey_bottle": {
      "name": "Honey Bottle",
      "tone": "#888888"
    },
    "honeycomb": {
      "name": "Honeycomb",
      "tone": "#888888"
    },
    "honeycomb_block": {
      "name": "Honeycomb Block",
      "tone": "#888888"
    },
    "hopper": {
      "name": "Hopper",
      "tone": "#888888"
    },
    "hopper_minecart": {
      "name": "Minecart with Hopper",
      "tone": "#888888"
    },
    "ice": {
      "name": "Ice",
      "tone": "#888888"
    },
    "ink_sac": {
      "name": "Ink Sac",
      "tone": "#888888"
    },
    "iron_axe": {
      "name": "Iron Axe",
      "tone": "#888888"
    },
    "iron_bars": {
      "name": "Iron Bars",
      "tone": "#888888"
    },
    "iron_block": {
      "name": "Block of Iron",
      "tone": "#888888"
    },
    "iron_boots": {
      "name": "Iron Boots",
      "tone": "#888888"
    },
    "iron_chain": {
      "name": "Iron Chain",
      "tone": "#888888"
    },
    "iron_chestplate": {
      "name": "Iron Chestplate",
      "tone": "#888888"
    },
    "iron_door": {
      "name": "Iron Door",
      "tone": "#888888"
    },
    "iron_helmet": {
      "name": "Iron Helmet",
      "tone": "#888888"
    },
    "iron_hoe": {
      "name": "Iron Hoe",
      "tone": "#888888"
    },
    "iron_ingot": {
      "name": "Iron Ingot",
      "tone": "#888888"
    },
    "iron_leggings": {
      "name": "Iron Leggings",
      "tone": "#888888"
    },
    "iron_nugget": {
      "name": "Iron Nugget",
      "tone": "#888888"
    },
    "iron_pickaxe": {
      "name": "Iron Pickaxe",
      "tone": "#888888"
    },
    "iron_shovel": {
      "name": "Iron Shovel",
      "tone": "#888888"
    },
    "iron_spear": {
      "name": "Iron Spear",
      "tone": "#888888"
    },
    "iron_sword": {
      "name": "Iron Sword",
      "tone": "#888888"
    },
    "iron_trapdoor": {
      "name": "Iron Trapdoor",
      "tone": "#888888"
    },
    "item_frame": {
      "name": "Item Frame",
      "tone": "#888888"
    },
    "jack_o_lantern": {
      "name": "Jack o'Lantern",
      "tone": "#888888"
    },
    "jukebox": {
      "name": "Jukebox",
      "tone": "#888888"
    },
    "jungle_boat": {
      "name": "Jungle Boat",
      "tone": "#888888"
    },
    "jungle_button": {
      "name": "Jungle Button",
      "tone": "#888888"
    },
    "jungle_chest_boat": {
      "name": "Jungle Boat with Chest",
      "tone": "#888888"
    },
    "jungle_door": {
      "name": "Jungle Door",
      "tone": "#888888"
    },
    "jungle_fence": {
      "name": "Jungle Fence",
      "tone": "#888888"
    },
    "jungle_fence_gate": {
      "name": "Jungle Fence Gate",
      "tone": "#888888"
    },
    "jungle_hanging_sign": {
      "name": "Jungle Hanging Sign",
      "tone": "#888888"
    },
    "jungle_log": {
      "name": "Jungle Log",
      "tone": "#888888"
    },
    "jungle_planks": {
      "name": "Jungle Planks",
      "tone": "#888888"
    },
    "jungle_pressure_plate": {
      "name": "Jungle Pressure Plate",
      "tone": "#888888"
    },
    "jungle_shelf": {
      "name": "Jungle Shelf",
      "tone": "#888888"
    },
    "jungle_sign": {
      "name": "Jungle Sign",
      "tone": "#888888"
    },
    "jungle_slab": {
      "name": "Jungle Slab",
      "tone": "#888888"
    },
    "jungle_stairs": {
      "name": "Jungle Stairs",
      "tone": "#888888"
    },
    "jungle_trapdoor": {
      "name": "Jungle Trapdoor",
      "tone": "#888888"
    },
    "jungle_wood": {
      "name": "Jungle Wood",
      "tone": "#888888"
    },
    "ladder": {
      "name": "Ladder",
      "tone": "#888888"
    },
    "lantern": {
      "name": "Lantern",
      "tone": "#888888"
    },
    "lapis_block": {
      "name": "Block of Lapis Lazuli",
      "tone": "#888888"
    },
    "lapis_lazuli": {
      "name": "Lapis Lazuli",
      "tone": "#888888"
    },
    "lead": {
      "name": "Lead",
      "tone": "#888888"
    },
    "leather": {
      "name": "Leather",
      "tone": "#888888"
    },
    "leather_boots": {
      "name": "Leather Boots",
      "tone": "#888888"
    },
    "leather_chestplate": {
      "name": "Leather Tunic",
      "tone": "#888888"
    },
    "leather_helmet": {
      "name": "Leather Cap",
      "tone": "#888888"
    },
    "leather_horse_armor": {
      "name": "Leather Horse Armor",
      "tone": "#888888"
    },
    "leather_leggings": {
      "name": "Leather Pants",
      "tone": "#888888"
    },
    "lectern": {
      "name": "Lectern",
      "tone": "#888888"
    },
    "lever": {
      "name": "Lever",
      "tone": "#888888"
    },
    "light_blue_banner": {
      "name": "Light Blue Banner",
      "tone": "#888888"
    },
    "light_blue_bed": {
      "name": "Light Blue Bed",
      "tone": "#888888"
    },
    "light_blue_bundle": {
      "name": "Light Blue Bundle",
      "tone": "#888888"
    },
    "light_blue_candle": {
      "name": "Light Blue Candle",
      "tone": "#888888"
    },
    "light_blue_carpet": {
      "name": "Light Blue Carpet",
      "tone": "#888888"
    },
    "light_blue_concrete_powder": {
      "name": "Light Blue Concrete Powder",
      "tone": "#888888"
    },
    "light_blue_dye": {
      "name": "Light Blue Dye",
      "tone": "#888888"
    },
    "light_blue_harness": {
      "name": "Light Blue Harness",
      "tone": "#888888"
    },
    "light_blue_shulker_box": {
      "name": "Light Blue Shulker Box",
      "tone": "#888888"
    },
    "light_blue_stained_glass": {
      "name": "Light Blue Stained Glass",
      "tone": "#888888"
    },
    "light_blue_stained_glass_pane": {
      "name": "Light Blue Stained Glass Pane",
      "tone": "#888888"
    },
    "light_blue_terracotta": {
      "name": "Light Blue Terracotta",
      "tone": "#888888"
    },
    "light_blue_wool": {
      "name": "Light Blue Wool",
      "tone": "#888888"
    },
    "light_gray_banner": {
      "name": "Light Gray Banner",
      "tone": "#888888"
    },
    "light_gray_bed": {
      "name": "Light Gray Bed",
      "tone": "#888888"
    },
    "light_gray_bundle": {
      "name": "Light Gray Bundle",
      "tone": "#888888"
    },
    "light_gray_candle": {
      "name": "Light Gray Candle",
      "tone": "#888888"
    },
    "light_gray_carpet": {
      "name": "Light Gray Carpet",
      "tone": "#888888"
    },
    "light_gray_concrete_powder": {
      "name": "Light Gray Concrete Powder",
      "tone": "#888888"
    },
    "light_gray_dye": {
      "name": "Light Gray Dye",
      "tone": "#888888"
    },
    "light_gray_harness": {
      "name": "Light Gray Harness",
      "tone": "#888888"
    },
    "light_gray_shulker_box": {
      "name": "Light Gray Shulker Box",
      "tone": "#888888"
    },
    "light_gray_stained_glass": {
      "name": "Light Gray Stained Glass",
      "tone": "#888888"
    },
    "light_gray_stained_glass_pane": {
      "name": "Light Gray Stained Glass Pane",
      "tone": "#888888"
    },
    "light_gray_terracotta": {
      "name": "Light Gray Terracotta",
      "tone": "#888888"
    },
    "light_gray_wool": {
      "name": "Light Gray Wool",
      "tone": "#888888"
    },
    "light_weighted_pressure_plate": {
      "name": "Light Weighted Pressure Plate",
      "tone": "#888888"
    },
    "lightning_rod": {
      "name": "Lightning Rod",
      "tone": "#888888"
    },
    "lime_banner": {
      "name": "Lime Banner",
      "tone": "#888888"
    },
    "lime_bed": {
      "name": "Lime Bed",
      "tone": "#888888"
    },
    "lime_bundle": {
      "name": "Lime Bundle",
      "tone": "#888888"
    },
    "lime_candle": {
      "name": "Lime Candle",
      "tone": "#888888"
    },
    "lime_carpet": {
      "name": "Lime Carpet",
      "tone": "#888888"
    },
    "lime_concrete_powder": {
      "name": "Lime Concrete Powder",
      "tone": "#888888"
    },
    "lime_dye": {
      "name": "Lime Dye",
      "tone": "#888888"
    },
    "lime_harness": {
      "name": "Lime Harness",
      "tone": "#888888"
    },
    "lime_shulker_box": {
      "name": "Lime Shulker Box",
      "tone": "#888888"
    },
    "lime_stained_glass": {
      "name": "Lime Stained Glass",
      "tone": "#888888"
    },
    "lime_stained_glass_pane": {
      "name": "Lime Stained Glass Pane",
      "tone": "#888888"
    },
    "lime_terracotta": {
      "name": "Lime Terracotta",
      "tone": "#888888"
    },
    "lime_wool": {
      "name": "Lime Wool",
      "tone": "#888888"
    },
    "lingering_potion": {
      "name": "Lingering Potion",
      "tone": "#888888"
    },
    "lodestone": {
      "name": "Lodestone",
      "tone": "#888888"
    },
    "loom": {
      "name": "Loom",
      "tone": "#888888"
    },
    "mace": {
      "name": "Mace",
      "tone": "#888888"
    },
    "magenta_banner": {
      "name": "Magenta Banner",
      "tone": "#888888"
    },
    "magenta_bed": {
      "name": "Magenta Bed",
      "tone": "#888888"
    },
    "magenta_bundle": {
      "name": "Magenta Bundle",
      "tone": "#888888"
    },
    "magenta_candle": {
      "name": "Magenta Candle",
      "tone": "#888888"
    },
    "magenta_carpet": {
      "name": "Magenta Carpet",
      "tone": "#888888"
    },
    "magenta_concrete_powder": {
      "name": "Magenta Concrete Powder",
      "tone": "#888888"
    },
    "magenta_dye": {
      "name": "Magenta Dye",
      "tone": "#888888"
    },
    "magenta_harness": {
      "name": "Magenta Harness",
      "tone": "#888888"
    },
    "magenta_shulker_box": {
      "name": "Magenta Shulker Box",
      "tone": "#888888"
    },
    "magenta_stained_glass": {
      "name": "Magenta Stained Glass",
      "tone": "#888888"
    },
    "magenta_stained_glass_pane": {
      "name": "Magenta Stained Glass Pane",
      "tone": "#888888"
    },
    "magenta_terracotta": {
      "name": "Magenta Terracotta",
      "tone": "#888888"
    },
    "magenta_wool": {
      "name": "Magenta Wool",
      "tone": "#888888"
    },
    "magma_block": {
      "name": "Magma Block",
      "tone": "#888888"
    },
    "magma_cream": {
      "name": "Magma Cream",
      "tone": "#888888"
    },
    "mangrove_boat": {
      "name": "Mangrove Boat",
      "tone": "#888888"
    },
    "mangrove_button": {
      "name": "Mangrove Button",
      "tone": "#888888"
    },
    "mangrove_chest_boat": {
      "name": "Mangrove Boat with Chest",
      "tone": "#888888"
    },
    "mangrove_door": {
      "name": "Mangrove Door",
      "tone": "#888888"
    },
    "mangrove_fence": {
      "name": "Mangrove Fence",
      "tone": "#888888"
    },
    "mangrove_fence_gate": {
      "name": "Mangrove Fence Gate",
      "tone": "#888888"
    },
    "mangrove_hanging_sign": {
      "name": "Mangrove Hanging Sign",
      "tone": "#888888"
    },
    "mangrove_log": {
      "name": "Mangrove Log",
      "tone": "#888888"
    },
    "mangrove_planks": {
      "name": "Mangrove Planks",
      "tone": "#888888"
    },
    "mangrove_pressure_plate": {
      "name": "Mangrove Pressure Plate",
      "tone": "#888888"
    },
    "mangrove_roots": {
      "name": "Mangrove Roots",
      "tone": "#888888"
    },
    "mangrove_shelf": {
      "name": "Mangrove Shelf",
      "tone": "#888888"
    },
    "mangrove_sign": {
      "name": "Mangrove Sign",
      "tone": "#888888"
    },
    "mangrove_slab": {
      "name": "Mangrove Slab",
      "tone": "#888888"
    },
    "mangrove_stairs": {
      "name": "Mangrove Stairs",
      "tone": "#888888"
    },
    "mangrove_trapdoor": {
      "name": "Mangrove Trapdoor",
      "tone": "#888888"
    },
    "mangrove_wood": {
      "name": "Mangrove Wood",
      "tone": "#888888"
    },
    "map": {
      "name": "Empty Map",
      "tone": "#888888"
    },
    "melon": {
      "name": "Melon",
      "tone": "#888888"
    },
    "melon_seeds": {
      "name": "Melon Seeds",
      "tone": "#888888"
    },
    "melon_slice": {
      "name": "Melon Slice",
      "tone": "#888888"
    },
    "milk_bucket": {
      "name": "Milk Bucket",
      "tone": "#888888"
    },
    "minecart": {
      "name": "Minecart",
      "tone": "#888888"
    },
    "mojang_banner_pattern": {
      "name": "Banner Pattern",
      "tone": "#888888"
    },
    "moss_block": {
      "name": "Moss Block",
      "tone": "#888888"
    },
    "moss_carpet": {
      "name": "Moss Carpet",
      "tone": "#888888"
    },
    "mossy_cobblestone": {
      "name": "Mossy Cobblestone",
      "tone": "#888888"
    },
    "mossy_cobblestone_slab": {
      "name": "Mossy Cobblestone Slab",
      "tone": "#888888"
    },
    "mossy_cobblestone_stairs": {
      "name": "Mossy Cobblestone Stairs",
      "tone": "#888888"
    },
    "mossy_cobblestone_wall": {
      "name": "Mossy Cobblestone Wall",
      "tone": "#888888"
    },
    "mossy_stone_brick_slab": {
      "name": "Mossy Stone Brick Slab",
      "tone": "#888888"
    },
    "mossy_stone_brick_stairs": {
      "name": "Mossy Stone Brick Stairs",
      "tone": "#888888"
    },
    "mossy_stone_brick_wall": {
      "name": "Mossy Stone Brick Wall",
      "tone": "#888888"
    },
    "mossy_stone_bricks": {
      "name": "Mossy Stone Bricks",
      "tone": "#888888"
    },
    "mud": {
      "name": "Mud",
      "tone": "#888888"
    },
    "mud_brick_slab": {
      "name": "Mud Brick Slab",
      "tone": "#888888"
    },
    "mud_brick_stairs": {
      "name": "Mud Brick Stairs",
      "tone": "#888888"
    },
    "mud_brick_wall": {
      "name": "Mud Brick Wall",
      "tone": "#888888"
    },
    "mud_bricks": {
      "name": "Mud Bricks",
      "tone": "#888888"
    },
    "muddy_mangrove_roots": {
      "name": "Muddy Mangrove Roots",
      "tone": "#888888"
    },
    "mushroom_stew": {
      "name": "Mushroom Stew",
      "tone": "#888888"
    },
    "music_disc_5": {
      "name": "Music Disc",
      "tone": "#888888"
    },
    "name_tag": {
      "name": "Name Tag",
      "tone": "#888888"
    },
    "nautilus_shell": {
      "name": "Nautilus Shell",
      "tone": "#888888"
    },
    "nether_brick": {
      "name": "Nether Brick",
      "tone": "#888888"
    },
    "nether_brick_fence": {
      "name": "Nether Brick Fence",
      "tone": "#888888"
    },
    "nether_brick_slab": {
      "name": "Nether Brick Slab",
      "tone": "#888888"
    },
    "nether_brick_stairs": {
      "name": "Nether Brick Stairs",
      "tone": "#888888"
    },
    "nether_brick_wall": {
      "name": "Nether Brick Wall",
      "tone": "#888888"
    },
    "nether_bricks": {
      "name": "Nether Bricks",
      "tone": "#888888"
    },
    "nether_star": {
      "name": "Nether Star",
      "tone": "#888888"
    },
    "nether_wart": {
      "name": "Nether Wart",
      "tone": "#888888"
    },
    "nether_wart_block": {
      "name": "Nether Wart Block",
      "tone": "#888888"
    },
    "netherite_block": {
      "name": "Block of Netherite",
      "tone": "#888888"
    },
    "netherite_ingot": {
      "name": "Netherite Ingot",
      "tone": "#888888"
    },
    "note_block": {
      "name": "Note Block",
      "tone": "#888888"
    },
    "oak_boat": {
      "name": "Oak Boat",
      "tone": "#888888"
    },
    "oak_button": {
      "name": "Oak Button",
      "tone": "#888888"
    },
    "oak_chest_boat": {
      "name": "Oak Boat with Chest",
      "tone": "#888888"
    },
    "oak_door": {
      "name": "Oak Door",
      "tone": "#888888"
    },
    "oak_fence": {
      "name": "Oak Fence",
      "tone": "#888888"
    },
    "oak_fence_gate": {
      "name": "Oak Fence Gate",
      "tone": "#888888"
    },
    "oak_hanging_sign": {
      "name": "Oak Hanging Sign",
      "tone": "#888888"
    },
    "oak_log": {
      "name": "Oak Log",
      "tone": "#888888"
    },
    "oak_planks": {
      "name": "Oak Planks",
      "tone": "#888888"
    },
    "oak_pressure_plate": {
      "name": "Oak Pressure Plate",
      "tone": "#888888"
    },
    "oak_shelf": {
      "name": "Oak Shelf",
      "tone": "#888888"
    },
    "oak_sign": {
      "name": "Oak Sign",
      "tone": "#888888"
    },
    "oak_slab": {
      "name": "Oak Slab",
      "tone": "#888888"
    },
    "oak_stairs": {
      "name": "Oak Stairs",
      "tone": "#888888"
    },
    "oak_trapdoor": {
      "name": "Oak Trapdoor",
      "tone": "#888888"
    },
    "oak_wood": {
      "name": "Oak Wood",
      "tone": "#888888"
    },
    "observer": {
      "name": "Observer",
      "tone": "#888888"
    },
    "obsidian": {
      "name": "Obsidian",
      "tone": "#888888"
    },
    "open_eyeblossom": {
      "name": "Open Eyeblossom",
      "tone": "#888888"
    },
    "orange_banner": {
      "name": "Orange Banner",
      "tone": "#888888"
    },
    "orange_bed": {
      "name": "Orange Bed",
      "tone": "#888888"
    },
    "orange_bundle": {
      "name": "Orange Bundle",
      "tone": "#888888"
    },
    "orange_candle": {
      "name": "Orange Candle",
      "tone": "#888888"
    },
    "orange_carpet": {
      "name": "Orange Carpet",
      "tone": "#888888"
    },
    "orange_concrete_powder": {
      "name": "Orange Concrete Powder",
      "tone": "#888888"
    },
    "orange_dye": {
      "name": "Orange Dye",
      "tone": "#888888"
    },
    "orange_harness": {
      "name": "Orange Harness",
      "tone": "#888888"
    },
    "orange_shulker_box": {
      "name": "Orange Shulker Box",
      "tone": "#888888"
    },
    "orange_stained_glass": {
      "name": "Orange Stained Glass",
      "tone": "#888888"
    },
    "orange_stained_glass_pane": {
      "name": "Orange Stained Glass Pane",
      "tone": "#888888"
    },
    "orange_terracotta": {
      "name": "Orange Terracotta",
      "tone": "#888888"
    },
    "orange_wool": {
      "name": "Orange Wool",
      "tone": "#888888"
    },
    "oxeye_daisy": {
      "name": "Oxeye Daisy",
      "tone": "#888888"
    },
    "oxidized_chiseled_copper": {
      "name": "Oxidized Chiseled Copper",
      "tone": "#888888"
    },
    "oxidized_copper": {
      "name": "Oxidized Copper",
      "tone": "#888888"
    },
    "oxidized_copper_bars": {
      "name": "Oxidized Copper Bars",
      "tone": "#888888"
    },
    "oxidized_copper_bulb": {
      "name": "Oxidized Copper Bulb",
      "tone": "#888888"
    },
    "oxidized_copper_chain": {
      "name": "Oxidized Copper Chain",
      "tone": "#888888"
    },
    "oxidized_copper_chest": {
      "name": "Oxidized Copper Chest",
      "tone": "#888888"
    },
    "oxidized_copper_door": {
      "name": "Oxidized Copper Door",
      "tone": "#888888"
    },
    "oxidized_copper_golem_statue": {
      "name": "Oxidized Copper Golem Statue",
      "tone": "#888888"
    },
    "oxidized_copper_grate": {
      "name": "Oxidized Copper Grate",
      "tone": "#888888"
    },
    "oxidized_copper_lantern": {
      "name": "Oxidized Copper Lantern",
      "tone": "#888888"
    },
    "oxidized_copper_trapdoor": {
      "name": "Oxidized Copper Trapdoor",
      "tone": "#888888"
    },
    "oxidized_cut_copper": {
      "name": "Oxidized Cut Copper",
      "tone": "#888888"
    },
    "oxidized_cut_copper_slab": {
      "name": "Oxidized Cut Copper Slab",
      "tone": "#888888"
    },
    "oxidized_cut_copper_stairs": {
      "name": "Oxidized Cut Copper Stairs",
      "tone": "#888888"
    },
    "oxidized_lightning_rod": {
      "name": "Oxidized Lightning Rod",
      "tone": "#888888"
    },
    "packed_ice": {
      "name": "Packed Ice",
      "tone": "#888888"
    },
    "packed_mud": {
      "name": "Packed Mud",
      "tone": "#888888"
    },
    "painting": {
      "name": "Painting",
      "tone": "#888888"
    },
    "pale_moss_block": {
      "name": "Pale Moss Block",
      "tone": "#888888"
    },
    "pale_moss_carpet": {
      "name": "Pale Moss Carpet",
      "tone": "#888888"
    },
    "pale_oak_boat": {
      "name": "Pale Oak Boat",
      "tone": "#888888"
    },
    "pale_oak_button": {
      "name": "Pale Oak Button",
      "tone": "#888888"
    },
    "pale_oak_chest_boat": {
      "name": "Pale Oak Boat with Chest",
      "tone": "#888888"
    },
    "pale_oak_door": {
      "name": "Pale Oak Door",
      "tone": "#888888"
    },
    "pale_oak_fence": {
      "name": "Pale Oak Fence",
      "tone": "#888888"
    },
    "pale_oak_fence_gate": {
      "name": "Pale Oak Fence Gate",
      "tone": "#888888"
    },
    "pale_oak_hanging_sign": {
      "name": "Pale Oak Hanging Sign",
      "tone": "#888888"
    },
    "pale_oak_log": {
      "name": "Pale Oak Log",
      "tone": "#888888"
    },
    "pale_oak_planks": {
      "name": "Pale Oak Planks",
      "tone": "#888888"
    },
    "pale_oak_pressure_plate": {
      "name": "Pale Oak Pressure Plate",
      "tone": "#888888"
    },
    "pale_oak_shelf": {
      "name": "Pale Oak Shelf",
      "tone": "#888888"
    },
    "pale_oak_sign": {
      "name": "Pale Oak Sign",
      "tone": "#888888"
    },
    "pale_oak_slab": {
      "name": "Pale Oak Slab",
      "tone": "#888888"
    },
    "pale_oak_stairs": {
      "name": "Pale Oak Stairs",
      "tone": "#888888"
    },
    "pale_oak_trapdoor": {
      "name": "Pale Oak Trapdoor",
      "tone": "#888888"
    },
    "pale_oak_wood": {
      "name": "Pale Oak Wood",
      "tone": "#888888"
    },
    "paper": {
      "name": "Paper",
      "tone": "#888888"
    },
    "pink_banner": {
      "name": "Pink Banner",
      "tone": "#888888"
    },
    "pink_bed": {
      "name": "Pink Bed",
      "tone": "#888888"
    },
    "pink_bundle": {
      "name": "Pink Bundle",
      "tone": "#888888"
    },
    "pink_candle": {
      "name": "Pink Candle",
      "tone": "#888888"
    },
    "pink_carpet": {
      "name": "Pink Carpet",
      "tone": "#888888"
    },
    "pink_concrete_powder": {
      "name": "Pink Concrete Powder",
      "tone": "#888888"
    },
    "pink_dye": {
      "name": "Pink Dye",
      "tone": "#888888"
    },
    "pink_harness": {
      "name": "Pink Harness",
      "tone": "#888888"
    },
    "pink_shulker_box": {
      "name": "Pink Shulker Box",
      "tone": "#888888"
    },
    "pink_stained_glass": {
      "name": "Pink Stained Glass",
      "tone": "#888888"
    },
    "pink_stained_glass_pane": {
      "name": "Pink Stained Glass Pane",
      "tone": "#888888"
    },
    "pink_terracotta": {
      "name": "Pink Terracotta",
      "tone": "#888888"
    },
    "pink_wool": {
      "name": "Pink Wool",
      "tone": "#888888"
    },
    "piston": {
      "name": "Piston",
      "tone": "#888888"
    },
    "pitcher_plant": {
      "name": "Pitcher Plant",
      "tone": "#888888"
    },
    "pointed_dripstone": {
      "name": "Pointed Dripstone",
      "tone": "#888888"
    },
    "polished_andesite": {
      "name": "Polished Andesite",
      "tone": "#888888"
    },
    "polished_andesite_slab": {
      "name": "Polished Andesite Slab",
      "tone": "#888888"
    },
    "polished_andesite_stairs": {
      "name": "Polished Andesite Stairs",
      "tone": "#888888"
    },
    "polished_basalt": {
      "name": "Polished Basalt",
      "tone": "#888888"
    },
    "polished_blackstone": {
      "name": "Polished Blackstone",
      "tone": "#888888"
    },
    "polished_blackstone_brick_slab": {
      "name": "Polished Blackstone Brick Slab",
      "tone": "#888888"
    },
    "polished_blackstone_brick_stairs": {
      "name": "Polished Blackstone Brick Stairs",
      "tone": "#888888"
    },
    "polished_blackstone_brick_wall": {
      "name": "Polished Blackstone Brick Wall",
      "tone": "#888888"
    },
    "polished_blackstone_bricks": {
      "name": "Polished Blackstone Bricks",
      "tone": "#888888"
    },
    "polished_blackstone_button": {
      "name": "Polished Blackstone Button",
      "tone": "#888888"
    },
    "polished_blackstone_pressure_plate": {
      "name": "Polished Blackstone Pressure Plate",
      "tone": "#888888"
    },
    "polished_blackstone_slab": {
      "name": "Polished Blackstone Slab",
      "tone": "#888888"
    },
    "polished_blackstone_stairs": {
      "name": "Polished Blackstone Stairs",
      "tone": "#888888"
    },
    "polished_blackstone_wall": {
      "name": "Polished Blackstone Wall",
      "tone": "#888888"
    },
    "polished_deepslate": {
      "name": "Polished Deepslate",
      "tone": "#888888"
    },
    "polished_deepslate_slab": {
      "name": "Polished Deepslate Slab",
      "tone": "#888888"
    },
    "polished_deepslate_stairs": {
      "name": "Polished Deepslate Stairs",
      "tone": "#888888"
    },
    "polished_deepslate_wall": {
      "name": "Polished Deepslate Wall",
      "tone": "#888888"
    },
    "polished_diorite": {
      "name": "Polished Diorite",
      "tone": "#888888"
    },
    "polished_diorite_slab": {
      "name": "Polished Diorite Slab",
      "tone": "#888888"
    },
    "polished_diorite_stairs": {
      "name": "Polished Diorite Stairs",
      "tone": "#888888"
    },
    "polished_granite": {
      "name": "Polished Granite",
      "tone": "#888888"
    },
    "polished_granite_slab": {
      "name": "Polished Granite Slab",
      "tone": "#888888"
    },
    "polished_granite_stairs": {
      "name": "Polished Granite Stairs",
      "tone": "#888888"
    },
    "polished_tuff": {
      "name": "Polished Tuff",
      "tone": "#888888"
    },
    "polished_tuff_slab": {
      "name": "Polished Tuff Slab",
      "tone": "#888888"
    },
    "polished_tuff_stairs": {
      "name": "Polished Tuff Stairs",
      "tone": "#888888"
    },
    "polished_tuff_wall": {
      "name": "Polished Tuff Wall",
      "tone": "#888888"
    },
    "popped_chorus_fruit": {
      "name": "Popped Chorus Fruit",
      "tone": "#888888"
    },
    "powered_rail": {
      "name": "Powered Rail",
      "tone": "#888888"
    },
    "prismarine": {
      "name": "Prismarine",
      "tone": "#888888"
    },
    "prismarine_brick_slab": {
      "name": "Prismarine Brick Slab",
      "tone": "#888888"
    },
    "prismarine_brick_stairs": {
      "name": "Prismarine Brick Stairs",
      "tone": "#888888"
    },
    "prismarine_bricks": {
      "name": "Prismarine Bricks",
      "tone": "#888888"
    },
    "prismarine_crystals": {
      "name": "Prismarine Crystals",
      "tone": "#888888"
    },
    "prismarine_shard": {
      "name": "Prismarine Shard",
      "tone": "#888888"
    },
    "prismarine_slab": {
      "name": "Prismarine Slab",
      "tone": "#888888"
    },
    "prismarine_stairs": {
      "name": "Prismarine Stairs",
      "tone": "#888888"
    },
    "prismarine_wall": {
      "name": "Prismarine Wall",
      "tone": "#888888"
    },
    "pumpkin": {
      "name": "Pumpkin",
      "tone": "#888888"
    },
    "pumpkin_pie": {
      "name": "Pumpkin Pie",
      "tone": "#888888"
    },
    "pumpkin_seeds": {
      "name": "Pumpkin Seeds",
      "tone": "#888888"
    },
    "purple_banner": {
      "name": "Purple Banner",
      "tone": "#888888"
    },
    "purple_bed": {
      "name": "Purple Bed",
      "tone": "#888888"
    },
    "purple_bundle": {
      "name": "Purple Bundle",
      "tone": "#888888"
    },
    "purple_candle": {
      "name": "Purple Candle",
      "tone": "#888888"
    },
    "purple_carpet": {
      "name": "Purple Carpet",
      "tone": "#888888"
    },
    "purple_concrete_powder": {
      "name": "Purple Concrete Powder",
      "tone": "#888888"
    },
    "purple_dye": {
      "name": "Purple Dye",
      "tone": "#888888"
    },
    "purple_harness": {
      "name": "Purple Harness",
      "tone": "#888888"
    },
    "purple_shulker_box": {
      "name": "Purple Shulker Box",
      "tone": "#888888"
    },
    "purple_stained_glass": {
      "name": "Purple Stained Glass",
      "tone": "#888888"
    },
    "purple_stained_glass_pane": {
      "name": "Purple Stained Glass Pane",
      "tone": "#888888"
    },
    "purple_terracotta": {
      "name": "Purple Terracotta",
      "tone": "#888888"
    },
    "purple_wool": {
      "name": "Purple Wool",
      "tone": "#888888"
    },
    "purpur_block": {
      "name": "Purpur Block",
      "tone": "#888888"
    },
    "purpur_pillar": {
      "name": "Purpur Pillar",
      "tone": "#888888"
    },
    "purpur_slab": {
      "name": "Purpur Slab",
      "tone": "#888888"
    },
    "purpur_stairs": {
      "name": "Purpur Stairs",
      "tone": "#888888"
    },
    "quartz": {
      "name": "Nether Quartz",
      "tone": "#888888"
    },
    "quartz_block": {
      "name": "Block of Quartz",
      "tone": "#888888"
    },
    "quartz_bricks": {
      "name": "Quartz Bricks",
      "tone": "#888888"
    },
    "quartz_pillar": {
      "name": "Quartz Pillar",
      "tone": "#888888"
    },
    "quartz_slab": {
      "name": "Quartz Slab",
      "tone": "#888888"
    },
    "quartz_stairs": {
      "name": "Quartz Stairs",
      "tone": "#888888"
    },
    "rabbit_hide": {
      "name": "Rabbit Hide",
      "tone": "#888888"
    },
    "rabbit_stew": {
      "name": "Rabbit Stew",
      "tone": "#888888"
    },
    "rail": {
      "name": "Rail",
      "tone": "#888888"
    },
    "raw_copper": {
      "name": "Raw Copper",
      "tone": "#888888"
    },
    "raw_copper_block": {
      "name": "Block of Raw Copper",
      "tone": "#888888"
    },
    "raw_gold": {
      "name": "Raw Gold",
      "tone": "#888888"
    },
    "raw_gold_block": {
      "name": "Block of Raw Gold",
      "tone": "#888888"
    },
    "raw_iron": {
      "name": "Raw Iron",
      "tone": "#888888"
    },
    "raw_iron_block": {
      "name": "Block of Raw Iron",
      "tone": "#888888"
    },
    "recovery_compass": {
      "name": "Recovery Compass",
      "tone": "#888888"
    },
    "red_banner": {
      "name": "Red Banner",
      "tone": "#888888"
    },
    "red_bed": {
      "name": "Red Bed",
      "tone": "#888888"
    },
    "red_bundle": {
      "name": "Red Bundle",
      "tone": "#888888"
    },
    "red_candle": {
      "name": "Red Candle",
      "tone": "#888888"
    },
    "red_carpet": {
      "name": "Red Carpet",
      "tone": "#888888"
    },
    "red_concrete_powder": {
      "name": "Red Concrete Powder",
      "tone": "#888888"
    },
    "red_dye": {
      "name": "Red Dye",
      "tone": "#888888"
    },
    "red_harness": {
      "name": "Red Harness",
      "tone": "#888888"
    },
    "red_mushroom": {
      "name": "Red Mushroom",
      "tone": "#888888"
    },
    "red_nether_brick_slab": {
      "name": "Red Nether Brick Slab",
      "tone": "#888888"
    },
    "red_nether_brick_stairs": {
      "name": "Red Nether Brick Stairs",
      "tone": "#888888"
    },
    "red_nether_brick_wall": {
      "name": "Red Nether Brick Wall",
      "tone": "#888888"
    },
    "red_nether_bricks": {
      "name": "Red Nether Bricks",
      "tone": "#888888"
    },
    "red_sand": {
      "name": "Red Sand",
      "tone": "#888888"
    },
    "red_sandstone": {
      "name": "Red Sandstone",
      "tone": "#888888"
    },
    "red_sandstone_slab": {
      "name": "Red Sandstone Slab",
      "tone": "#888888"
    },
    "red_sandstone_stairs": {
      "name": "Red Sandstone Stairs",
      "tone": "#888888"
    },
    "red_sandstone_wall": {
      "name": "Red Sandstone Wall",
      "tone": "#888888"
    },
    "red_shulker_box": {
      "name": "Red Shulker Box",
      "tone": "#888888"
    },
    "red_stained_glass": {
      "name": "Red Stained Glass",
      "tone": "#888888"
    },
    "red_stained_glass_pane": {
      "name": "Red Stained Glass Pane",
      "tone": "#888888"
    },
    "red_terracotta": {
      "name": "Red Terracotta",
      "tone": "#888888"
    },
    "red_wool": {
      "name": "Red Wool",
      "tone": "#888888"
    },
    "redstone": {
      "name": "Redstone Dust",
      "tone": "#888888"
    },
    "redstone_block": {
      "name": "Block of Redstone",
      "tone": "#888888"
    },
    "redstone_lamp": {
      "name": "Redstone Lamp",
      "tone": "#888888"
    },
    "redstone_torch": {
      "name": "Redstone Torch",
      "tone": "#888888"
    },
    "repeater": {
      "name": "Redstone Repeater",
      "tone": "#888888"
    },
    "resin_block": {
      "name": "Block of Resin",
      "tone": "#888888"
    },
    "resin_brick": {
      "name": "Resin Brick",
      "tone": "#888888"
    },
    "resin_brick_slab": {
      "name": "Resin Brick Slab",
      "tone": "#888888"
    },
    "resin_brick_stairs": {
      "name": "Resin Brick Stairs",
      "tone": "#888888"
    },
    "resin_brick_wall": {
      "name": "Resin Brick Wall",
      "tone": "#888888"
    },
    "resin_bricks": {
      "name": "Resin Bricks",
      "tone": "#888888"
    },
    "resin_clump": {
      "name": "Resin Clump",
      "tone": "#888888"
    },
    "respawn_anchor": {
      "name": "Respawn Anchor",
      "tone": "#888888"
    },
    "saddle": {
      "name": "Saddle",
      "tone": "#888888"
    },
    "sand": {
      "name": "Sand",
      "tone": "#888888"
    },
    "sandstone": {
      "name": "Sandstone",
      "tone": "#888888"
    },
    "sandstone_slab": {
      "name": "Sandstone Slab",
      "tone": "#888888"
    },
    "sandstone_stairs": {
      "name": "Sandstone Stairs",
      "tone": "#888888"
    },
    "sandstone_wall": {
      "name": "Sandstone Wall",
      "tone": "#888888"
    },
    "scaffolding": {
      "name": "Scaffolding",
      "tone": "#888888"
    },
    "sculk_sensor": {
      "name": "Sculk Sensor",
      "tone": "#888888"
    },
    "sea_lantern": {
      "name": "Sea Lantern",
      "tone": "#888888"
    },
    "shears": {
      "name": "Shears",
      "tone": "#888888"
    },
    "shield": {
      "name": "Shield",
      "tone": "#888888"
    },
    "shulker_box": {
      "name": "Shulker Box",
      "tone": "#888888"
    },
    "shulker_shell": {
      "name": "Shulker Shell",
      "tone": "#888888"
    },
    "skull_banner_pattern": {
      "name": "Banner Pattern",
      "tone": "#888888"
    },
    "slime_ball": {
      "name": "Slimeball",
      "tone": "#888888"
    },
    "slime_block": {
      "name": "Slime Block",
      "tone": "#888888"
    },
    "smithing_table": {
      "name": "Smithing Table",
      "tone": "#888888"
    },
    "smoker": {
      "name": "Smoker",
      "tone": "#888888"
    },
    "smooth_quartz": {
      "name": "Smooth Quartz Block",
      "tone": "#888888"
    },
    "smooth_quartz_slab": {
      "name": "Smooth Quartz Slab",
      "tone": "#888888"
    },
    "smooth_quartz_stairs": {
      "name": "Smooth Quartz Stairs",
      "tone": "#888888"
    },
    "smooth_red_sandstone": {
      "name": "Smooth Red Sandstone",
      "tone": "#888888"
    },
    "smooth_red_sandstone_slab": {
      "name": "Smooth Red Sandstone Slab",
      "tone": "#888888"
    },
    "smooth_red_sandstone_stairs": {
      "name": "Smooth Red Sandstone Stairs",
      "tone": "#888888"
    },
    "smooth_sandstone": {
      "name": "Smooth Sandstone",
      "tone": "#888888"
    },
    "smooth_sandstone_slab": {
      "name": "Smooth Sandstone Slab",
      "tone": "#888888"
    },
    "smooth_sandstone_stairs": {
      "name": "Smooth Sandstone Stairs",
      "tone": "#888888"
    },
    "smooth_stone": {
      "name": "Smooth Stone",
      "tone": "#888888"
    },
    "smooth_stone_slab": {
      "name": "Smooth Stone Slab",
      "tone": "#888888"
    },
    "snow": {
      "name": "Snow",
      "tone": "#888888"
    },
    "snow_block": {
      "name": "Snow Block",
      "tone": "#888888"
    },
    "snowball": {
      "name": "Snowball",
      "tone": "#888888"
    },
    "soul_campfire": {
      "name": "Soul Campfire",
      "tone": "#888888"
    },
    "soul_lantern": {
      "name": "Soul Lantern",
      "tone": "#888888"
    },
    "soul_sand": {
      "name": "Soul Sand",
      "tone": "#888888"
    },
    "soul_torch": {
      "name": "Soul Torch",
      "tone": "#888888"
    },
    "spectral_arrow": {
      "name": "Spectral Arrow",
      "tone": "#888888"
    },
    "spider_eye": {
      "name": "Spider Eye",
      "tone": "#888888"
    },
    "spruce_boat": {
      "name": "Spruce Boat",
      "tone": "#888888"
    },
    "spruce_button": {
      "name": "Spruce Button",
      "tone": "#888888"
    },
    "spruce_chest_boat": {
      "name": "Spruce Boat with Chest",
      "tone": "#888888"
    },
    "spruce_door": {
      "name": "Spruce Door",
      "tone": "#888888"
    },
    "spruce_fence": {
      "name": "Spruce Fence",
      "tone": "#888888"
    },
    "spruce_fence_gate": {
      "name": "Spruce Fence Gate",
      "tone": "#888888"
    },
    "spruce_hanging_sign": {
      "name": "Spruce Hanging Sign",
      "tone": "#888888"
    },
    "spruce_log": {
      "name": "Spruce Log",
      "tone": "#888888"
    },
    "spruce_planks": {
      "name": "Spruce Planks",
      "tone": "#888888"
    },
    "spruce_pressure_plate": {
      "name": "Spruce Pressure Plate",
      "tone": "#888888"
    },
    "spruce_shelf": {
      "name": "Spruce Shelf",
      "tone": "#888888"
    },
    "spruce_sign": {
      "name": "Spruce Sign",
      "tone": "#888888"
    },
    "spruce_slab": {
      "name": "Spruce Slab",
      "tone": "#888888"
    },
    "spruce_stairs": {
      "name": "Spruce Stairs",
      "tone": "#888888"
    },
    "spruce_trapdoor": {
      "name": "Spruce Trapdoor",
      "tone": "#888888"
    },
    "spruce_wood": {
      "name": "Spruce Wood",
      "tone": "#888888"
    },
    "spyglass": {
      "name": "Spyglass",
      "tone": "#888888"
    },
    "stick": {
      "name": "Stick",
      "tone": "#888888"
    },
    "sticky_piston": {
      "name": "Sticky Piston",
      "tone": "#888888"
    },
    "stone": {
      "name": "Stone",
      "tone": "#888888"
    },
    "stone_axe": {
      "name": "Stone Axe",
      "tone": "#888888"
    },
    "stone_brick_slab": {
      "name": "Stone Brick Slab",
      "tone": "#888888"
    },
    "stone_brick_stairs": {
      "name": "Stone Brick Stairs",
      "tone": "#888888"
    },
    "stone_brick_wall": {
      "name": "Stone Brick Wall",
      "tone": "#888888"
    },
    "stone_bricks": {
      "name": "Stone Bricks",
      "tone": "#888888"
    },
    "stone_button": {
      "name": "Stone Button",
      "tone": "#888888"
    },
    "stone_hoe": {
      "name": "Stone Hoe",
      "tone": "#888888"
    },
    "stone_pickaxe": {
      "name": "Stone Pickaxe",
      "tone": "#888888"
    },
    "stone_pressure_plate": {
      "name": "Stone Pressure Plate",
      "tone": "#888888"
    },
    "stone_shovel": {
      "name": "Stone Shovel",
      "tone": "#888888"
    },
    "stone_slab": {
      "name": "Stone Slab",
      "tone": "#888888"
    },
    "stone_spear": {
      "name": "Stone Spear",
      "tone": "#888888"
    },
    "stone_stairs": {
      "name": "Stone Stairs",
      "tone": "#888888"
    },
    "stone_sword": {
      "name": "Stone Sword",
      "tone": "#888888"
    },
    "stonecutter": {
      "name": "Stonecutter",
      "tone": "#888888"
    },
    "string": {
      "name": "String",
      "tone": "#888888"
    },
    "stripped_acacia_log": {
      "name": "Stripped Acacia Log",
      "tone": "#888888"
    },
    "stripped_acacia_wood": {
      "name": "Stripped Acacia Wood",
      "tone": "#888888"
    },
    "stripped_bamboo_block": {
      "name": "Block of Stripped Bamboo",
      "tone": "#888888"
    },
    "stripped_birch_log": {
      "name": "Stripped Birch Log",
      "tone": "#888888"
    },
    "stripped_birch_wood": {
      "name": "Stripped Birch Wood",
      "tone": "#888888"
    },
    "stripped_cherry_log": {
      "name": "Stripped Cherry Log",
      "tone": "#888888"
    },
    "stripped_cherry_wood": {
      "name": "Stripped Cherry Wood",
      "tone": "#888888"
    },
    "stripped_crimson_hyphae": {
      "name": "Stripped Crimson Hyphae",
      "tone": "#888888"
    },
    "stripped_crimson_stem": {
      "name": "Stripped Crimson Stem",
      "tone": "#888888"
    },
    "stripped_dark_oak_log": {
      "name": "Stripped Dark Oak Log",
      "tone": "#888888"
    },
    "stripped_dark_oak_wood": {
      "name": "Stripped Dark Oak Wood",
      "tone": "#888888"
    },
    "stripped_jungle_log": {
      "name": "Stripped Jungle Log",
      "tone": "#888888"
    },
    "stripped_jungle_wood": {
      "name": "Stripped Jungle Wood",
      "tone": "#888888"
    },
    "stripped_mangrove_log": {
      "name": "Stripped Mangrove Log",
      "tone": "#888888"
    },
    "stripped_mangrove_wood": {
      "name": "Stripped Mangrove Wood",
      "tone": "#888888"
    },
    "stripped_oak_log": {
      "name": "Stripped Oak Log",
      "tone": "#888888"
    },
    "stripped_oak_wood": {
      "name": "Stripped Oak Wood",
      "tone": "#888888"
    },
    "stripped_pale_oak_log": {
      "name": "Stripped Pale Oak Log",
      "tone": "#888888"
    },
    "stripped_pale_oak_wood": {
      "name": "Stripped Pale Oak Wood",
      "tone": "#888888"
    },
    "stripped_spruce_log": {
      "name": "Stripped Spruce Log",
      "tone": "#888888"
    },
    "stripped_spruce_wood": {
      "name": "Stripped Spruce Wood",
      "tone": "#888888"
    },
    "stripped_warped_hyphae": {
      "name": "Stripped Warped Hyphae",
      "tone": "#888888"
    },
    "stripped_warped_stem": {
      "name": "Stripped Warped Stem",
      "tone": "#888888"
    },
    "sugar": {
      "name": "Sugar",
      "tone": "#888888"
    },
    "sugar_cane": {
      "name": "Sugar Cane",
      "tone": "#888888"
    },
    "suspicious_stew": {
      "name": "Suspicious Stew",
      "tone": "#888888"
    },
    "target": {
      "name": "Target",
      "tone": "#888888"
    },
    "terracotta": {
      "name": "Terracotta",
      "tone": "#888888"
    },
    "tinted_glass": {
      "name": "Tinted Glass",
      "tone": "#888888"
    },
    "tipped_arrow": {
      "name": "Tipped Arrow",
      "tone": "#888888"
    },
    "tnt": {
      "name": "TNT",
      "tone": "#888888"
    },
    "tnt_minecart": {
      "name": "Minecart with TNT",
      "tone": "#888888"
    },
    "torch": {
      "name": "Torch",
      "tone": "#888888"
    },
    "trapped_chest": {
      "name": "Trapped Chest",
      "tone": "#888888"
    },
    "tripwire_hook": {
      "name": "Tripwire Hook",
      "tone": "#888888"
    },
    "tuff": {
      "name": "Tuff",
      "tone": "#888888"
    },
    "tuff_brick_slab": {
      "name": "Tuff Brick Slab",
      "tone": "#888888"
    },
    "tuff_brick_stairs": {
      "name": "Tuff Brick Stairs",
      "tone": "#888888"
    },
    "tuff_brick_wall": {
      "name": "Tuff Brick Wall",
      "tone": "#888888"
    },
    "tuff_bricks": {
      "name": "Tuff Bricks",
      "tone": "#888888"
    },
    "tuff_slab": {
      "name": "Tuff Slab",
      "tone": "#888888"
    },
    "tuff_stairs": {
      "name": "Tuff Stairs",
      "tone": "#888888"
    },
    "tuff_wall": {
      "name": "Tuff Wall",
      "tone": "#888888"
    },
    "turtle_helmet": {
      "name": "Turtle Shell",
      "tone": "#888888"
    },
    "turtle_scute": {
      "name": "Turtle Scute",
      "tone": "#888888"
    },
    "vine": {
      "name": "Vines",
      "tone": "#888888"
    },
    "warped_button": {
      "name": "Warped Button",
      "tone": "#888888"
    },
    "warped_door": {
      "name": "Warped Door",
      "tone": "#888888"
    },
    "warped_fence": {
      "name": "Warped Fence",
      "tone": "#888888"
    },
    "warped_fence_gate": {
      "name": "Warped Fence Gate",
      "tone": "#888888"
    },
    "warped_fungus": {
      "name": "Warped Fungus",
      "tone": "#888888"
    },
    "warped_fungus_on_a_stick": {
      "name": "Warped Fungus on a Stick",
      "tone": "#888888"
    },
    "warped_hanging_sign": {
      "name": "Warped Hanging Sign",
      "tone": "#888888"
    },
    "warped_hyphae": {
      "name": "Warped Hyphae",
      "tone": "#888888"
    },
    "warped_planks": {
      "name": "Warped Planks",
      "tone": "#888888"
    },
    "warped_pressure_plate": {
      "name": "Warped Pressure Plate",
      "tone": "#888888"
    },
    "warped_shelf": {
      "name": "Warped Shelf",
      "tone": "#888888"
    },
    "warped_sign": {
      "name": "Warped Sign",
      "tone": "#888888"
    },
    "warped_slab": {
      "name": "Warped Slab",
      "tone": "#888888"
    },
    "warped_stairs": {
      "name": "Warped Stairs",
      "tone": "#888888"
    },
    "warped_stem": {
      "name": "Warped Stem",
      "tone": "#888888"
    },
    "warped_trapdoor": {
      "name": "Warped Trapdoor",
      "tone": "#888888"
    },
    "waxed_chiseled_copper": {
      "name": "Waxed Chiseled Copper",
      "tone": "#888888"
    },
    "waxed_copper_bars": {
      "name": "Waxed Copper Bars",
      "tone": "#888888"
    },
    "waxed_copper_block": {
      "name": "Waxed Block of Copper",
      "tone": "#888888"
    },
    "waxed_copper_bulb": {
      "name": "Waxed Copper Bulb",
      "tone": "#888888"
    },
    "waxed_copper_chain": {
      "name": "Waxed Copper Chain",
      "tone": "#888888"
    },
    "waxed_copper_chest": {
      "name": "Waxed Copper Chest",
      "tone": "#888888"
    },
    "waxed_copper_door": {
      "name": "Waxed Copper Door",
      "tone": "#888888"
    },
    "waxed_copper_golem_statue": {
      "name": "Waxed Copper Golem Statue",
      "tone": "#888888"
    },
    "waxed_copper_grate": {
      "name": "Waxed Copper Grate",
      "tone": "#888888"
    },
    "waxed_copper_lantern": {
      "name": "Waxed Copper Lantern",
      "tone": "#888888"
    },
    "waxed_copper_trapdoor": {
      "name": "Waxed Copper Trapdoor",
      "tone": "#888888"
    },
    "waxed_cut_copper": {
      "name": "Waxed Cut Copper",
      "tone": "#888888"
    },
    "waxed_cut_copper_slab": {
      "name": "Waxed Cut Copper Slab",
      "tone": "#888888"
    },
    "waxed_cut_copper_stairs": {
      "name": "Waxed Cut Copper Stairs",
      "tone": "#888888"
    },
    "waxed_exposed_chiseled_copper": {
      "name": "Waxed Exposed Chiseled Copper",
      "tone": "#888888"
    },
    "waxed_exposed_copper": {
      "name": "Waxed Exposed Copper",
      "tone": "#888888"
    },
    "waxed_exposed_copper_bars": {
      "name": "Waxed Exposed Copper Bars",
      "tone": "#888888"
    },
    "waxed_exposed_copper_bulb": {
      "name": "Waxed Exposed Copper Bulb",
      "tone": "#888888"
    },
    "waxed_exposed_copper_chain": {
      "name": "Waxed Exposed Copper Chain",
      "tone": "#888888"
    },
    "waxed_exposed_copper_chest": {
      "name": "Waxed Exposed Copper Chest",
      "tone": "#888888"
    },
    "waxed_exposed_copper_door": {
      "name": "Waxed Exposed Copper Door",
      "tone": "#888888"
    },
    "waxed_exposed_copper_golem_statue": {
      "name": "Waxed Exposed Copper Golem Statue",
      "tone": "#888888"
    },
    "waxed_exposed_copper_grate": {
      "name": "Waxed Exposed Copper Grate",
      "tone": "#888888"
    },
    "waxed_exposed_copper_lantern": {
      "name": "Waxed Exposed Copper Lantern",
      "tone": "#888888"
    },
    "waxed_exposed_copper_trapdoor": {
      "name": "Waxed Exposed Copper Trapdoor",
      "tone": "#888888"
    },
    "waxed_exposed_cut_copper": {
      "name": "Waxed Exposed Cut Copper",
      "tone": "#888888"
    },
    "waxed_exposed_cut_copper_slab": {
      "name": "Waxed Exposed Cut Copper Slab",
      "tone": "#888888"
    },
    "waxed_exposed_cut_copper_stairs": {
      "name": "Waxed Exposed Cut Copper Stairs",
      "tone": "#888888"
    },
    "waxed_exposed_lightning_rod": {
      "name": "Waxed Exposed Lightning Rod",
      "tone": "#888888"
    },
    "waxed_lightning_rod": {
      "name": "Waxed Lightning Rod",
      "tone": "#888888"
    },
    "waxed_oxidized_chiseled_copper": {
      "name": "Waxed Oxidized Chiseled Copper",
      "tone": "#888888"
    },
    "waxed_oxidized_copper": {
      "name": "Waxed Oxidized Copper",
      "tone": "#888888"
    },
    "waxed_oxidized_copper_bars": {
      "name": "Waxed Oxidized Copper Bars",
      "tone": "#888888"
    },
    "waxed_oxidized_copper_bulb": {
      "name": "Waxed Oxidized Copper Bulb",
      "tone": "#888888"
    },
    "waxed_oxidized_copper_chain": {
      "name": "Waxed Oxidized Copper Chain",
      "tone": "#888888"
    },
    "waxed_oxidized_copper_chest": {
      "name": "Waxed Oxidized Copper Chest",
      "tone": "#888888"
    },
    "waxed_oxidized_copper_door": {
      "name": "Waxed Oxidized Copper Door",
      "tone": "#888888"
    },
    "waxed_oxidized_copper_golem_statue": {
      "name": "Waxed Oxidized Copper Golem Statue",
      "tone": "#888888"
    },
    "waxed_oxidized_copper_grate": {
      "name": "Waxed Oxidized Copper Grate",
      "tone": "#888888"
    },
    "waxed_oxidized_copper_lantern": {
      "name": "Waxed Oxidized Copper Lantern",
      "tone": "#888888"
    },
    "waxed_oxidized_copper_trapdoor": {
      "name": "Waxed Oxidized Copper Trapdoor",
      "tone": "#888888"
    },
    "waxed_oxidized_cut_copper": {
      "name": "Waxed Oxidized Cut Copper",
      "tone": "#888888"
    },
    "waxed_oxidized_cut_copper_slab": {
      "name": "Waxed Oxidized Cut Copper Slab",
      "tone": "#888888"
    },
    "waxed_oxidized_cut_copper_stairs": {
      "name": "Waxed Oxidized Cut Copper Stairs",
      "tone": "#888888"
    },
    "waxed_oxidized_lightning_rod": {
      "name": "Waxed Oxidized Lightning Rod",
      "tone": "#888888"
    },
    "waxed_weathered_chiseled_copper": {
      "name": "Waxed Weathered Chiseled Copper",
      "tone": "#888888"
    },
    "waxed_weathered_copper": {
      "name": "Waxed Weathered Copper",
      "tone": "#888888"
    },
    "waxed_weathered_copper_bars": {
      "name": "Waxed Weathered Copper Bars",
      "tone": "#888888"
    },
    "waxed_weathered_copper_bulb": {
      "name": "Waxed Weathered Copper Bulb",
      "tone": "#888888"
    },
    "waxed_weathered_copper_chain": {
      "name": "Waxed Weathered Copper Chain",
      "tone": "#888888"
    },
    "waxed_weathered_copper_chest": {
      "name": "Waxed Weathered Copper Chest",
      "tone": "#888888"
    },
    "waxed_weathered_copper_door": {
      "name": "Waxed Weathered Copper Door",
      "tone": "#888888"
    },
    "waxed_weathered_copper_golem_statue": {
      "name": "Waxed Weathered Copper Golem Statue",
      "tone": "#888888"
    },
    "waxed_weathered_copper_grate": {
      "name": "Waxed Weathered Copper Grate",
      "tone": "#888888"
    },
    "waxed_weathered_copper_lantern": {
      "name": "Waxed Weathered Copper Lantern",
      "tone": "#888888"
    },
    "waxed_weathered_copper_trapdoor": {
      "name": "Waxed Weathered Copper Trapdoor",
      "tone": "#888888"
    },
    "waxed_weathered_cut_copper": {
      "name": "Waxed Weathered Cut Copper",
      "tone": "#888888"
    },
    "waxed_weathered_cut_copper_slab": {
      "name": "Waxed Weathered Cut Copper Slab",
      "tone": "#888888"
    },
    "waxed_weathered_cut_copper_stairs": {
      "name": "Waxed Weathered Cut Copper Stairs",
      "tone": "#888888"
    },
    "waxed_weathered_lightning_rod": {
      "name": "Waxed Weathered Lightning Rod",
      "tone": "#888888"
    },
    "weathered_chiseled_copper": {
      "name": "Weathered Chiseled Copper",
      "tone": "#888888"
    },
    "weathered_copper": {
      "name": "Weathered Copper",
      "tone": "#888888"
    },
    "weathered_copper_bars": {
      "name": "Weathered Copper Bars",
      "tone": "#888888"
    },
    "weathered_copper_bulb": {
      "name": "Weathered Copper Bulb",
      "tone": "#888888"
    },
    "weathered_copper_chain": {
      "name": "Weathered Copper Chain",
      "tone": "#888888"
    },
    "weathered_copper_chest": {
      "name": "Weathered Copper Chest",
      "tone": "#888888"
    },
    "weathered_copper_door": {
      "name": "Weathered Copper Door",
      "tone": "#888888"
    },
    "weathered_copper_golem_statue": {
      "name": "Weathered Copper Golem Statue",
      "tone": "#888888"
    },
    "weathered_copper_grate": {
      "name": "Weathered Copper Grate",
      "tone": "#888888"
    },
    "weathered_copper_lantern": {
      "name": "Weathered Copper Lantern",
      "tone": "#888888"
    },
    "weathered_copper_trapdoor": {
      "name": "Weathered Copper Trapdoor",
      "tone": "#888888"
    },
    "weathered_cut_copper": {
      "name": "Weathered Cut Copper",
      "tone": "#888888"
    },
    "weathered_cut_copper_slab": {
      "name": "Weathered Cut Copper Slab",
      "tone": "#888888"
    },
    "weathered_cut_copper_stairs": {
      "name": "Weathered Cut Copper Stairs",
      "tone": "#888888"
    },
    "weathered_lightning_rod": {
      "name": "Weathered Lightning Rod",
      "tone": "#888888"
    },
    "wheat": {
      "name": "Wheat",
      "tone": "#888888"
    },
    "white_banner": {
      "name": "White Banner",
      "tone": "#888888"
    },
    "white_bed": {
      "name": "White Bed",
      "tone": "#888888"
    },
    "white_bundle": {
      "name": "White Bundle",
      "tone": "#888888"
    },
    "white_candle": {
      "name": "White Candle",
      "tone": "#888888"
    },
    "white_carpet": {
      "name": "White Carpet",
      "tone": "#888888"
    },
    "white_concrete_powder": {
      "name": "White Concrete Powder",
      "tone": "#888888"
    },
    "white_dye": {
      "name": "White Dye",
      "tone": "#888888"
    },
    "white_harness": {
      "name": "White Harness",
      "tone": "#888888"
    },
    "white_shulker_box": {
      "name": "White Shulker Box",
      "tone": "#888888"
    },
    "white_stained_glass": {
      "name": "White Stained Glass",
      "tone": "#888888"
    },
    "white_stained_glass_pane": {
      "name": "White Stained Glass Pane",
      "tone": "#888888"
    },
    "white_terracotta": {
      "name": "White Terracotta",
      "tone": "#888888"
    },
    "white_wool": {
      "name": "White Wool",
      "tone": "#888888"
    },
    "wind_charge": {
      "name": "Wind Charge",
      "tone": "#888888"
    },
    "wither_skeleton_skull": {
      "name": "Wither Skeleton Skull",
      "tone": "#888888"
    },
    "wolf_armor": {
      "name": "Wolf Armor",
      "tone": "#888888"
    },
    "wooden_axe": {
      "name": "Wooden Axe",
      "tone": "#888888"
    },
    "wooden_hoe": {
      "name": "Wooden Hoe",
      "tone": "#888888"
    },
    "wooden_pickaxe": {
      "name": "Wooden Pickaxe",
      "tone": "#888888"
    },
    "wooden_shovel": {
      "name": "Wooden Shovel",
      "tone": "#888888"
    },
    "wooden_spear": {
      "name": "Wooden Spear",
      "tone": "#888888"
    },
    "wooden_sword": {
      "name": "Wooden Sword",
      "tone": "#888888"
    },
    "writable_book": {
      "name": "Book and Quill",
      "tone": "#888888"
    },
    "yellow_banner": {
      "name": "Yellow Banner",
      "tone": "#888888"
    },
    "yellow_bed": {
      "name": "Yellow Bed",
      "tone": "#888888"
    },
    "yellow_bundle": {
      "name": "Yellow Bundle",
      "tone": "#888888"
    },
    "yellow_candle": {
      "name": "Yellow Candle",
      "tone": "#888888"
    },
    "yellow_carpet": {
      "name": "Yellow Carpet",
      "tone": "#888888"
    },
    "yellow_concrete_powder": {
      "name": "Yellow Concrete Powder",
      "tone": "#888888"
    },
    "yellow_dye": {
      "name": "Yellow Dye",
      "tone": "#888888"
    },
    "yellow_harness": {
      "name": "Yellow Harness",
      "tone": "#888888"
    },
    "yellow_shulker_box": {
      "name": "Yellow Shulker Box",
      "tone": "#888888"
    },
    "yellow_stained_glass": {
      "name": "Yellow Stained Glass",
      "tone": "#888888"
    },
    "yellow_stained_glass_pane": {
      "name": "Yellow Stained Glass Pane",
      "tone": "#888888"
    },
    "yellow_terracotta": {
      "name": "Yellow Terracotta",
      "tone": "#888888"
    },
    "yellow_wool": {
      "name": "Yellow Wool",
      "tone": "#888888"
    }
  },
  "recipes": [
    {
      "id": "acacia_boat",
      "name": "Acacia Boat",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "acacia_boat",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "acacia_planks",
        null,
        "acacia_planks",
        "acacia_planks",
        "acacia_planks",
        "acacia_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_chest_boat",
      "name": "Acacia Boat with Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "acacia_chest_boat",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "chest",
        "acacia_boat"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_button",
      "name": "Acacia Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "acacia_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "acacia_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_door",
      "name": "Acacia Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "acacia_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "acacia_planks",
        "acacia_planks",
        "acacia_planks",
        "acacia_planks",
        "acacia_planks",
        "acacia_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_fence",
      "name": "Acacia Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "acacia_fence",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "acacia_planks",
        "stick",
        "acacia_planks",
        "acacia_planks",
        "stick",
        "acacia_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_fence_gate",
      "name": "Acacia Fence Gate",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "acacia_fence_gate",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "acacia_planks",
        "stick",
        "stick",
        "acacia_planks",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_hanging_sign",
      "name": "Acacia Hanging Sign",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "acacia_hanging_sign",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_chain",
        null,
        "iron_chain",
        "stripped_acacia_log",
        "stripped_acacia_log",
        "stripped_acacia_log",
        "stripped_acacia_log",
        "stripped_acacia_log",
        "stripped_acacia_log"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_planks",
      "name": "Acacia Planks",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "acacia_planks",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "acacia_log"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_pressure_plate",
      "name": "Acacia Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "acacia_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "acacia_planks",
        "acacia_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_shelf",
      "name": "Acacia Shelf",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "acacia_shelf",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stripped_acacia_log",
        "stripped_acacia_log",
        "stripped_acacia_log",
        null,
        null,
        null,
        "stripped_acacia_log",
        "stripped_acacia_log",
        "stripped_acacia_log"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_sign",
      "name": "Acacia Sign",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "acacia_sign",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "acacia_planks",
        "acacia_planks",
        "acacia_planks",
        "acacia_planks",
        "acacia_planks",
        "acacia_planks",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_slab",
      "name": "Acacia Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "acacia_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "acacia_planks",
        "acacia_planks",
        "acacia_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_stairs",
      "name": "Acacia Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "acacia_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "acacia_planks",
        null,
        null,
        "acacia_planks",
        "acacia_planks",
        null,
        "acacia_planks",
        "acacia_planks",
        "acacia_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_trapdoor",
      "name": "Acacia Trapdoor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "acacia_trapdoor",
      "outputQuantity": 2,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "acacia_planks",
        "acacia_planks",
        "acacia_planks",
        "acacia_planks",
        "acacia_planks",
        "acacia_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "acacia_wood",
      "name": "Acacia Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "acacia_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "acacia_log",
        "acacia_log",
        "acacia_log",
        "acacia_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "activator_rail",
      "name": "Activator Rail",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "activator_rail",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "stick",
        "iron_ingot",
        "iron_ingot",
        "redstone_torch",
        "iron_ingot",
        "iron_ingot",
        "stick",
        "iron_ingot"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "andesite",
      "name": "Andesite",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "andesite",
      "outputQuantity": 2,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "diorite",
        "cobblestone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "andesite_slab",
      "name": "Andesite Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "andesite_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "andesite",
        "andesite",
        "andesite"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "andesite_stairs",
      "name": "Andesite Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "andesite_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "andesite",
        null,
        null,
        "andesite",
        "andesite",
        null,
        "andesite",
        "andesite",
        "andesite"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "andesite_wall",
      "name": "Andesite Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "andesite_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "andesite",
        "andesite",
        "andesite",
        "andesite",
        "andesite",
        "andesite"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "anvil",
      "name": "Anvil",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "anvil",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_block",
        "iron_block",
        "iron_block",
        null,
        "iron_ingot",
        null,
        "iron_ingot",
        "iron_ingot",
        "iron_ingot"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "armor_stand",
      "name": "Armor Stand",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "armor_stand",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stick",
        "stick",
        "stick",
        null,
        "stick",
        null,
        "stick",
        "smooth_stone_slab",
        "stick"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "arrow",
      "name": "Arrow",
      "description": "3 ingredients using 3 unique materials.",
      "outputItemId": "arrow",
      "outputQuantity": 4,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "flint",
        "stick",
        "feather"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_button",
      "name": "Bamboo Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "bamboo_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "bamboo_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_door",
      "name": "Bamboo Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "bamboo_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_fence",
      "name": "Bamboo Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "bamboo_fence",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "bamboo_planks",
        "stick",
        "bamboo_planks",
        "bamboo_planks",
        "stick",
        "bamboo_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_fence_gate",
      "name": "Bamboo Fence Gate",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "bamboo_fence_gate",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "bamboo_planks",
        "stick",
        "stick",
        "bamboo_planks",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_hanging_sign",
      "name": "Bamboo Hanging Sign",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "bamboo_hanging_sign",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_chain",
        null,
        "iron_chain",
        "stripped_bamboo_block",
        "stripped_bamboo_block",
        "stripped_bamboo_block",
        "stripped_bamboo_block",
        "stripped_bamboo_block",
        "stripped_bamboo_block"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_mosaic",
      "name": "Bamboo Mosaic",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "bamboo_mosaic",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "bamboo_slab",
        "bamboo_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_mosaic_slab",
      "name": "Bamboo Mosaic Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "bamboo_mosaic_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "bamboo_mosaic",
        "bamboo_mosaic",
        "bamboo_mosaic"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_mosaic_stairs",
      "name": "Bamboo Mosaic Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "bamboo_mosaic_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "bamboo_mosaic",
        null,
        null,
        "bamboo_mosaic",
        "bamboo_mosaic",
        null,
        "bamboo_mosaic",
        "bamboo_mosaic",
        "bamboo_mosaic"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_planks",
      "name": "Bamboo Planks",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "bamboo_planks",
      "outputQuantity": 2,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "bamboo_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_pressure_plate",
      "name": "Bamboo Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "bamboo_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "bamboo_planks",
        "bamboo_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_raft",
      "name": "Bamboo Raft",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "bamboo_raft",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "bamboo_planks",
        null,
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_chest_raft",
      "name": "Bamboo Raft with Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "bamboo_chest_raft",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "chest",
        "bamboo_raft"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_shelf",
      "name": "Bamboo Shelf",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "bamboo_shelf",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stripped_bamboo_block",
        "stripped_bamboo_block",
        "stripped_bamboo_block",
        null,
        null,
        null,
        "stripped_bamboo_block",
        "stripped_bamboo_block",
        "stripped_bamboo_block"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_sign",
      "name": "Bamboo Sign",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "bamboo_sign",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_slab",
      "name": "Bamboo Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "bamboo_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_stairs",
      "name": "Bamboo Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "bamboo_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "bamboo_planks",
        null,
        null,
        "bamboo_planks",
        "bamboo_planks",
        null,
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_trapdoor",
      "name": "Bamboo Trapdoor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "bamboo_trapdoor",
      "outputQuantity": 2,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks",
        "bamboo_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "creeper_banner_pattern",
      "name": "Banner Pattern",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "creeper_banner_pattern",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "paper",
        "creeper_head"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "flower_banner_pattern",
      "name": "Banner Pattern",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "flower_banner_pattern",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "paper",
        "oxeye_daisy"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mojang_banner_pattern",
      "name": "Banner Pattern",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "mojang_banner_pattern",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "paper",
        "enchanted_golden_apple"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "skull_banner_pattern",
      "name": "Banner Pattern",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "skull_banner_pattern",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "paper",
        "wither_skeleton_skull"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "barrel",
      "name": "Barrel",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "barrel",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_slab",
        "oak_planks",
        "oak_planks",
        null,
        "oak_planks",
        "oak_planks",
        "oak_slab",
        "oak_planks"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "beacon",
      "name": "Beacon",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "beacon",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "nether_star",
        "glass",
        "obsidian",
        "obsidian",
        "obsidian"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "beehive",
      "name": "Beehive",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "beehive",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "honeycomb",
        "honeycomb",
        "honeycomb",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "beetroot_soup",
      "name": "Beetroot Soup",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "beetroot_soup",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "bowl",
        "beetroot",
        "beetroot",
        "beetroot",
        "beetroot",
        "beetroot",
        "beetroot"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_boat",
      "name": "Birch Boat",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "birch_boat",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "birch_planks",
        null,
        "birch_planks",
        "birch_planks",
        "birch_planks",
        "birch_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_chest_boat",
      "name": "Birch Boat with Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "birch_chest_boat",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "chest",
        "birch_boat"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_button",
      "name": "Birch Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "birch_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "birch_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_door",
      "name": "Birch Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "birch_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "birch_planks",
        "birch_planks",
        "birch_planks",
        "birch_planks",
        "birch_planks",
        "birch_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_fence",
      "name": "Birch Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "birch_fence",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "birch_planks",
        "stick",
        "birch_planks",
        "birch_planks",
        "stick",
        "birch_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_fence_gate",
      "name": "Birch Fence Gate",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "birch_fence_gate",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "birch_planks",
        "stick",
        "stick",
        "birch_planks",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_hanging_sign",
      "name": "Birch Hanging Sign",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "birch_hanging_sign",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_chain",
        null,
        "iron_chain",
        "stripped_birch_log",
        "stripped_birch_log",
        "stripped_birch_log",
        "stripped_birch_log",
        "stripped_birch_log",
        "stripped_birch_log"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_planks",
      "name": "Birch Planks",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "birch_planks",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "birch_log"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_pressure_plate",
      "name": "Birch Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "birch_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "birch_planks",
        "birch_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_shelf",
      "name": "Birch Shelf",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "birch_shelf",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stripped_birch_log",
        "stripped_birch_log",
        "stripped_birch_log",
        null,
        null,
        null,
        "stripped_birch_log",
        "stripped_birch_log",
        "stripped_birch_log"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_sign",
      "name": "Birch Sign",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "birch_sign",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "birch_planks",
        "birch_planks",
        "birch_planks",
        "birch_planks",
        "birch_planks",
        "birch_planks",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_slab",
      "name": "Birch Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "birch_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "birch_planks",
        "birch_planks",
        "birch_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_stairs",
      "name": "Birch Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "birch_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "birch_planks",
        null,
        null,
        "birch_planks",
        "birch_planks",
        null,
        "birch_planks",
        "birch_planks",
        "birch_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_trapdoor",
      "name": "Birch Trapdoor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "birch_trapdoor",
      "outputQuantity": 2,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "birch_planks",
        "birch_planks",
        "birch_planks",
        "birch_planks",
        "birch_planks",
        "birch_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "birch_wood",
      "name": "Birch Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "birch_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "birch_log",
        "birch_log",
        "birch_log",
        "birch_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "black_banner",
      "name": "Black Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "black_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "black_wool",
        "black_wool",
        "black_wool",
        "black_wool",
        "black_wool",
        "black_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_black_bed",
      "name": "Black Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "black_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "black_dye",
        "blue_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "black_bundle",
      "name": "Black Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "black_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "black_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "black_candle",
      "name": "Black Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "black_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "black_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "black_carpet",
      "name": "Black Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "black_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "black_wool",
        "black_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "black_concrete_powder",
      "name": "Black Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "black_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "black_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "black_dye",
      "name": "Black Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "black_dye",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "ink_sac"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_black_harness",
      "name": "Black Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "black_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "black_dye",
        "blue_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "black_shulker_box",
      "name": "Black Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "black_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "black_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "black_stained_glass",
      "name": "Black Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "black_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "black_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "black_stained_glass_pane",
      "name": "Black Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "black_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "black_stained_glass",
        "black_stained_glass",
        "black_stained_glass",
        "black_stained_glass",
        "black_stained_glass",
        "black_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "black_terracotta",
      "name": "Black Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "black_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "black_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_black_wool",
      "name": "Black Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "black_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "black_dye",
        "blue_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blackstone_slab",
      "name": "Blackstone Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "blackstone_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "blackstone",
        "blackstone",
        "blackstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blackstone_stairs",
      "name": "Blackstone Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "blackstone_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "blackstone",
        null,
        null,
        "blackstone",
        "blackstone",
        null,
        "blackstone",
        "blackstone",
        "blackstone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blackstone_wall",
      "name": "Blackstone Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "blackstone_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "blackstone",
        "blackstone",
        "blackstone",
        "blackstone",
        "blackstone",
        "blackstone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blast_furnace",
      "name": "Blast Furnace",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "blast_furnace",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "furnace",
        "iron_ingot",
        "smooth_stone",
        "smooth_stone",
        "smooth_stone"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blaze_powder",
      "name": "Blaze Powder",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "blaze_powder",
      "outputQuantity": 2,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "blaze_rod"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "amethyst_block",
      "name": "Block of Amethyst",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "amethyst_block",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "amethyst_shard",
        "amethyst_shard",
        "amethyst_shard",
        "amethyst_shard"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bamboo_block",
      "name": "Block of Bamboo",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "bamboo_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "bamboo",
        "bamboo",
        "bamboo",
        "bamboo",
        "bamboo",
        "bamboo",
        "bamboo",
        "bamboo",
        "bamboo"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "coal_block",
      "name": "Block of Coal",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "coal_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "coal",
        "coal",
        "coal",
        "coal",
        "coal",
        "coal",
        "coal",
        "coal",
        "coal"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_block",
      "name": "Block of Copper",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "copper_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diamond_block",
      "name": "Block of Diamond",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "diamond_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "diamond",
        "diamond",
        "diamond",
        "diamond",
        "diamond",
        "diamond",
        "diamond",
        "diamond",
        "diamond"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "emerald_block",
      "name": "Block of Emerald",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "emerald_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "emerald",
        "emerald",
        "emerald",
        "emerald",
        "emerald",
        "emerald",
        "emerald",
        "emerald",
        "emerald"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gold_block",
      "name": "Block of Gold",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "gold_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_block",
      "name": "Block of Iron",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "iron_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lapis_block",
      "name": "Block of Lapis Lazuli",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "lapis_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "lapis_lazuli",
        "lapis_lazuli",
        "lapis_lazuli",
        "lapis_lazuli",
        "lapis_lazuli",
        "lapis_lazuli",
        "lapis_lazuli",
        "lapis_lazuli",
        "lapis_lazuli"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "netherite_block",
      "name": "Block of Netherite",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "netherite_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "netherite_ingot",
        "netherite_ingot",
        "netherite_ingot",
        "netherite_ingot",
        "netherite_ingot",
        "netherite_ingot",
        "netherite_ingot",
        "netherite_ingot",
        "netherite_ingot"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "quartz_block",
      "name": "Block of Quartz",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "quartz_block",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "quartz",
        "quartz",
        "quartz",
        "quartz"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "raw_copper_block",
      "name": "Block of Raw Copper",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "raw_copper_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "raw_copper",
        "raw_copper",
        "raw_copper",
        "raw_copper",
        "raw_copper",
        "raw_copper",
        "raw_copper",
        "raw_copper",
        "raw_copper"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "raw_gold_block",
      "name": "Block of Raw Gold",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "raw_gold_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "raw_gold",
        "raw_gold",
        "raw_gold",
        "raw_gold",
        "raw_gold",
        "raw_gold",
        "raw_gold",
        "raw_gold",
        "raw_gold"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "raw_iron_block",
      "name": "Block of Raw Iron",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "raw_iron_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "raw_iron",
        "raw_iron",
        "raw_iron",
        "raw_iron",
        "raw_iron",
        "raw_iron",
        "raw_iron",
        "raw_iron",
        "raw_iron"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "redstone_block",
      "name": "Block of Redstone",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "redstone_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "redstone",
        "redstone",
        "redstone",
        "redstone",
        "redstone",
        "redstone",
        "redstone",
        "redstone",
        "redstone"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "resin_block",
      "name": "Block of Resin",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "resin_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "resin_clump",
        "resin_clump",
        "resin_clump",
        "resin_clump",
        "resin_clump",
        "resin_clump",
        "resin_clump",
        "resin_clump",
        "resin_clump"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blue_banner",
      "name": "Blue Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "blue_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "blue_wool",
        "blue_wool",
        "blue_wool",
        "blue_wool",
        "blue_wool",
        "blue_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_blue_bed",
      "name": "Blue Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "blue_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "blue_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blue_bundle",
      "name": "Blue Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "blue_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "blue_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blue_candle",
      "name": "Blue Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "blue_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "blue_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blue_carpet",
      "name": "Blue Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "blue_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "blue_wool",
        "blue_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blue_concrete_powder",
      "name": "Blue Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "blue_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "blue_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blue_dye",
      "name": "Blue Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "blue_dye",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "lapis_lazuli"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_blue_harness",
      "name": "Blue Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "blue_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "blue_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blue_ice",
      "name": "Blue Ice",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "blue_ice",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "packed_ice",
        "packed_ice",
        "packed_ice",
        "packed_ice",
        "packed_ice",
        "packed_ice",
        "packed_ice",
        "packed_ice",
        "packed_ice"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blue_shulker_box",
      "name": "Blue Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "blue_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "blue_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blue_stained_glass",
      "name": "Blue Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "blue_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "blue_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blue_stained_glass_pane",
      "name": "Blue Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "blue_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "blue_stained_glass",
        "blue_stained_glass",
        "blue_stained_glass",
        "blue_stained_glass",
        "blue_stained_glass",
        "blue_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "blue_terracotta",
      "name": "Blue Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "blue_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "blue_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_blue_wool",
      "name": "Blue Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "blue_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "blue_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bone_block",
      "name": "Bone Block",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "bone_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "bone_meal",
        "bone_meal",
        "bone_meal",
        "bone_meal",
        "bone_meal",
        "bone_meal",
        "bone_meal",
        "bone_meal",
        "bone_meal"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bone_meal",
      "name": "Bone Meal",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "bone_meal",
      "outputQuantity": 3,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "bone"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "book",
      "name": "Book",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "book",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": false,
      "grid": [
        "paper",
        "paper",
        "paper",
        "leather"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "writable_book",
      "name": "Book and Quill",
      "description": "3 ingredients using 3 unique materials.",
      "outputItemId": "writable_book",
      "outputQuantity": 1,
      "width": 3,
      "height": 1,
      "shaped": false,
      "grid": [
        "book",
        "ink_sac",
        "feather"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bookshelf",
      "name": "Bookshelf",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "bookshelf",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "book",
        "book",
        "book",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bordure_indented_banner_pattern",
      "name": "Bordure Indented Banner Pattern",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "bordure_indented_banner_pattern",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "paper",
        "vine"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bow",
      "name": "Bow",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "bow",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "stick",
        "string",
        "stick",
        null,
        "string",
        null,
        "stick",
        "string"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bowl",
      "name": "Bowl",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "bowl",
      "outputQuantity": 4,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "oak_planks",
        null,
        "oak_planks",
        null,
        "oak_planks",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bread",
      "name": "Bread",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "bread",
      "outputQuantity": 1,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "wheat",
        "wheat",
        "wheat"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brewing_stand",
      "name": "Brewing Stand",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "brewing_stand",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        null,
        "blaze_rod",
        null,
        "cobblestone",
        "cobblestone",
        "cobblestone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brick_slab",
      "name": "Brick Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "brick_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "bricks",
        "bricks",
        "bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brick_stairs",
      "name": "Brick Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "brick_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "bricks",
        null,
        null,
        "bricks",
        "bricks",
        null,
        "bricks",
        "bricks",
        "bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brick_wall",
      "name": "Brick Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "brick_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "bricks",
        "bricks",
        "bricks",
        "bricks",
        "bricks",
        "bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bricks",
      "name": "Bricks",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "bricks",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "brick",
        "brick",
        "brick",
        "brick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brown_banner",
      "name": "Brown Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "brown_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "brown_wool",
        "brown_wool",
        "brown_wool",
        "brown_wool",
        "brown_wool",
        "brown_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_brown_bed",
      "name": "Brown Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "brown_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "brown_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brown_bundle",
      "name": "Brown Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "brown_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "brown_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brown_candle",
      "name": "Brown Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "brown_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "brown_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brown_carpet",
      "name": "Brown Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "brown_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "brown_wool",
        "brown_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brown_concrete_powder",
      "name": "Brown Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "brown_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "brown_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brown_dye",
      "name": "Brown Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "brown_dye",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "cocoa_beans"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_brown_harness",
      "name": "Brown Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "brown_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "brown_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brown_shulker_box",
      "name": "Brown Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "brown_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "brown_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brown_stained_glass",
      "name": "Brown Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "brown_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "brown_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brown_stained_glass_pane",
      "name": "Brown Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "brown_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "brown_stained_glass",
        "brown_stained_glass",
        "brown_stained_glass",
        "brown_stained_glass",
        "brown_stained_glass",
        "brown_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brown_terracotta",
      "name": "Brown Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "brown_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "brown_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_brown_wool",
      "name": "Brown Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "brown_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "brown_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "brush",
      "name": "Brush",
      "description": "3 ingredients using 3 unique materials.",
      "outputItemId": "brush",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "feather",
        "copper_ingot",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bucket",
      "name": "Bucket",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "bucket",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "iron_ingot",
        null,
        "iron_ingot",
        null,
        "iron_ingot",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "bundle",
      "name": "Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "bundle",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "string",
        "leather"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cake",
      "name": "Cake",
      "description": "9 ingredients using 4 unique materials.",
      "outputItemId": "cake",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "milk_bucket",
        "milk_bucket",
        "milk_bucket",
        "sugar",
        "egg",
        "sugar",
        "wheat",
        "wheat",
        "wheat"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "calibrated_sculk_sensor",
      "name": "Calibrated Sculk Sensor",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "calibrated_sculk_sensor",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        null,
        "amethyst_shard",
        null,
        "amethyst_shard",
        "sculk_sensor",
        "amethyst_shard"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "campfire",
      "name": "Campfire",
      "description": "7 ingredients using 3 unique materials.",
      "outputItemId": "campfire",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "stick",
        null,
        "stick",
        "coal",
        "stick",
        "dark_oak_log",
        "dark_oak_log",
        "dark_oak_log"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "candle",
      "name": "Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "candle",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "string",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "carrot_on_a_stick",
      "name": "Carrot on a Stick",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "carrot_on_a_stick",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "fishing_rod",
        null,
        null,
        "carrot"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cartography_table",
      "name": "Cartography Table",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "cartography_table",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "paper",
        "paper",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cauldron",
      "name": "Cauldron",
      "description": "7 ingredients using 1 unique material.",
      "outputItemId": "cauldron",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        null,
        "iron_ingot",
        "iron_ingot",
        null,
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_boat",
      "name": "Cherry Boat",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "cherry_boat",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "cherry_planks",
        null,
        "cherry_planks",
        "cherry_planks",
        "cherry_planks",
        "cherry_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_chest_boat",
      "name": "Cherry Boat with Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "cherry_chest_boat",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "chest",
        "cherry_boat"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_button",
      "name": "Cherry Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "cherry_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "cherry_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_door",
      "name": "Cherry Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "cherry_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "cherry_planks",
        "cherry_planks",
        "cherry_planks",
        "cherry_planks",
        "cherry_planks",
        "cherry_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_fence",
      "name": "Cherry Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "cherry_fence",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "cherry_planks",
        "stick",
        "cherry_planks",
        "cherry_planks",
        "stick",
        "cherry_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_fence_gate",
      "name": "Cherry Fence Gate",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "cherry_fence_gate",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "cherry_planks",
        "stick",
        "stick",
        "cherry_planks",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_hanging_sign",
      "name": "Cherry Hanging Sign",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "cherry_hanging_sign",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_chain",
        null,
        "iron_chain",
        "stripped_cherry_log",
        "stripped_cherry_log",
        "stripped_cherry_log",
        "stripped_cherry_log",
        "stripped_cherry_log",
        "stripped_cherry_log"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_planks",
      "name": "Cherry Planks",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "cherry_planks",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "cherry_log"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_pressure_plate",
      "name": "Cherry Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "cherry_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "cherry_planks",
        "cherry_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_shelf",
      "name": "Cherry Shelf",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "cherry_shelf",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stripped_cherry_log",
        "stripped_cherry_log",
        "stripped_cherry_log",
        null,
        null,
        null,
        "stripped_cherry_log",
        "stripped_cherry_log",
        "stripped_cherry_log"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_sign",
      "name": "Cherry Sign",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "cherry_sign",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "cherry_planks",
        "cherry_planks",
        "cherry_planks",
        "cherry_planks",
        "cherry_planks",
        "cherry_planks",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_slab",
      "name": "Cherry Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "cherry_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "cherry_planks",
        "cherry_planks",
        "cherry_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_stairs",
      "name": "Cherry Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "cherry_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "cherry_planks",
        null,
        null,
        "cherry_planks",
        "cherry_planks",
        null,
        "cherry_planks",
        "cherry_planks",
        "cherry_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_trapdoor",
      "name": "Cherry Trapdoor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "cherry_trapdoor",
      "outputQuantity": 2,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "cherry_planks",
        "cherry_planks",
        "cherry_planks",
        "cherry_planks",
        "cherry_planks",
        "cherry_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cherry_wood",
      "name": "Cherry Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "cherry_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "cherry_log",
        "cherry_log",
        "cherry_log",
        "cherry_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chest",
      "name": "Chest",
      "description": "8 ingredients using 1 unique material.",
      "outputItemId": "chest",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        null,
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chiseled_bookshelf",
      "name": "Chiseled Bookshelf",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "chiseled_bookshelf",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_slab",
        "oak_slab",
        "oak_slab",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chiseled_copper",
      "name": "Chiseled Copper",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "chiseled_copper",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "cut_copper_slab",
        "cut_copper_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chiseled_deepslate",
      "name": "Chiseled Deepslate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "chiseled_deepslate",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "cobbled_deepslate_slab",
        "cobbled_deepslate_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chiseled_nether_bricks",
      "name": "Chiseled Nether Bricks",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "chiseled_nether_bricks",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "nether_brick_slab",
        "nether_brick_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chiseled_polished_blackstone",
      "name": "Chiseled Polished Blackstone",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "chiseled_polished_blackstone",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "polished_blackstone_slab",
        "polished_blackstone_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chiseled_quartz_block",
      "name": "Chiseled Quartz Block",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "chiseled_quartz_block",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "quartz_slab",
        "quartz_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chiseled_red_sandstone",
      "name": "Chiseled Red Sandstone",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "chiseled_red_sandstone",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "red_sandstone_slab",
        "red_sandstone_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chiseled_resin_bricks",
      "name": "Chiseled Resin Bricks",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "chiseled_resin_bricks",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "resin_brick_slab",
        "resin_brick_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chiseled_sandstone",
      "name": "Chiseled Sandstone",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "chiseled_sandstone",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "sandstone_slab",
        "sandstone_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chiseled_stone_bricks",
      "name": "Chiseled Stone Bricks",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "chiseled_stone_bricks",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "stone_brick_slab",
        "stone_brick_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chiseled_tuff",
      "name": "Chiseled Tuff",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "chiseled_tuff",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "tuff_slab",
        "tuff_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chiseled_tuff_bricks",
      "name": "Chiseled Tuff Bricks",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "chiseled_tuff_bricks",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "tuff_brick_slab",
        "tuff_brick_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "clay",
      "name": "Clay",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "clay",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "clay_ball",
        "clay_ball",
        "clay_ball",
        "clay_ball"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "clock",
      "name": "Clock",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "clock",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "gold_ingot",
        null,
        "gold_ingot",
        "redstone",
        "gold_ingot",
        null,
        "gold_ingot",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "coal",
      "name": "Coal",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "coal",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "coal_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "coarse_dirt",
      "name": "Coarse Dirt",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "coarse_dirt",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "dirt",
        "gravel",
        "gravel",
        "dirt"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cobbled_deepslate_slab",
      "name": "Cobbled Deepslate Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "cobbled_deepslate_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "cobbled_deepslate",
        "cobbled_deepslate",
        "cobbled_deepslate"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cobbled_deepslate_stairs",
      "name": "Cobbled Deepslate Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "cobbled_deepslate_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "cobbled_deepslate",
        null,
        null,
        "cobbled_deepslate",
        "cobbled_deepslate",
        null,
        "cobbled_deepslate",
        "cobbled_deepslate",
        "cobbled_deepslate"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cobbled_deepslate_wall",
      "name": "Cobbled Deepslate Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "cobbled_deepslate_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "cobbled_deepslate",
        "cobbled_deepslate",
        "cobbled_deepslate",
        "cobbled_deepslate",
        "cobbled_deepslate",
        "cobbled_deepslate"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cobblestone_slab",
      "name": "Cobblestone Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "cobblestone_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "cobblestone",
        "cobblestone",
        "cobblestone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cobblestone_stairs",
      "name": "Cobblestone Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "cobblestone_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "cobblestone",
        null,
        null,
        "cobblestone",
        "cobblestone",
        null,
        "cobblestone",
        "cobblestone",
        "cobblestone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cobblestone_wall",
      "name": "Cobblestone Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "cobblestone_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "cobblestone",
        "cobblestone",
        "cobblestone",
        "cobblestone",
        "cobblestone",
        "cobblestone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "compass",
      "name": "Compass",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "compass",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "iron_ingot",
        null,
        "iron_ingot",
        "redstone",
        "iron_ingot",
        null,
        "iron_ingot",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "composter",
      "name": "Composter",
      "description": "7 ingredients using 1 unique material.",
      "outputItemId": "composter",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_slab",
        null,
        "oak_slab",
        "oak_slab",
        null,
        "oak_slab",
        "oak_slab",
        "oak_slab",
        "oak_slab"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "conduit",
      "name": "Conduit",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "conduit",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "nautilus_shell",
        "nautilus_shell",
        "nautilus_shell",
        "nautilus_shell",
        "heart_of_the_sea",
        "nautilus_shell",
        "nautilus_shell",
        "nautilus_shell",
        "nautilus_shell"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cookie",
      "name": "Cookie",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "cookie",
      "outputQuantity": 8,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "wheat",
        "cocoa_beans",
        "wheat"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_axe",
      "name": "Copper Axe",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "copper_axe",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_bars",
      "name": "Copper Bars",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "copper_bars",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_boots",
      "name": "Copper Boots",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "copper_boots",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "copper_ingot",
        null,
        "copper_ingot",
        "copper_ingot",
        null,
        "copper_ingot"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_bulb",
      "name": "Copper Bulb",
      "description": "5 ingredients using 3 unique materials.",
      "outputItemId": "copper_bulb",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "copper_block",
        null,
        "copper_block",
        "blaze_rod",
        "copper_block",
        null,
        "redstone",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_chain",
      "name": "Copper Chain",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "copper_chain",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_nugget",
        "copper_ingot",
        "copper_nugget"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_chest",
      "name": "Copper Chest",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "copper_chest",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "chest",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_chestplate",
      "name": "Copper Chestplate",
      "description": "8 ingredients using 1 unique material.",
      "outputItemId": "copper_chestplate",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_ingot",
        null,
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_door",
      "name": "Copper Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "copper_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_grate",
      "name": "Copper Grate",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "copper_grate",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "copper_block",
        null,
        "copper_block",
        null,
        "copper_block",
        null,
        "copper_block",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_helmet",
      "name": "Copper Helmet",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "copper_helmet",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        null,
        "copper_ingot"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_hoe",
      "name": "Copper Hoe",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "copper_hoe",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "copper_ingot",
        null,
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_ingot",
      "name": "Copper Ingot",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "copper_ingot",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "copper_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_lantern",
      "name": "Copper Lantern",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "copper_lantern",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_nugget",
        "copper_nugget",
        "copper_nugget",
        "copper_nugget",
        "copper_torch",
        "copper_nugget",
        "copper_nugget",
        "copper_nugget",
        "copper_nugget"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_leggings",
      "name": "Copper Leggings",
      "description": "7 ingredients using 1 unique material.",
      "outputItemId": "copper_leggings",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        null,
        "copper_ingot",
        "copper_ingot",
        null,
        "copper_ingot"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_nugget",
      "name": "Copper Nugget",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "copper_nugget",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "copper_ingot"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_pickaxe",
      "name": "Copper Pickaxe",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "copper_pickaxe",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        null,
        "stick",
        null,
        null,
        "stick",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_shovel",
      "name": "Copper Shovel",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "copper_shovel",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "stick",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_spear",
      "name": "Copper Spear",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "copper_spear",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        null,
        "copper_ingot",
        null,
        "stick",
        null,
        "stick",
        null,
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_sword",
      "name": "Copper Sword",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "copper_sword",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "copper_ingot",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_torch",
      "name": "Copper Torch",
      "description": "3 ingredients using 3 unique materials.",
      "outputItemId": "copper_torch",
      "outputQuantity": 4,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_nugget",
        "coal",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "copper_trapdoor",
      "name": "Copper Trapdoor",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "copper_trapdoor",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "copper_ingot",
        "copper_ingot",
        "copper_ingot"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crafter",
      "name": "Crafter",
      "description": "9 ingredients using 4 unique materials.",
      "outputItemId": "crafter",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "crafting_table",
        "iron_ingot",
        "redstone",
        "dropper",
        "redstone"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crafting_table",
      "name": "Crafting Table",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "crafting_table",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "creaking_heart",
      "name": "Creaking Heart",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "creaking_heart",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "pale_oak_log",
        null,
        null,
        "resin_block",
        null,
        null,
        "pale_oak_log",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_button",
      "name": "Crimson Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "crimson_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "crimson_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_door",
      "name": "Crimson Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "crimson_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "crimson_planks",
        "crimson_planks",
        "crimson_planks",
        "crimson_planks",
        "crimson_planks",
        "crimson_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_fence",
      "name": "Crimson Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "crimson_fence",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "crimson_planks",
        "stick",
        "crimson_planks",
        "crimson_planks",
        "stick",
        "crimson_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_fence_gate",
      "name": "Crimson Fence Gate",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "crimson_fence_gate",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "crimson_planks",
        "stick",
        "stick",
        "crimson_planks",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_hanging_sign",
      "name": "Crimson Hanging Sign",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "crimson_hanging_sign",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_chain",
        null,
        "iron_chain",
        "stripped_crimson_stem",
        "stripped_crimson_stem",
        "stripped_crimson_stem",
        "stripped_crimson_stem",
        "stripped_crimson_stem",
        "stripped_crimson_stem"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_hyphae",
      "name": "Crimson Hyphae",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "crimson_hyphae",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "crimson_stem",
        "crimson_stem",
        "crimson_stem",
        "crimson_stem"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_planks",
      "name": "Crimson Planks",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "crimson_planks",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "crimson_stem"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_pressure_plate",
      "name": "Crimson Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "crimson_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "crimson_planks",
        "crimson_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_shelf",
      "name": "Crimson Shelf",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "crimson_shelf",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stripped_crimson_stem",
        "stripped_crimson_stem",
        "stripped_crimson_stem",
        null,
        null,
        null,
        "stripped_crimson_stem",
        "stripped_crimson_stem",
        "stripped_crimson_stem"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_sign",
      "name": "Crimson Sign",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "crimson_sign",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "crimson_planks",
        "crimson_planks",
        "crimson_planks",
        "crimson_planks",
        "crimson_planks",
        "crimson_planks",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_slab",
      "name": "Crimson Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "crimson_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "crimson_planks",
        "crimson_planks",
        "crimson_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_stairs",
      "name": "Crimson Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "crimson_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "crimson_planks",
        null,
        null,
        "crimson_planks",
        "crimson_planks",
        null,
        "crimson_planks",
        "crimson_planks",
        "crimson_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crimson_trapdoor",
      "name": "Crimson Trapdoor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "crimson_trapdoor",
      "outputQuantity": 2,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "crimson_planks",
        "crimson_planks",
        "crimson_planks",
        "crimson_planks",
        "crimson_planks",
        "crimson_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "crossbow",
      "name": "Crossbow",
      "description": "7 ingredients using 4 unique materials.",
      "outputItemId": "crossbow",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stick",
        "iron_ingot",
        "stick",
        "string",
        "tripwire_hook",
        "string",
        null,
        "stick",
        null
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cut_copper",
      "name": "Cut Copper",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "cut_copper",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "copper_block",
        "copper_block",
        "copper_block",
        "copper_block"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cut_copper_slab",
      "name": "Cut Copper Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "cut_copper_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "cut_copper",
        "cut_copper",
        "cut_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cut_copper_stairs",
      "name": "Cut Copper Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "cut_copper_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "cut_copper",
        null,
        null,
        "cut_copper",
        "cut_copper",
        null,
        "cut_copper",
        "cut_copper",
        "cut_copper"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cut_red_sandstone",
      "name": "Cut Red Sandstone",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "cut_red_sandstone",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "red_sandstone",
        "red_sandstone",
        "red_sandstone",
        "red_sandstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cut_red_sandstone_slab",
      "name": "Cut Red Sandstone Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "cut_red_sandstone_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "cut_red_sandstone",
        "cut_red_sandstone",
        "cut_red_sandstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cut_sandstone",
      "name": "Cut Sandstone",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "cut_sandstone",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "sandstone",
        "sandstone",
        "sandstone",
        "sandstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cut_sandstone_slab",
      "name": "Cut Sandstone Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "cut_sandstone_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "cut_sandstone",
        "cut_sandstone",
        "cut_sandstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cyan_banner",
      "name": "Cyan Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "cyan_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "cyan_wool",
        "cyan_wool",
        "cyan_wool",
        "cyan_wool",
        "cyan_wool",
        "cyan_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_cyan_bed",
      "name": "Cyan Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "cyan_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "cyan_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cyan_bundle",
      "name": "Cyan Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "cyan_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "cyan_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cyan_candle",
      "name": "Cyan Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "cyan_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "cyan_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cyan_carpet",
      "name": "Cyan Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "cyan_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "cyan_wool",
        "cyan_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cyan_concrete_powder",
      "name": "Cyan Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "cyan_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "cyan_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cyan_dye_from_pitcher_plant",
      "name": "Cyan Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "cyan_dye",
      "outputQuantity": 2,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "pitcher_plant"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_cyan_harness",
      "name": "Cyan Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "cyan_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "cyan_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cyan_shulker_box",
      "name": "Cyan Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "cyan_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "cyan_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cyan_stained_glass",
      "name": "Cyan Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "cyan_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "cyan_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cyan_stained_glass_pane",
      "name": "Cyan Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "cyan_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "cyan_stained_glass",
        "cyan_stained_glass",
        "cyan_stained_glass",
        "cyan_stained_glass",
        "cyan_stained_glass",
        "cyan_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "cyan_terracotta",
      "name": "Cyan Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "cyan_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "cyan_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_cyan_wool",
      "name": "Cyan Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "cyan_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "cyan_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_boat",
      "name": "Dark Oak Boat",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "dark_oak_boat",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "dark_oak_planks",
        null,
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_chest_boat",
      "name": "Dark Oak Boat with Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "dark_oak_chest_boat",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "chest",
        "dark_oak_boat"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_button",
      "name": "Dark Oak Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "dark_oak_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "dark_oak_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_door",
      "name": "Dark Oak Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "dark_oak_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_fence",
      "name": "Dark Oak Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "dark_oak_fence",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "dark_oak_planks",
        "stick",
        "dark_oak_planks",
        "dark_oak_planks",
        "stick",
        "dark_oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_fence_gate",
      "name": "Dark Oak Fence Gate",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "dark_oak_fence_gate",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "dark_oak_planks",
        "stick",
        "stick",
        "dark_oak_planks",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_hanging_sign",
      "name": "Dark Oak Hanging Sign",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "dark_oak_hanging_sign",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_chain",
        null,
        "iron_chain",
        "stripped_dark_oak_log",
        "stripped_dark_oak_log",
        "stripped_dark_oak_log",
        "stripped_dark_oak_log",
        "stripped_dark_oak_log",
        "stripped_dark_oak_log"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_planks",
      "name": "Dark Oak Planks",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "dark_oak_planks",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "dark_oak_log"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_pressure_plate",
      "name": "Dark Oak Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "dark_oak_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "dark_oak_planks",
        "dark_oak_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_shelf",
      "name": "Dark Oak Shelf",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "dark_oak_shelf",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stripped_dark_oak_log",
        "stripped_dark_oak_log",
        "stripped_dark_oak_log",
        null,
        null,
        null,
        "stripped_dark_oak_log",
        "stripped_dark_oak_log",
        "stripped_dark_oak_log"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_sign",
      "name": "Dark Oak Sign",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "dark_oak_sign",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_slab",
      "name": "Dark Oak Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "dark_oak_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_stairs",
      "name": "Dark Oak Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "dark_oak_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "dark_oak_planks",
        null,
        null,
        "dark_oak_planks",
        "dark_oak_planks",
        null,
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_trapdoor",
      "name": "Dark Oak Trapdoor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "dark_oak_trapdoor",
      "outputQuantity": 2,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks",
        "dark_oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_oak_wood",
      "name": "Dark Oak Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "dark_oak_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "dark_oak_log",
        "dark_oak_log",
        "dark_oak_log",
        "dark_oak_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_prismarine",
      "name": "Dark Prismarine",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "dark_prismarine",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard",
        "black_dye",
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_prismarine_slab",
      "name": "Dark Prismarine Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "dark_prismarine_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "dark_prismarine",
        "dark_prismarine",
        "dark_prismarine"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dark_prismarine_stairs",
      "name": "Dark Prismarine Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "dark_prismarine_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "dark_prismarine",
        null,
        null,
        "dark_prismarine",
        "dark_prismarine",
        null,
        "dark_prismarine",
        "dark_prismarine",
        "dark_prismarine"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "daylight_detector",
      "name": "Daylight Detector",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "daylight_detector",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "quartz",
        "quartz",
        "quartz",
        "oak_slab",
        "oak_slab",
        "oak_slab"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "decorated_pot",
      "name": "Decorated Pot",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "decorated_pot",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "brick",
        null,
        "brick",
        null,
        "brick",
        null,
        "brick",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "deepslate_brick_slab",
      "name": "Deepslate Brick Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "deepslate_brick_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "deepslate_bricks",
        "deepslate_bricks",
        "deepslate_bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "deepslate_brick_stairs",
      "name": "Deepslate Brick Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "deepslate_brick_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "deepslate_bricks",
        null,
        null,
        "deepslate_bricks",
        "deepslate_bricks",
        null,
        "deepslate_bricks",
        "deepslate_bricks",
        "deepslate_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "deepslate_brick_wall",
      "name": "Deepslate Brick Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "deepslate_brick_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "deepslate_bricks",
        "deepslate_bricks",
        "deepslate_bricks",
        "deepslate_bricks",
        "deepslate_bricks",
        "deepslate_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "deepslate_bricks",
      "name": "Deepslate Bricks",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "deepslate_bricks",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "polished_deepslate",
        "polished_deepslate",
        "polished_deepslate",
        "polished_deepslate"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "deepslate_tile_slab",
      "name": "Deepslate Tile Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "deepslate_tile_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "deepslate_tiles",
        "deepslate_tiles",
        "deepslate_tiles"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "deepslate_tile_stairs",
      "name": "Deepslate Tile Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "deepslate_tile_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "deepslate_tiles",
        null,
        null,
        "deepslate_tiles",
        "deepslate_tiles",
        null,
        "deepslate_tiles",
        "deepslate_tiles",
        "deepslate_tiles"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "deepslate_tile_wall",
      "name": "Deepslate Tile Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "deepslate_tile_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "deepslate_tiles",
        "deepslate_tiles",
        "deepslate_tiles",
        "deepslate_tiles",
        "deepslate_tiles",
        "deepslate_tiles"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "deepslate_tiles",
      "name": "Deepslate Tiles",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "deepslate_tiles",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "deepslate_bricks",
        "deepslate_bricks",
        "deepslate_bricks",
        "deepslate_bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "detector_rail",
      "name": "Detector Rail",
      "description": "8 ingredients using 3 unique materials.",
      "outputItemId": "detector_rail",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        null,
        "iron_ingot",
        "iron_ingot",
        "stone_pressure_plate",
        "iron_ingot",
        "iron_ingot",
        "redstone",
        "iron_ingot"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diamond",
      "name": "Diamond",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "diamond",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "diamond_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diamond_axe",
      "name": "Diamond Axe",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "diamond_axe",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "diamond",
        "diamond",
        "diamond",
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diamond_boots",
      "name": "Diamond Boots",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "diamond_boots",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "diamond",
        null,
        "diamond",
        "diamond",
        null,
        "diamond"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diamond_chestplate",
      "name": "Diamond Chestplate",
      "description": "8 ingredients using 1 unique material.",
      "outputItemId": "diamond_chestplate",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "diamond",
        null,
        "diamond",
        "diamond",
        "diamond",
        "diamond",
        "diamond",
        "diamond",
        "diamond"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diamond_helmet",
      "name": "Diamond Helmet",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "diamond_helmet",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "diamond",
        "diamond",
        "diamond",
        "diamond",
        null,
        "diamond"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diamond_hoe",
      "name": "Diamond Hoe",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "diamond_hoe",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "diamond",
        "diamond",
        null,
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diamond_leggings",
      "name": "Diamond Leggings",
      "description": "7 ingredients using 1 unique material.",
      "outputItemId": "diamond_leggings",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "diamond",
        "diamond",
        "diamond",
        "diamond",
        null,
        "diamond",
        "diamond",
        null,
        "diamond"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diamond_pickaxe",
      "name": "Diamond Pickaxe",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "diamond_pickaxe",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "diamond",
        "diamond",
        "diamond",
        null,
        "stick",
        null,
        null,
        "stick",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diamond_shovel",
      "name": "Diamond Shovel",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "diamond_shovel",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "diamond",
        "stick",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diamond_spear",
      "name": "Diamond Spear",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "diamond_spear",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        null,
        "diamond",
        null,
        "stick",
        null,
        "stick",
        null,
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diamond_sword",
      "name": "Diamond Sword",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "diamond_sword",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "diamond",
        "diamond",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diorite",
      "name": "Diorite",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "diorite",
      "outputQuantity": 2,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "cobblestone",
        "quartz",
        "quartz",
        "cobblestone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diorite_slab",
      "name": "Diorite Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "diorite_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "diorite",
        "diorite",
        "diorite"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diorite_stairs",
      "name": "Diorite Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "diorite_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "diorite",
        null,
        null,
        "diorite",
        "diorite",
        null,
        "diorite",
        "diorite",
        "diorite"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "diorite_wall",
      "name": "Diorite Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "diorite_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "diorite",
        "diorite",
        "diorite",
        "diorite",
        "diorite",
        "diorite"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dispenser",
      "name": "Dispenser",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "dispenser",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "cobblestone",
        "cobblestone",
        "cobblestone",
        "cobblestone",
        "bow",
        "cobblestone",
        "cobblestone",
        "redstone",
        "cobblestone"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dried_ghast",
      "name": "Dried Ghast",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "dried_ghast",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "ghast_tear",
        "ghast_tear",
        "ghast_tear",
        "ghast_tear",
        "soul_sand",
        "ghast_tear",
        "ghast_tear",
        "ghast_tear",
        "ghast_tear"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dried_kelp",
      "name": "Dried Kelp",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "dried_kelp",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "dried_kelp_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dried_kelp_block",
      "name": "Dried Kelp Block",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "dried_kelp_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "dried_kelp",
        "dried_kelp",
        "dried_kelp",
        "dried_kelp",
        "dried_kelp",
        "dried_kelp",
        "dried_kelp",
        "dried_kelp",
        "dried_kelp"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dripstone_block",
      "name": "Dripstone Block",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "dripstone_block",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "pointed_dripstone",
        "pointed_dripstone",
        "pointed_dripstone",
        "pointed_dripstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dropper",
      "name": "Dropper",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "dropper",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "cobblestone",
        "cobblestone",
        "cobblestone",
        "cobblestone",
        null,
        "cobblestone",
        "cobblestone",
        "redstone",
        "cobblestone"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "emerald",
      "name": "Emerald",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "emerald",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "emerald_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "map",
      "name": "Empty Map",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "map",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "paper",
        "paper",
        "paper",
        "paper",
        "compass",
        "paper",
        "paper",
        "paper",
        "paper"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "enchanting_table",
      "name": "Enchanting Table",
      "description": "7 ingredients using 3 unique materials.",
      "outputItemId": "enchanting_table",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "book",
        null,
        "diamond",
        "obsidian",
        "diamond",
        "obsidian",
        "obsidian",
        "obsidian"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "end_crystal",
      "name": "End Crystal",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "end_crystal",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "ender_eye",
        "glass",
        "glass",
        "ghast_tear",
        "glass"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "end_rod",
      "name": "End Rod",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "end_rod",
      "outputQuantity": 4,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "blaze_rod",
        "popped_chorus_fruit"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "end_stone_brick_slab",
      "name": "End Stone Brick Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "end_stone_brick_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "end_stone_bricks",
        "end_stone_bricks",
        "end_stone_bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "end_stone_brick_stairs",
      "name": "End Stone Brick Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "end_stone_brick_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "end_stone_bricks",
        null,
        null,
        "end_stone_bricks",
        "end_stone_bricks",
        null,
        "end_stone_bricks",
        "end_stone_bricks",
        "end_stone_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "end_stone_brick_wall",
      "name": "End Stone Brick Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "end_stone_brick_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "end_stone_bricks",
        "end_stone_bricks",
        "end_stone_bricks",
        "end_stone_bricks",
        "end_stone_bricks",
        "end_stone_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "end_stone_bricks",
      "name": "End Stone Bricks",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "end_stone_bricks",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "end_stone",
        "end_stone",
        "end_stone",
        "end_stone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "ender_chest",
      "name": "Ender Chest",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "ender_chest",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "obsidian",
        "obsidian",
        "obsidian",
        "obsidian",
        "ender_eye",
        "obsidian",
        "obsidian",
        "obsidian",
        "obsidian"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "exposed_chiseled_copper",
      "name": "Exposed Chiseled Copper",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "exposed_chiseled_copper",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "exposed_cut_copper_slab",
        "exposed_cut_copper_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "exposed_copper_bulb",
      "name": "Exposed Copper Bulb",
      "description": "5 ingredients using 3 unique materials.",
      "outputItemId": "exposed_copper_bulb",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "exposed_copper",
        null,
        "exposed_copper",
        "blaze_rod",
        "exposed_copper",
        null,
        "redstone",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "exposed_copper_grate",
      "name": "Exposed Copper Grate",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "exposed_copper_grate",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "exposed_copper",
        null,
        "exposed_copper",
        null,
        "exposed_copper",
        null,
        "exposed_copper",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "exposed_cut_copper",
      "name": "Exposed Cut Copper",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "exposed_cut_copper",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "exposed_copper",
        "exposed_copper",
        "exposed_copper",
        "exposed_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "exposed_cut_copper_slab",
      "name": "Exposed Cut Copper Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "exposed_cut_copper_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "exposed_cut_copper",
        "exposed_cut_copper",
        "exposed_cut_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "exposed_cut_copper_stairs",
      "name": "Exposed Cut Copper Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "exposed_cut_copper_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "exposed_cut_copper",
        null,
        null,
        "exposed_cut_copper",
        "exposed_cut_copper",
        null,
        "exposed_cut_copper",
        "exposed_cut_copper",
        "exposed_cut_copper"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "ender_eye",
      "name": "Eye of Ender",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "ender_eye",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "ender_pearl",
        "blaze_powder"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "fermented_spider_eye",
      "name": "Fermented Spider Eye",
      "description": "3 ingredients using 3 unique materials.",
      "outputItemId": "fermented_spider_eye",
      "outputQuantity": 1,
      "width": 3,
      "height": 1,
      "shaped": false,
      "grid": [
        "spider_eye",
        "brown_mushroom",
        "sugar"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "field_masoned_banner_pattern",
      "name": "Field Masoned Banner Pattern",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "field_masoned_banner_pattern",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "paper",
        "bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "fire_charge",
      "name": "Fire Charge",
      "description": "3 ingredients using 3 unique materials.",
      "outputItemId": "fire_charge",
      "outputQuantity": 3,
      "width": 3,
      "height": 1,
      "shaped": false,
      "grid": [
        "gunpowder",
        "blaze_powder",
        "coal"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "firework_rocket",
      "name": "Firework Rocket",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "firework_rocket",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "paper",
        "gunpowder"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "firework_star",
      "name": "Firework Star",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "firework_star",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "gunpowder",
        "white_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "fishing_rod",
      "name": "Fishing Rod",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "fishing_rod",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        null,
        "stick",
        null,
        "stick",
        "string",
        "stick",
        null,
        "string"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "fletching_table",
      "name": "Fletching Table",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "fletching_table",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "flint",
        "flint",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "flint_and_steel",
      "name": "Flint and Steel",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "flint_and_steel",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "iron_ingot",
        "flint"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "flower_pot",
      "name": "Flower Pot",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "flower_pot",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "brick",
        null,
        "brick",
        null,
        "brick",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "furnace",
      "name": "Furnace",
      "description": "8 ingredients using 1 unique material.",
      "outputItemId": "furnace",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "cobblestone",
        "cobblestone",
        "cobblestone",
        "cobblestone",
        null,
        "cobblestone",
        "cobblestone",
        "cobblestone",
        "cobblestone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "glass_bottle",
      "name": "Glass Bottle",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "glass_bottle",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "glass",
        null,
        "glass",
        null,
        "glass",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "glass_pane",
      "name": "Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "glistering_melon_slice",
      "name": "Glistering Melon Slice",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "glistering_melon_slice",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_nugget",
        "gold_nugget",
        "gold_nugget",
        "gold_nugget",
        "melon_slice",
        "gold_nugget",
        "gold_nugget",
        "gold_nugget",
        "gold_nugget"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "glow_item_frame",
      "name": "Glow Item Frame",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "glow_item_frame",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "item_frame",
        "glow_ink_sac"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "glowstone",
      "name": "Glowstone",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "glowstone",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "glowstone_dust",
        "glowstone_dust",
        "glowstone_dust",
        "glowstone_dust"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gold_ingot_from_gold_block",
      "name": "Gold Ingot",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "gold_ingot",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "gold_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gold_nugget",
      "name": "Gold Nugget",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "gold_nugget",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "gold_ingot"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_apple",
      "name": "Golden Apple",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "golden_apple",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "apple",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_axe",
      "name": "Golden Axe",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "golden_axe",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_boots",
      "name": "Golden Boots",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "golden_boots",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "gold_ingot",
        null,
        "gold_ingot",
        "gold_ingot",
        null,
        "gold_ingot"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_carrot",
      "name": "Golden Carrot",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "golden_carrot",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_nugget",
        "gold_nugget",
        "gold_nugget",
        "gold_nugget",
        "carrot",
        "gold_nugget",
        "gold_nugget",
        "gold_nugget",
        "gold_nugget"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_chestplate",
      "name": "Golden Chestplate",
      "description": "8 ingredients using 1 unique material.",
      "outputItemId": "golden_chestplate",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_ingot",
        null,
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_dandelion",
      "name": "Golden Dandelion",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "golden_dandelion",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_nugget",
        "gold_nugget",
        "gold_nugget",
        "gold_nugget",
        "dandelion",
        "gold_nugget",
        "gold_nugget",
        "gold_nugget",
        "gold_nugget"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_helmet",
      "name": "Golden Helmet",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "golden_helmet",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        null,
        "gold_ingot"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_hoe",
      "name": "Golden Hoe",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "golden_hoe",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_ingot",
        "gold_ingot",
        null,
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_leggings",
      "name": "Golden Leggings",
      "description": "7 ingredients using 1 unique material.",
      "outputItemId": "golden_leggings",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        null,
        "gold_ingot",
        "gold_ingot",
        null,
        "gold_ingot"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_pickaxe",
      "name": "Golden Pickaxe",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "golden_pickaxe",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_ingot",
        "gold_ingot",
        "gold_ingot",
        null,
        "stick",
        null,
        null,
        "stick",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_shovel",
      "name": "Golden Shovel",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "golden_shovel",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_ingot",
        "stick",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_spear",
      "name": "Golden Spear",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "golden_spear",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        null,
        "gold_ingot",
        null,
        "stick",
        null,
        "stick",
        null,
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "golden_sword",
      "name": "Golden Sword",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "golden_sword",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_ingot",
        "gold_ingot",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "granite",
      "name": "Granite",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "granite",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "diorite",
        "quartz"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "granite_slab",
      "name": "Granite Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "granite_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "granite",
        "granite",
        "granite"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "granite_stairs",
      "name": "Granite Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "granite_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "granite",
        null,
        null,
        "granite",
        "granite",
        null,
        "granite",
        "granite",
        "granite"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "granite_wall",
      "name": "Granite Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "granite_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "granite",
        "granite",
        "granite",
        "granite",
        "granite",
        "granite"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gray_banner",
      "name": "Gray Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "gray_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "gray_wool",
        "gray_wool",
        "gray_wool",
        "gray_wool",
        "gray_wool",
        "gray_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_gray_bed",
      "name": "Gray Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "gray_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "gray_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gray_bundle",
      "name": "Gray Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "gray_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "gray_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gray_candle",
      "name": "Gray Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "gray_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "gray_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gray_carpet",
      "name": "Gray Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "gray_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "gray_wool",
        "gray_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gray_concrete_powder",
      "name": "Gray Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "gray_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "gray_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gray_dye_from_closed_eyeblossom",
      "name": "Gray Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "gray_dye",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "closed_eyeblossom"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_gray_harness",
      "name": "Gray Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "gray_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "gray_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gray_shulker_box",
      "name": "Gray Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "gray_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "gray_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gray_stained_glass",
      "name": "Gray Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "gray_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "gray_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gray_stained_glass_pane",
      "name": "Gray Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "gray_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "gray_stained_glass",
        "gray_stained_glass",
        "gray_stained_glass",
        "gray_stained_glass",
        "gray_stained_glass",
        "gray_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "gray_terracotta",
      "name": "Gray Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "gray_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "gray_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_gray_wool",
      "name": "Gray Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "gray_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "gray_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "green_banner",
      "name": "Green Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "green_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "green_wool",
        "green_wool",
        "green_wool",
        "green_wool",
        "green_wool",
        "green_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_green_bed",
      "name": "Green Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "green_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "green_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "green_bundle",
      "name": "Green Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "green_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "green_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "green_candle",
      "name": "Green Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "green_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "green_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "green_carpet",
      "name": "Green Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "green_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "green_wool",
        "green_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "green_concrete_powder",
      "name": "Green Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "green_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "green_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_green_harness",
      "name": "Green Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "green_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "green_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "green_shulker_box",
      "name": "Green Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "green_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "green_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "green_stained_glass",
      "name": "Green Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "green_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "green_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "green_stained_glass_pane",
      "name": "Green Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "green_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "green_stained_glass",
        "green_stained_glass",
        "green_stained_glass",
        "green_stained_glass",
        "green_stained_glass",
        "green_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "green_terracotta",
      "name": "Green Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "green_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "green_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_green_wool",
      "name": "Green Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "green_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "green_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "grindstone",
      "name": "Grindstone",
      "description": "5 ingredients using 3 unique materials.",
      "outputItemId": "grindstone",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "stone_slab",
        "stick",
        "oak_planks",
        null,
        "oak_planks"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "hay_block",
      "name": "Hay Bale",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "hay_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "wheat",
        "wheat",
        "wheat",
        "wheat",
        "wheat",
        "wheat",
        "wheat",
        "wheat",
        "wheat"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "heavy_weighted_pressure_plate",
      "name": "Heavy Weighted Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "heavy_weighted_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "honey_block",
      "name": "Honey Block",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "honey_block",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "honey_bottle",
        "honey_bottle",
        "honey_bottle",
        "honey_bottle"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "honey_bottle",
      "name": "Honey Bottle",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "honey_bottle",
      "outputQuantity": 4,
      "width": 3,
      "height": 2,
      "shaped": false,
      "grid": [
        "honey_block",
        "glass_bottle",
        "glass_bottle",
        "glass_bottle",
        "glass_bottle"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "honeycomb_block",
      "name": "Honeycomb Block",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "honeycomb_block",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "honeycomb",
        "honeycomb",
        "honeycomb",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "hopper",
      "name": "Hopper",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "hopper",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        null,
        "iron_ingot",
        "iron_ingot",
        "chest",
        "iron_ingot",
        null,
        "iron_ingot",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_axe",
      "name": "Iron Axe",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "iron_axe",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_bars",
      "name": "Iron Bars",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "iron_bars",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_boots",
      "name": "Iron Boots",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "iron_boots",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "iron_ingot",
        null,
        "iron_ingot",
        "iron_ingot",
        null,
        "iron_ingot"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_chain",
      "name": "Iron Chain",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "iron_chain",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_nugget",
        "iron_ingot",
        "iron_nugget"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_chestplate",
      "name": "Iron Chestplate",
      "description": "8 ingredients using 1 unique material.",
      "outputItemId": "iron_chestplate",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        null,
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_door",
      "name": "Iron Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "iron_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_helmet",
      "name": "Iron Helmet",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "iron_helmet",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        null,
        "iron_ingot"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_hoe",
      "name": "Iron Hoe",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "iron_hoe",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        null,
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_ingot_from_iron_block",
      "name": "Iron Ingot",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "iron_ingot",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "iron_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_leggings",
      "name": "Iron Leggings",
      "description": "7 ingredients using 1 unique material.",
      "outputItemId": "iron_leggings",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        null,
        "iron_ingot",
        "iron_ingot",
        null,
        "iron_ingot"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_nugget",
      "name": "Iron Nugget",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "iron_nugget",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "iron_ingot"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_pickaxe",
      "name": "Iron Pickaxe",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "iron_pickaxe",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        null,
        "stick",
        null,
        null,
        "stick",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_shovel",
      "name": "Iron Shovel",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "iron_shovel",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "stick",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_spear",
      "name": "Iron Spear",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "iron_spear",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        null,
        "iron_ingot",
        null,
        "stick",
        null,
        "stick",
        null,
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_sword",
      "name": "Iron Sword",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "iron_sword",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "iron_trapdoor",
      "name": "Iron Trapdoor",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "iron_trapdoor",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "item_frame",
      "name": "Item Frame",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "item_frame",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stick",
        "stick",
        "stick",
        "stick",
        "leather",
        "stick",
        "stick",
        "stick",
        "stick"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jack_o_lantern",
      "name": "Jack o'Lantern",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "jack_o_lantern",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "carved_pumpkin",
        "torch"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jukebox",
      "name": "Jukebox",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "jukebox",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "diamond",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_boat",
      "name": "Jungle Boat",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "jungle_boat",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "jungle_planks",
        null,
        "jungle_planks",
        "jungle_planks",
        "jungle_planks",
        "jungle_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_chest_boat",
      "name": "Jungle Boat with Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "jungle_chest_boat",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "chest",
        "jungle_boat"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_button",
      "name": "Jungle Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "jungle_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "jungle_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_door",
      "name": "Jungle Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "jungle_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "jungle_planks",
        "jungle_planks",
        "jungle_planks",
        "jungle_planks",
        "jungle_planks",
        "jungle_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_fence",
      "name": "Jungle Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "jungle_fence",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "jungle_planks",
        "stick",
        "jungle_planks",
        "jungle_planks",
        "stick",
        "jungle_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_fence_gate",
      "name": "Jungle Fence Gate",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "jungle_fence_gate",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "jungle_planks",
        "stick",
        "stick",
        "jungle_planks",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_hanging_sign",
      "name": "Jungle Hanging Sign",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "jungle_hanging_sign",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_chain",
        null,
        "iron_chain",
        "stripped_jungle_log",
        "stripped_jungle_log",
        "stripped_jungle_log",
        "stripped_jungle_log",
        "stripped_jungle_log",
        "stripped_jungle_log"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_planks",
      "name": "Jungle Planks",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "jungle_planks",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "jungle_log"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_pressure_plate",
      "name": "Jungle Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "jungle_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "jungle_planks",
        "jungle_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_shelf",
      "name": "Jungle Shelf",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "jungle_shelf",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stripped_jungle_log",
        "stripped_jungle_log",
        "stripped_jungle_log",
        null,
        null,
        null,
        "stripped_jungle_log",
        "stripped_jungle_log",
        "stripped_jungle_log"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_sign",
      "name": "Jungle Sign",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "jungle_sign",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "jungle_planks",
        "jungle_planks",
        "jungle_planks",
        "jungle_planks",
        "jungle_planks",
        "jungle_planks",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_slab",
      "name": "Jungle Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "jungle_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "jungle_planks",
        "jungle_planks",
        "jungle_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_stairs",
      "name": "Jungle Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "jungle_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "jungle_planks",
        null,
        null,
        "jungle_planks",
        "jungle_planks",
        null,
        "jungle_planks",
        "jungle_planks",
        "jungle_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_trapdoor",
      "name": "Jungle Trapdoor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "jungle_trapdoor",
      "outputQuantity": 2,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "jungle_planks",
        "jungle_planks",
        "jungle_planks",
        "jungle_planks",
        "jungle_planks",
        "jungle_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "jungle_wood",
      "name": "Jungle Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "jungle_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "jungle_log",
        "jungle_log",
        "jungle_log",
        "jungle_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "ladder",
      "name": "Ladder",
      "description": "7 ingredients using 1 unique material.",
      "outputItemId": "ladder",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stick",
        null,
        "stick",
        "stick",
        "stick",
        "stick",
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lantern",
      "name": "Lantern",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "lantern",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_nugget",
        "iron_nugget",
        "iron_nugget",
        "iron_nugget",
        "torch",
        "iron_nugget",
        "iron_nugget",
        "iron_nugget",
        "iron_nugget"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lapis_lazuli",
      "name": "Lapis Lazuli",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "lapis_lazuli",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "lapis_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lead",
      "name": "Lead",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "lead",
      "outputQuantity": 2,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "string",
        "string",
        null,
        "string",
        "string",
        null,
        null,
        null,
        "string"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "leather",
      "name": "Leather",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "leather",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "rabbit_hide",
        "rabbit_hide",
        "rabbit_hide",
        "rabbit_hide"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "leather_boots",
      "name": "Leather Boots",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "leather_boots",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "leather",
        null,
        "leather",
        "leather",
        null,
        "leather"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "leather_helmet",
      "name": "Leather Cap",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "leather_helmet",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "leather",
        "leather",
        "leather",
        "leather",
        null,
        "leather"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "leather_horse_armor",
      "name": "Leather Horse Armor",
      "description": "7 ingredients using 1 unique material.",
      "outputItemId": "leather_horse_armor",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "leather",
        null,
        "leather",
        "leather",
        "leather",
        "leather",
        "leather",
        null,
        "leather"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "leather_leggings",
      "name": "Leather Pants",
      "description": "7 ingredients using 1 unique material.",
      "outputItemId": "leather_leggings",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "leather",
        "leather",
        "leather",
        "leather",
        null,
        "leather",
        "leather",
        null,
        "leather"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "leather_chestplate",
      "name": "Leather Tunic",
      "description": "8 ingredients using 1 unique material.",
      "outputItemId": "leather_chestplate",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "leather",
        null,
        "leather",
        "leather",
        "leather",
        "leather",
        "leather",
        "leather",
        "leather"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lectern",
      "name": "Lectern",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "lectern",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_slab",
        "oak_slab",
        "oak_slab",
        null,
        "bookshelf",
        null,
        null,
        "oak_slab",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lever",
      "name": "Lever",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "lever",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "cobblestone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_blue_banner",
      "name": "Light Blue Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "light_blue_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "light_blue_wool",
        "light_blue_wool",
        "light_blue_wool",
        "light_blue_wool",
        "light_blue_wool",
        "light_blue_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_light_blue_bed",
      "name": "Light Blue Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "light_blue_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "light_blue_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_blue_bundle",
      "name": "Light Blue Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "light_blue_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "light_blue_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_blue_candle",
      "name": "Light Blue Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "light_blue_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "light_blue_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_blue_carpet",
      "name": "Light Blue Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "light_blue_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "light_blue_wool",
        "light_blue_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_blue_concrete_powder",
      "name": "Light Blue Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "light_blue_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "light_blue_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_blue_dye_from_blue_orchid",
      "name": "Light Blue Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "light_blue_dye",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "blue_orchid"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_light_blue_harness",
      "name": "Light Blue Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "light_blue_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "light_blue_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_blue_shulker_box",
      "name": "Light Blue Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "light_blue_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "light_blue_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_blue_stained_glass",
      "name": "Light Blue Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "light_blue_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "light_blue_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_blue_stained_glass_pane",
      "name": "Light Blue Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "light_blue_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "light_blue_stained_glass",
        "light_blue_stained_glass",
        "light_blue_stained_glass",
        "light_blue_stained_glass",
        "light_blue_stained_glass",
        "light_blue_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_blue_terracotta",
      "name": "Light Blue Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "light_blue_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "light_blue_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_light_blue_wool",
      "name": "Light Blue Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "light_blue_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "light_blue_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_gray_banner",
      "name": "Light Gray Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "light_gray_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "light_gray_wool",
        "light_gray_wool",
        "light_gray_wool",
        "light_gray_wool",
        "light_gray_wool",
        "light_gray_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_light_gray_bed",
      "name": "Light Gray Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "light_gray_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "light_gray_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_gray_bundle",
      "name": "Light Gray Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "light_gray_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "light_gray_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_gray_candle",
      "name": "Light Gray Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "light_gray_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "light_gray_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_gray_carpet",
      "name": "Light Gray Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "light_gray_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "light_gray_wool",
        "light_gray_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_gray_concrete_powder",
      "name": "Light Gray Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "light_gray_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "light_gray_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_gray_dye_from_azure_bluet",
      "name": "Light Gray Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "light_gray_dye",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "azure_bluet"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_light_gray_harness",
      "name": "Light Gray Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "light_gray_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "light_gray_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_gray_shulker_box",
      "name": "Light Gray Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "light_gray_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "light_gray_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_gray_stained_glass",
      "name": "Light Gray Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "light_gray_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "light_gray_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_gray_stained_glass_pane",
      "name": "Light Gray Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "light_gray_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "light_gray_stained_glass",
        "light_gray_stained_glass",
        "light_gray_stained_glass",
        "light_gray_stained_glass",
        "light_gray_stained_glass",
        "light_gray_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_gray_terracotta",
      "name": "Light Gray Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "light_gray_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "light_gray_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_light_gray_wool",
      "name": "Light Gray Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "light_gray_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "light_gray_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "light_weighted_pressure_plate",
      "name": "Light Weighted Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "light_weighted_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "gold_ingot",
        "gold_ingot"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lightning_rod",
      "name": "Lightning Rod",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "lightning_rod",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "copper_ingot",
        "copper_ingot",
        "copper_ingot"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lime_banner",
      "name": "Lime Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "lime_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "lime_wool",
        "lime_wool",
        "lime_wool",
        "lime_wool",
        "lime_wool",
        "lime_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_lime_bed",
      "name": "Lime Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "lime_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "lime_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lime_bundle",
      "name": "Lime Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "lime_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "lime_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lime_candle",
      "name": "Lime Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "lime_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "lime_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lime_carpet",
      "name": "Lime Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "lime_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "lime_wool",
        "lime_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lime_concrete_powder",
      "name": "Lime Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "lime_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "lime_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lime_dye",
      "name": "Lime Dye",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "lime_dye",
      "outputQuantity": 2,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "green_dye",
        "white_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_lime_harness",
      "name": "Lime Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "lime_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "lime_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lime_shulker_box",
      "name": "Lime Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "lime_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "lime_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lime_stained_glass",
      "name": "Lime Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "lime_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "lime_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lime_stained_glass_pane",
      "name": "Lime Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "lime_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "lime_stained_glass",
        "lime_stained_glass",
        "lime_stained_glass",
        "lime_stained_glass",
        "lime_stained_glass",
        "lime_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lime_terracotta",
      "name": "Lime Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "lime_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "lime_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_lime_wool",
      "name": "Lime Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "lime_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "lime_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "lodestone",
      "name": "Lodestone",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "lodestone",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "chiseled_stone_bricks",
        "chiseled_stone_bricks",
        "chiseled_stone_bricks",
        "chiseled_stone_bricks",
        "iron_ingot",
        "chiseled_stone_bricks",
        "chiseled_stone_bricks",
        "chiseled_stone_bricks",
        "chiseled_stone_bricks"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "loom",
      "name": "Loom",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "loom",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "string",
        "string",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mace",
      "name": "Mace",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "mace",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        null,
        "heavy_core",
        null,
        null,
        "breeze_rod",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "magenta_banner",
      "name": "Magenta Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "magenta_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "magenta_wool",
        "magenta_wool",
        "magenta_wool",
        "magenta_wool",
        "magenta_wool",
        "magenta_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_magenta_bed",
      "name": "Magenta Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "magenta_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "magenta_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "magenta_bundle",
      "name": "Magenta Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "magenta_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "magenta_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "magenta_candle",
      "name": "Magenta Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "magenta_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "magenta_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "magenta_carpet",
      "name": "Magenta Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "magenta_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "magenta_wool",
        "magenta_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "magenta_concrete_powder",
      "name": "Magenta Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "magenta_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "magenta_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "magenta_dye_from_allium",
      "name": "Magenta Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "magenta_dye",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "allium"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_magenta_harness",
      "name": "Magenta Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "magenta_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "magenta_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "magenta_shulker_box",
      "name": "Magenta Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "magenta_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "magenta_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "magenta_stained_glass",
      "name": "Magenta Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "magenta_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "magenta_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "magenta_stained_glass_pane",
      "name": "Magenta Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "magenta_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "magenta_stained_glass",
        "magenta_stained_glass",
        "magenta_stained_glass",
        "magenta_stained_glass",
        "magenta_stained_glass",
        "magenta_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "magenta_terracotta",
      "name": "Magenta Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "magenta_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "magenta_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_magenta_wool",
      "name": "Magenta Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "magenta_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "magenta_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "magma_block",
      "name": "Magma Block",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "magma_block",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "magma_cream",
        "magma_cream",
        "magma_cream",
        "magma_cream"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "magma_cream",
      "name": "Magma Cream",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "magma_cream",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "blaze_powder",
        "slime_ball"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_boat",
      "name": "Mangrove Boat",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "mangrove_boat",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "mangrove_planks",
        null,
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_chest_boat",
      "name": "Mangrove Boat with Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "mangrove_chest_boat",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "chest",
        "mangrove_boat"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_button",
      "name": "Mangrove Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "mangrove_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "mangrove_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_door",
      "name": "Mangrove Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "mangrove_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_fence",
      "name": "Mangrove Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "mangrove_fence",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "mangrove_planks",
        "stick",
        "mangrove_planks",
        "mangrove_planks",
        "stick",
        "mangrove_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_fence_gate",
      "name": "Mangrove Fence Gate",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "mangrove_fence_gate",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "mangrove_planks",
        "stick",
        "stick",
        "mangrove_planks",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_hanging_sign",
      "name": "Mangrove Hanging Sign",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "mangrove_hanging_sign",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_chain",
        null,
        "iron_chain",
        "stripped_mangrove_log",
        "stripped_mangrove_log",
        "stripped_mangrove_log",
        "stripped_mangrove_log",
        "stripped_mangrove_log",
        "stripped_mangrove_log"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_planks",
      "name": "Mangrove Planks",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "mangrove_planks",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "mangrove_log"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_pressure_plate",
      "name": "Mangrove Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "mangrove_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "mangrove_planks",
        "mangrove_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_shelf",
      "name": "Mangrove Shelf",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "mangrove_shelf",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stripped_mangrove_log",
        "stripped_mangrove_log",
        "stripped_mangrove_log",
        null,
        null,
        null,
        "stripped_mangrove_log",
        "stripped_mangrove_log",
        "stripped_mangrove_log"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_sign",
      "name": "Mangrove Sign",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "mangrove_sign",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_slab",
      "name": "Mangrove Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "mangrove_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_stairs",
      "name": "Mangrove Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "mangrove_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "mangrove_planks",
        null,
        null,
        "mangrove_planks",
        "mangrove_planks",
        null,
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_trapdoor",
      "name": "Mangrove Trapdoor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "mangrove_trapdoor",
      "outputQuantity": 2,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks",
        "mangrove_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mangrove_wood",
      "name": "Mangrove Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "mangrove_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "mangrove_log",
        "mangrove_log",
        "mangrove_log",
        "mangrove_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "melon",
      "name": "Melon",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "melon",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "melon_slice",
        "melon_slice",
        "melon_slice",
        "melon_slice",
        "melon_slice",
        "melon_slice",
        "melon_slice",
        "melon_slice",
        "melon_slice"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "melon_seeds",
      "name": "Melon Seeds",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "melon_seeds",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "melon_slice"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "minecart",
      "name": "Minecart",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "minecart",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "iron_ingot",
        null,
        "iron_ingot",
        "iron_ingot",
        "iron_ingot",
        "iron_ingot"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "chest_minecart",
      "name": "Minecart with Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "chest_minecart",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "chest",
        "minecart"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "furnace_minecart",
      "name": "Minecart with Furnace",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "furnace_minecart",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "furnace",
        "minecart"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "hopper_minecart",
      "name": "Minecart with Hopper",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "hopper_minecart",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "hopper",
        "minecart"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "tnt_minecart",
      "name": "Minecart with TNT",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "tnt_minecart",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "tnt",
        "minecart"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "moss_carpet",
      "name": "Moss Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "moss_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "moss_block",
        "moss_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mossy_cobblestone_from_moss_block",
      "name": "Mossy Cobblestone",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "mossy_cobblestone",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "cobblestone",
        "moss_block"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mossy_cobblestone_slab",
      "name": "Mossy Cobblestone Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "mossy_cobblestone_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "mossy_cobblestone",
        "mossy_cobblestone",
        "mossy_cobblestone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mossy_cobblestone_stairs",
      "name": "Mossy Cobblestone Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "mossy_cobblestone_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "mossy_cobblestone",
        null,
        null,
        "mossy_cobblestone",
        "mossy_cobblestone",
        null,
        "mossy_cobblestone",
        "mossy_cobblestone",
        "mossy_cobblestone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mossy_cobblestone_wall",
      "name": "Mossy Cobblestone Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "mossy_cobblestone_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "mossy_cobblestone",
        "mossy_cobblestone",
        "mossy_cobblestone",
        "mossy_cobblestone",
        "mossy_cobblestone",
        "mossy_cobblestone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mossy_stone_brick_slab",
      "name": "Mossy Stone Brick Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "mossy_stone_brick_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "mossy_stone_bricks",
        "mossy_stone_bricks",
        "mossy_stone_bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mossy_stone_brick_stairs",
      "name": "Mossy Stone Brick Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "mossy_stone_brick_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "mossy_stone_bricks",
        null,
        null,
        "mossy_stone_bricks",
        "mossy_stone_bricks",
        null,
        "mossy_stone_bricks",
        "mossy_stone_bricks",
        "mossy_stone_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mossy_stone_brick_wall",
      "name": "Mossy Stone Brick Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "mossy_stone_brick_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "mossy_stone_bricks",
        "mossy_stone_bricks",
        "mossy_stone_bricks",
        "mossy_stone_bricks",
        "mossy_stone_bricks",
        "mossy_stone_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mossy_stone_bricks_from_moss_block",
      "name": "Mossy Stone Bricks",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "mossy_stone_bricks",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "stone_bricks",
        "moss_block"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mud_brick_slab",
      "name": "Mud Brick Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "mud_brick_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "mud_bricks",
        "mud_bricks",
        "mud_bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mud_brick_stairs",
      "name": "Mud Brick Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "mud_brick_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "mud_bricks",
        null,
        null,
        "mud_bricks",
        "mud_bricks",
        null,
        "mud_bricks",
        "mud_bricks",
        "mud_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mud_brick_wall",
      "name": "Mud Brick Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "mud_brick_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "mud_bricks",
        "mud_bricks",
        "mud_bricks",
        "mud_bricks",
        "mud_bricks",
        "mud_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mud_bricks",
      "name": "Mud Bricks",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "mud_bricks",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "packed_mud",
        "packed_mud",
        "packed_mud",
        "packed_mud"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "muddy_mangrove_roots",
      "name": "Muddy Mangrove Roots",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "muddy_mangrove_roots",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "mud",
        "mangrove_roots"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "mushroom_stew",
      "name": "Mushroom Stew",
      "description": "3 ingredients using 3 unique materials.",
      "outputItemId": "mushroom_stew",
      "outputQuantity": 1,
      "width": 3,
      "height": 1,
      "shaped": false,
      "grid": [
        "brown_mushroom",
        "red_mushroom",
        "bowl"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "music_disc_5",
      "name": "Music Disc",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "music_disc_5",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "disc_fragment_5",
        "disc_fragment_5",
        "disc_fragment_5",
        "disc_fragment_5",
        "disc_fragment_5",
        "disc_fragment_5",
        "disc_fragment_5",
        "disc_fragment_5",
        "disc_fragment_5"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "name_tag",
      "name": "Name Tag",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "name_tag",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        null,
        "copper_nugget",
        "paper",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "nether_brick_fence",
      "name": "Nether Brick Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "nether_brick_fence",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "nether_bricks",
        "nether_brick",
        "nether_bricks",
        "nether_bricks",
        "nether_brick",
        "nether_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "nether_brick_slab",
      "name": "Nether Brick Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "nether_brick_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "nether_bricks",
        "nether_bricks",
        "nether_bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "nether_brick_stairs",
      "name": "Nether Brick Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "nether_brick_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "nether_bricks",
        null,
        null,
        "nether_bricks",
        "nether_bricks",
        null,
        "nether_bricks",
        "nether_bricks",
        "nether_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "nether_brick_wall",
      "name": "Nether Brick Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "nether_brick_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "nether_bricks",
        "nether_bricks",
        "nether_bricks",
        "nether_bricks",
        "nether_bricks",
        "nether_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "nether_bricks",
      "name": "Nether Bricks",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "nether_bricks",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "nether_brick",
        "nether_brick",
        "nether_brick",
        "nether_brick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "nether_wart_block",
      "name": "Nether Wart Block",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "nether_wart_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "nether_wart",
        "nether_wart",
        "nether_wart",
        "nether_wart",
        "nether_wart",
        "nether_wart",
        "nether_wart",
        "nether_wart",
        "nether_wart"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "netherite_ingot_from_netherite_block",
      "name": "Netherite Ingot",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "netherite_ingot",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "netherite_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "note_block",
      "name": "Note Block",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "note_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "redstone",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_boat",
      "name": "Oak Boat",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "oak_boat",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "oak_planks",
        null,
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_chest_boat",
      "name": "Oak Boat with Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "oak_chest_boat",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "chest",
        "oak_boat"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_button",
      "name": "Oak Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "oak_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "oak_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_door",
      "name": "Oak Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "oak_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_fence",
      "name": "Oak Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "oak_fence",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "oak_planks",
        "stick",
        "oak_planks",
        "oak_planks",
        "stick",
        "oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_fence_gate",
      "name": "Oak Fence Gate",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "oak_fence_gate",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "oak_planks",
        "stick",
        "stick",
        "oak_planks",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_hanging_sign",
      "name": "Oak Hanging Sign",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "oak_hanging_sign",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_chain",
        null,
        "iron_chain",
        "stripped_oak_log",
        "stripped_oak_log",
        "stripped_oak_log",
        "stripped_oak_log",
        "stripped_oak_log",
        "stripped_oak_log"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_planks",
      "name": "Oak Planks",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "oak_planks",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "oak_log"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_pressure_plate",
      "name": "Oak Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "oak_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_shelf",
      "name": "Oak Shelf",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "oak_shelf",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stripped_oak_log",
        "stripped_oak_log",
        "stripped_oak_log",
        null,
        null,
        null,
        "stripped_oak_log",
        "stripped_oak_log",
        "stripped_oak_log"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_sign",
      "name": "Oak Sign",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "oak_sign",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_slab",
      "name": "Oak Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "oak_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_stairs",
      "name": "Oak Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "oak_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        null,
        null,
        "oak_planks",
        "oak_planks",
        null,
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_trapdoor",
      "name": "Oak Trapdoor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "oak_trapdoor",
      "outputQuantity": 2,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oak_wood",
      "name": "Oak Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "oak_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "oak_log",
        "oak_log",
        "oak_log",
        "oak_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "observer",
      "name": "Observer",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "observer",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "cobblestone",
        "cobblestone",
        "cobblestone",
        "redstone",
        "redstone",
        "quartz",
        "cobblestone",
        "cobblestone",
        "cobblestone"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "orange_banner",
      "name": "Orange Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "orange_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "orange_wool",
        "orange_wool",
        "orange_wool",
        "orange_wool",
        "orange_wool",
        "orange_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_orange_bed",
      "name": "Orange Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "orange_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "orange_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "orange_bundle",
      "name": "Orange Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "orange_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "orange_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "orange_candle",
      "name": "Orange Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "orange_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "orange_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "orange_carpet",
      "name": "Orange Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "orange_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "orange_wool",
        "orange_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "orange_concrete_powder",
      "name": "Orange Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "orange_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "orange_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "orange_dye_from_open_eyeblossom",
      "name": "Orange Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "orange_dye",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "open_eyeblossom"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_orange_harness",
      "name": "Orange Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "orange_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "orange_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "orange_shulker_box",
      "name": "Orange Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "orange_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "orange_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "orange_stained_glass",
      "name": "Orange Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "orange_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "orange_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "orange_stained_glass_pane",
      "name": "Orange Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "orange_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "orange_stained_glass",
        "orange_stained_glass",
        "orange_stained_glass",
        "orange_stained_glass",
        "orange_stained_glass",
        "orange_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "orange_terracotta",
      "name": "Orange Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "orange_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "orange_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_orange_wool",
      "name": "Orange Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "orange_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "orange_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oxidized_chiseled_copper",
      "name": "Oxidized Chiseled Copper",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "oxidized_chiseled_copper",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "oxidized_cut_copper_slab",
        "oxidized_cut_copper_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oxidized_copper_bulb",
      "name": "Oxidized Copper Bulb",
      "description": "5 ingredients using 3 unique materials.",
      "outputItemId": "oxidized_copper_bulb",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "oxidized_copper",
        null,
        "oxidized_copper",
        "blaze_rod",
        "oxidized_copper",
        null,
        "redstone",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oxidized_copper_grate",
      "name": "Oxidized Copper Grate",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "oxidized_copper_grate",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "oxidized_copper",
        null,
        "oxidized_copper",
        null,
        "oxidized_copper",
        null,
        "oxidized_copper",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oxidized_cut_copper",
      "name": "Oxidized Cut Copper",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "oxidized_cut_copper",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "oxidized_copper",
        "oxidized_copper",
        "oxidized_copper",
        "oxidized_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oxidized_cut_copper_slab",
      "name": "Oxidized Cut Copper Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "oxidized_cut_copper_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "oxidized_cut_copper",
        "oxidized_cut_copper",
        "oxidized_cut_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "oxidized_cut_copper_stairs",
      "name": "Oxidized Cut Copper Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "oxidized_cut_copper_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oxidized_cut_copper",
        null,
        null,
        "oxidized_cut_copper",
        "oxidized_cut_copper",
        null,
        "oxidized_cut_copper",
        "oxidized_cut_copper",
        "oxidized_cut_copper"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "packed_ice",
      "name": "Packed Ice",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "packed_ice",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "ice",
        "ice",
        "ice",
        "ice",
        "ice",
        "ice",
        "ice",
        "ice",
        "ice"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "packed_mud",
      "name": "Packed Mud",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "packed_mud",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "mud",
        "wheat"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "painting",
      "name": "Painting",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "painting",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stick",
        "stick",
        "stick",
        "stick",
        "white_wool",
        "stick",
        "stick",
        "stick",
        "stick"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_moss_carpet",
      "name": "Pale Moss Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "pale_moss_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "pale_moss_block",
        "pale_moss_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_boat",
      "name": "Pale Oak Boat",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "pale_oak_boat",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "pale_oak_planks",
        null,
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_chest_boat",
      "name": "Pale Oak Boat with Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "pale_oak_chest_boat",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "chest",
        "pale_oak_boat"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_button",
      "name": "Pale Oak Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "pale_oak_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "pale_oak_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_door",
      "name": "Pale Oak Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "pale_oak_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_fence",
      "name": "Pale Oak Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "pale_oak_fence",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "pale_oak_planks",
        "stick",
        "pale_oak_planks",
        "pale_oak_planks",
        "stick",
        "pale_oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_fence_gate",
      "name": "Pale Oak Fence Gate",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "pale_oak_fence_gate",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "pale_oak_planks",
        "stick",
        "stick",
        "pale_oak_planks",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_hanging_sign",
      "name": "Pale Oak Hanging Sign",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "pale_oak_hanging_sign",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_chain",
        null,
        "iron_chain",
        "stripped_pale_oak_log",
        "stripped_pale_oak_log",
        "stripped_pale_oak_log",
        "stripped_pale_oak_log",
        "stripped_pale_oak_log",
        "stripped_pale_oak_log"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_planks",
      "name": "Pale Oak Planks",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "pale_oak_planks",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "pale_oak_log"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_pressure_plate",
      "name": "Pale Oak Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "pale_oak_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "pale_oak_planks",
        "pale_oak_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_shelf",
      "name": "Pale Oak Shelf",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "pale_oak_shelf",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stripped_pale_oak_log",
        "stripped_pale_oak_log",
        "stripped_pale_oak_log",
        null,
        null,
        null,
        "stripped_pale_oak_log",
        "stripped_pale_oak_log",
        "stripped_pale_oak_log"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_sign",
      "name": "Pale Oak Sign",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "pale_oak_sign",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_slab",
      "name": "Pale Oak Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "pale_oak_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_stairs",
      "name": "Pale Oak Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "pale_oak_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "pale_oak_planks",
        null,
        null,
        "pale_oak_planks",
        "pale_oak_planks",
        null,
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_trapdoor",
      "name": "Pale Oak Trapdoor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "pale_oak_trapdoor",
      "outputQuantity": 2,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks",
        "pale_oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pale_oak_wood",
      "name": "Pale Oak Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "pale_oak_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "pale_oak_log",
        "pale_oak_log",
        "pale_oak_log",
        "pale_oak_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "paper",
      "name": "Paper",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "paper",
      "outputQuantity": 3,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "sugar_cane",
        "sugar_cane",
        "sugar_cane"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pink_banner",
      "name": "Pink Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "pink_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "pink_wool",
        "pink_wool",
        "pink_wool",
        "pink_wool",
        "pink_wool",
        "pink_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_pink_bed",
      "name": "Pink Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "pink_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "pink_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pink_bundle",
      "name": "Pink Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "pink_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "pink_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pink_candle",
      "name": "Pink Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "pink_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "pink_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pink_carpet",
      "name": "Pink Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "pink_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "pink_wool",
        "pink_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pink_concrete_powder",
      "name": "Pink Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "pink_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "pink_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pink_dye_from_cactus_flower",
      "name": "Pink Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "pink_dye",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "cactus_flower"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_pink_harness",
      "name": "Pink Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "pink_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "pink_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pink_shulker_box",
      "name": "Pink Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "pink_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "pink_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pink_stained_glass",
      "name": "Pink Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "pink_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "pink_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pink_stained_glass_pane",
      "name": "Pink Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "pink_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "pink_stained_glass",
        "pink_stained_glass",
        "pink_stained_glass",
        "pink_stained_glass",
        "pink_stained_glass",
        "pink_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pink_terracotta",
      "name": "Pink Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "pink_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "pink_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_pink_wool",
      "name": "Pink Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "pink_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "pink_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "piston",
      "name": "Piston",
      "description": "9 ingredients using 4 unique materials.",
      "outputItemId": "piston",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "cobblestone",
        "iron_ingot",
        "cobblestone",
        "cobblestone",
        "redstone",
        "cobblestone"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_andesite",
      "name": "Polished Andesite",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "polished_andesite",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "andesite",
        "andesite",
        "andesite",
        "andesite"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_andesite_slab",
      "name": "Polished Andesite Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "polished_andesite_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "polished_andesite",
        "polished_andesite",
        "polished_andesite"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_andesite_stairs",
      "name": "Polished Andesite Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "polished_andesite_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "polished_andesite",
        null,
        null,
        "polished_andesite",
        "polished_andesite",
        null,
        "polished_andesite",
        "polished_andesite",
        "polished_andesite"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_basalt",
      "name": "Polished Basalt",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "polished_basalt",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "basalt",
        "basalt",
        "basalt",
        "basalt"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_blackstone",
      "name": "Polished Blackstone",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "polished_blackstone",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "blackstone",
        "blackstone",
        "blackstone",
        "blackstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_blackstone_brick_slab",
      "name": "Polished Blackstone Brick Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "polished_blackstone_brick_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "polished_blackstone_bricks",
        "polished_blackstone_bricks",
        "polished_blackstone_bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_blackstone_brick_stairs",
      "name": "Polished Blackstone Brick Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "polished_blackstone_brick_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "polished_blackstone_bricks",
        null,
        null,
        "polished_blackstone_bricks",
        "polished_blackstone_bricks",
        null,
        "polished_blackstone_bricks",
        "polished_blackstone_bricks",
        "polished_blackstone_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_blackstone_brick_wall",
      "name": "Polished Blackstone Brick Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "polished_blackstone_brick_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "polished_blackstone_bricks",
        "polished_blackstone_bricks",
        "polished_blackstone_bricks",
        "polished_blackstone_bricks",
        "polished_blackstone_bricks",
        "polished_blackstone_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_blackstone_bricks",
      "name": "Polished Blackstone Bricks",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "polished_blackstone_bricks",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "polished_blackstone",
        "polished_blackstone",
        "polished_blackstone",
        "polished_blackstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_blackstone_button",
      "name": "Polished Blackstone Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "polished_blackstone_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "polished_blackstone"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_blackstone_pressure_plate",
      "name": "Polished Blackstone Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "polished_blackstone_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "polished_blackstone",
        "polished_blackstone"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_blackstone_slab",
      "name": "Polished Blackstone Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "polished_blackstone_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "polished_blackstone",
        "polished_blackstone",
        "polished_blackstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_blackstone_stairs",
      "name": "Polished Blackstone Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "polished_blackstone_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "polished_blackstone",
        null,
        null,
        "polished_blackstone",
        "polished_blackstone",
        null,
        "polished_blackstone",
        "polished_blackstone",
        "polished_blackstone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_blackstone_wall",
      "name": "Polished Blackstone Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "polished_blackstone_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "polished_blackstone",
        "polished_blackstone",
        "polished_blackstone",
        "polished_blackstone",
        "polished_blackstone",
        "polished_blackstone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_deepslate",
      "name": "Polished Deepslate",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "polished_deepslate",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "cobbled_deepslate",
        "cobbled_deepslate",
        "cobbled_deepslate",
        "cobbled_deepslate"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_deepslate_slab",
      "name": "Polished Deepslate Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "polished_deepslate_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "polished_deepslate",
        "polished_deepslate",
        "polished_deepslate"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_deepslate_stairs",
      "name": "Polished Deepslate Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "polished_deepslate_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "polished_deepslate",
        null,
        null,
        "polished_deepslate",
        "polished_deepslate",
        null,
        "polished_deepslate",
        "polished_deepslate",
        "polished_deepslate"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_deepslate_wall",
      "name": "Polished Deepslate Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "polished_deepslate_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "polished_deepslate",
        "polished_deepslate",
        "polished_deepslate",
        "polished_deepslate",
        "polished_deepslate",
        "polished_deepslate"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_diorite",
      "name": "Polished Diorite",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "polished_diorite",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "diorite",
        "diorite",
        "diorite",
        "diorite"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_diorite_slab",
      "name": "Polished Diorite Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "polished_diorite_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "polished_diorite",
        "polished_diorite",
        "polished_diorite"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_diorite_stairs",
      "name": "Polished Diorite Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "polished_diorite_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "polished_diorite",
        null,
        null,
        "polished_diorite",
        "polished_diorite",
        null,
        "polished_diorite",
        "polished_diorite",
        "polished_diorite"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_granite",
      "name": "Polished Granite",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "polished_granite",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "granite",
        "granite",
        "granite",
        "granite"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_granite_slab",
      "name": "Polished Granite Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "polished_granite_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "polished_granite",
        "polished_granite",
        "polished_granite"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_granite_stairs",
      "name": "Polished Granite Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "polished_granite_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "polished_granite",
        null,
        null,
        "polished_granite",
        "polished_granite",
        null,
        "polished_granite",
        "polished_granite",
        "polished_granite"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_tuff",
      "name": "Polished Tuff",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "polished_tuff",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "tuff",
        "tuff",
        "tuff",
        "tuff"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_tuff_slab",
      "name": "Polished Tuff Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "polished_tuff_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "polished_tuff",
        "polished_tuff",
        "polished_tuff"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_tuff_stairs",
      "name": "Polished Tuff Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "polished_tuff_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "polished_tuff",
        null,
        null,
        "polished_tuff",
        "polished_tuff",
        null,
        "polished_tuff",
        "polished_tuff",
        "polished_tuff"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "polished_tuff_wall",
      "name": "Polished Tuff Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "polished_tuff_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "polished_tuff",
        "polished_tuff",
        "polished_tuff",
        "polished_tuff",
        "polished_tuff",
        "polished_tuff"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "powered_rail",
      "name": "Powered Rail",
      "description": "8 ingredients using 3 unique materials.",
      "outputItemId": "powered_rail",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "gold_ingot",
        null,
        "gold_ingot",
        "gold_ingot",
        "stick",
        "gold_ingot",
        "gold_ingot",
        "redstone",
        "gold_ingot"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "prismarine",
      "name": "Prismarine",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "prismarine",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "prismarine_brick_slab",
      "name": "Prismarine Brick Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "prismarine_brick_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "prismarine_bricks",
        "prismarine_bricks",
        "prismarine_bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "prismarine_brick_stairs",
      "name": "Prismarine Brick Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "prismarine_brick_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "prismarine_bricks",
        null,
        null,
        "prismarine_bricks",
        "prismarine_bricks",
        null,
        "prismarine_bricks",
        "prismarine_bricks",
        "prismarine_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "prismarine_bricks",
      "name": "Prismarine Bricks",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "prismarine_bricks",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard",
        "prismarine_shard"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "prismarine_slab",
      "name": "Prismarine Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "prismarine_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "prismarine",
        "prismarine",
        "prismarine"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "prismarine_stairs",
      "name": "Prismarine Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "prismarine_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "prismarine",
        null,
        null,
        "prismarine",
        "prismarine",
        null,
        "prismarine",
        "prismarine",
        "prismarine"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "prismarine_wall",
      "name": "Prismarine Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "prismarine_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "prismarine",
        "prismarine",
        "prismarine",
        "prismarine",
        "prismarine",
        "prismarine"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pumpkin_pie",
      "name": "Pumpkin Pie",
      "description": "3 ingredients using 3 unique materials.",
      "outputItemId": "pumpkin_pie",
      "outputQuantity": 1,
      "width": 3,
      "height": 1,
      "shaped": false,
      "grid": [
        "pumpkin",
        "sugar",
        "egg"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "pumpkin_seeds",
      "name": "Pumpkin Seeds",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "pumpkin_seeds",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "pumpkin"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purple_banner",
      "name": "Purple Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "purple_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "purple_wool",
        "purple_wool",
        "purple_wool",
        "purple_wool",
        "purple_wool",
        "purple_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_purple_bed",
      "name": "Purple Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "purple_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "purple_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purple_bundle",
      "name": "Purple Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "purple_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "purple_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purple_candle",
      "name": "Purple Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "purple_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "purple_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purple_carpet",
      "name": "Purple Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "purple_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "purple_wool",
        "purple_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purple_concrete_powder",
      "name": "Purple Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "purple_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "purple_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purple_dye",
      "name": "Purple Dye",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "purple_dye",
      "outputQuantity": 2,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "blue_dye",
        "red_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_purple_harness",
      "name": "Purple Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "purple_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "purple_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purple_shulker_box",
      "name": "Purple Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "purple_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "purple_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purple_stained_glass",
      "name": "Purple Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "purple_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "purple_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purple_stained_glass_pane",
      "name": "Purple Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "purple_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "purple_stained_glass",
        "purple_stained_glass",
        "purple_stained_glass",
        "purple_stained_glass",
        "purple_stained_glass",
        "purple_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purple_terracotta",
      "name": "Purple Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "purple_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "purple_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_purple_wool",
      "name": "Purple Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "purple_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "purple_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purpur_block",
      "name": "Purpur Block",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "purpur_block",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "popped_chorus_fruit",
        "popped_chorus_fruit",
        "popped_chorus_fruit",
        "popped_chorus_fruit"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purpur_pillar",
      "name": "Purpur Pillar",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "purpur_pillar",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "purpur_slab",
        "purpur_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purpur_slab",
      "name": "Purpur Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "purpur_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "purpur_block",
        "purpur_block",
        "purpur_block"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "purpur_stairs",
      "name": "Purpur Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "purpur_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "purpur_block",
        null,
        null,
        "purpur_block",
        "purpur_block",
        null,
        "purpur_block",
        "purpur_block",
        "purpur_block"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "quartz_bricks",
      "name": "Quartz Bricks",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "quartz_bricks",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "quartz_block",
        "quartz_block",
        "quartz_block",
        "quartz_block"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "quartz_pillar",
      "name": "Quartz Pillar",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "quartz_pillar",
      "outputQuantity": 2,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "quartz_block",
        "quartz_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "quartz_slab",
      "name": "Quartz Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "quartz_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "chiseled_quartz_block",
        "chiseled_quartz_block",
        "chiseled_quartz_block"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "quartz_stairs",
      "name": "Quartz Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "quartz_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "chiseled_quartz_block",
        null,
        null,
        "chiseled_quartz_block",
        "chiseled_quartz_block",
        null,
        "chiseled_quartz_block",
        "chiseled_quartz_block",
        "chiseled_quartz_block"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "rabbit_stew_from_brown_mushroom",
      "name": "Rabbit Stew",
      "description": "5 ingredients using 5 unique materials.",
      "outputItemId": "rabbit_stew",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": false,
      "grid": [
        "baked_potato",
        "cooked_rabbit",
        "bowl",
        "carrot",
        "brown_mushroom"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "rail",
      "name": "Rail",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "rail",
      "outputQuantity": 16,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        null,
        "iron_ingot",
        "iron_ingot",
        "stick",
        "iron_ingot",
        "iron_ingot",
        null,
        "iron_ingot"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "raw_copper",
      "name": "Raw Copper",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "raw_copper",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "raw_copper_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "raw_gold",
      "name": "Raw Gold",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "raw_gold",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "raw_gold_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "raw_iron",
      "name": "Raw Iron",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "raw_iron",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "raw_iron_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "recovery_compass",
      "name": "Recovery Compass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "recovery_compass",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "echo_shard",
        "echo_shard",
        "echo_shard",
        "echo_shard",
        "compass",
        "echo_shard",
        "echo_shard",
        "echo_shard",
        "echo_shard"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_banner",
      "name": "Red Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "red_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "red_wool",
        "red_wool",
        "red_wool",
        "red_wool",
        "red_wool",
        "red_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_red_bed",
      "name": "Red Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "red_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "red_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_bundle",
      "name": "Red Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "red_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "red_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_candle",
      "name": "Red Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "red_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "red_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_carpet",
      "name": "Red Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "red_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "red_wool",
        "red_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_concrete_powder",
      "name": "Red Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "red_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "red_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_dye_from_beetroot",
      "name": "Red Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "red_dye",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "beetroot"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_red_harness",
      "name": "Red Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "red_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "red_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_nether_brick_slab",
      "name": "Red Nether Brick Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "red_nether_brick_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "red_nether_bricks",
        "red_nether_bricks",
        "red_nether_bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_nether_brick_stairs",
      "name": "Red Nether Brick Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "red_nether_brick_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "red_nether_bricks",
        null,
        null,
        "red_nether_bricks",
        "red_nether_bricks",
        null,
        "red_nether_bricks",
        "red_nether_bricks",
        "red_nether_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_nether_brick_wall",
      "name": "Red Nether Brick Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "red_nether_brick_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "red_nether_bricks",
        "red_nether_bricks",
        "red_nether_bricks",
        "red_nether_bricks",
        "red_nether_bricks",
        "red_nether_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_nether_bricks",
      "name": "Red Nether Bricks",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "red_nether_bricks",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "nether_brick",
        "nether_wart",
        "nether_wart",
        "nether_brick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_sandstone",
      "name": "Red Sandstone",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "red_sandstone",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "red_sand",
        "red_sand",
        "red_sand",
        "red_sand"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_sandstone_slab",
      "name": "Red Sandstone Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "red_sandstone_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "red_sandstone",
        "red_sandstone",
        "red_sandstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_sandstone_stairs",
      "name": "Red Sandstone Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "red_sandstone_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "red_sandstone",
        null,
        null,
        "red_sandstone",
        "red_sandstone",
        null,
        "red_sandstone",
        "red_sandstone",
        "red_sandstone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_sandstone_wall",
      "name": "Red Sandstone Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "red_sandstone_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "red_sandstone",
        "red_sandstone",
        "red_sandstone",
        "red_sandstone",
        "red_sandstone",
        "red_sandstone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_shulker_box",
      "name": "Red Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "red_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "red_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_stained_glass",
      "name": "Red Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "red_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "red_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_stained_glass_pane",
      "name": "Red Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "red_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "red_stained_glass",
        "red_stained_glass",
        "red_stained_glass",
        "red_stained_glass",
        "red_stained_glass",
        "red_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "red_terracotta",
      "name": "Red Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "red_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "red_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_red_wool",
      "name": "Red Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "red_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "red_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "comparator",
      "name": "Redstone Comparator",
      "description": "7 ingredients using 3 unique materials.",
      "outputItemId": "comparator",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "redstone_torch",
        null,
        "redstone_torch",
        "quartz",
        "redstone_torch",
        "stone",
        "stone",
        "stone"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "redstone",
      "name": "Redstone Dust",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "redstone",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "redstone_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "redstone_lamp",
      "name": "Redstone Lamp",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "redstone_lamp",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "redstone",
        null,
        "redstone",
        "glowstone",
        "redstone",
        null,
        "redstone",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "repeater",
      "name": "Redstone Repeater",
      "description": "6 ingredients using 3 unique materials.",
      "outputItemId": "repeater",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "redstone_torch",
        "redstone",
        "redstone_torch",
        "stone",
        "stone",
        "stone"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "redstone_torch",
      "name": "Redstone Torch",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "redstone_torch",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "redstone",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "resin_brick_slab",
      "name": "Resin Brick Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "resin_brick_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "resin_bricks",
        "resin_bricks",
        "resin_bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "resin_brick_stairs",
      "name": "Resin Brick Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "resin_brick_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "resin_bricks",
        null,
        null,
        "resin_bricks",
        "resin_bricks",
        null,
        "resin_bricks",
        "resin_bricks",
        "resin_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "resin_brick_wall",
      "name": "Resin Brick Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "resin_brick_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "resin_bricks",
        "resin_bricks",
        "resin_bricks",
        "resin_bricks",
        "resin_bricks",
        "resin_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "resin_bricks",
      "name": "Resin Bricks",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "resin_bricks",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "resin_brick",
        "resin_brick",
        "resin_brick",
        "resin_brick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "resin_clump",
      "name": "Resin Clump",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "resin_clump",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "resin_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "respawn_anchor",
      "name": "Respawn Anchor",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "respawn_anchor",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "crying_obsidian",
        "crying_obsidian",
        "crying_obsidian",
        "glowstone",
        "glowstone",
        "glowstone",
        "crying_obsidian",
        "crying_obsidian",
        "crying_obsidian"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "saddle",
      "name": "Saddle",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "saddle",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        null,
        "leather",
        null,
        "leather",
        "iron_ingot",
        "leather"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "sandstone",
      "name": "Sandstone",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "sandstone",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "sand",
        "sand",
        "sand",
        "sand"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "sandstone_slab",
      "name": "Sandstone Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "sandstone_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "sandstone",
        "sandstone",
        "sandstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "sandstone_stairs",
      "name": "Sandstone Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "sandstone_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "sandstone",
        null,
        null,
        "sandstone",
        "sandstone",
        null,
        "sandstone",
        "sandstone",
        "sandstone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "sandstone_wall",
      "name": "Sandstone Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "sandstone_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "sandstone",
        "sandstone",
        "sandstone",
        "sandstone",
        "sandstone",
        "sandstone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "scaffolding",
      "name": "Scaffolding",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "scaffolding",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "bamboo",
        "string",
        "bamboo",
        "bamboo",
        null,
        "bamboo",
        "bamboo",
        null,
        "bamboo"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "sea_lantern",
      "name": "Sea Lantern",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "sea_lantern",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "prismarine_shard",
        "prismarine_crystals",
        "prismarine_shard",
        "prismarine_crystals",
        "prismarine_crystals",
        "prismarine_crystals",
        "prismarine_shard",
        "prismarine_crystals",
        "prismarine_shard"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "shears",
      "name": "Shears",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "shears",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        null,
        "iron_ingot",
        "iron_ingot",
        null
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "shield",
      "name": "Shield",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "shield",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "iron_ingot",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        null,
        "oak_planks",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "shulker_box",
      "name": "Shulker Box",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "shulker_box",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "shulker_shell",
        "chest",
        "shulker_shell"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "slime_block",
      "name": "Slime Block",
      "description": "9 ingredients using 1 unique material.",
      "outputItemId": "slime_block",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "slime_ball",
        "slime_ball",
        "slime_ball",
        "slime_ball",
        "slime_ball",
        "slime_ball",
        "slime_ball",
        "slime_ball",
        "slime_ball"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "slime_ball",
      "name": "Slimeball",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "slime_ball",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "slime_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "smithing_table",
      "name": "Smithing Table",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "smithing_table",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "iron_ingot",
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "smoker",
      "name": "Smoker",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "smoker",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "dark_oak_log",
        null,
        "dark_oak_log",
        "furnace",
        "dark_oak_log",
        null,
        "dark_oak_log",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "smooth_quartz_slab",
      "name": "Smooth Quartz Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "smooth_quartz_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "smooth_quartz",
        "smooth_quartz",
        "smooth_quartz"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "smooth_quartz_stairs",
      "name": "Smooth Quartz Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "smooth_quartz_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "smooth_quartz",
        null,
        null,
        "smooth_quartz",
        "smooth_quartz",
        null,
        "smooth_quartz",
        "smooth_quartz",
        "smooth_quartz"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "smooth_red_sandstone_slab",
      "name": "Smooth Red Sandstone Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "smooth_red_sandstone_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "smooth_red_sandstone",
        "smooth_red_sandstone",
        "smooth_red_sandstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "smooth_red_sandstone_stairs",
      "name": "Smooth Red Sandstone Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "smooth_red_sandstone_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "smooth_red_sandstone",
        null,
        null,
        "smooth_red_sandstone",
        "smooth_red_sandstone",
        null,
        "smooth_red_sandstone",
        "smooth_red_sandstone",
        "smooth_red_sandstone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "smooth_sandstone_slab",
      "name": "Smooth Sandstone Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "smooth_sandstone_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "smooth_sandstone",
        "smooth_sandstone",
        "smooth_sandstone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "smooth_sandstone_stairs",
      "name": "Smooth Sandstone Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "smooth_sandstone_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "smooth_sandstone",
        null,
        null,
        "smooth_sandstone",
        "smooth_sandstone",
        null,
        "smooth_sandstone",
        "smooth_sandstone",
        "smooth_sandstone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "smooth_stone_slab",
      "name": "Smooth Stone Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "smooth_stone_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "smooth_stone",
        "smooth_stone",
        "smooth_stone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "snow",
      "name": "Snow",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "snow",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "snow_block",
        "snow_block",
        "snow_block"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "snow_block",
      "name": "Snow Block",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "snow_block",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "snowball",
        "snowball",
        "snowball",
        "snowball"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "soul_campfire",
      "name": "Soul Campfire",
      "description": "7 ingredients using 3 unique materials.",
      "outputItemId": "soul_campfire",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "stick",
        null,
        "stick",
        "soul_sand",
        "stick",
        "dark_oak_log",
        "dark_oak_log",
        "dark_oak_log"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "soul_lantern",
      "name": "Soul Lantern",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "soul_lantern",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_nugget",
        "iron_nugget",
        "iron_nugget",
        "iron_nugget",
        "soul_torch",
        "iron_nugget",
        "iron_nugget",
        "iron_nugget",
        "iron_nugget"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "soul_torch",
      "name": "Soul Torch",
      "description": "3 ingredients using 3 unique materials.",
      "outputItemId": "soul_torch",
      "outputQuantity": 4,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "coal",
        "stick",
        "soul_sand"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spectral_arrow",
      "name": "Spectral Arrow",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "spectral_arrow",
      "outputQuantity": 2,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "glowstone_dust",
        null,
        "glowstone_dust",
        "arrow",
        "glowstone_dust",
        null,
        "glowstone_dust",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_boat",
      "name": "Spruce Boat",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "spruce_boat",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "spruce_planks",
        null,
        "spruce_planks",
        "spruce_planks",
        "spruce_planks",
        "spruce_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_chest_boat",
      "name": "Spruce Boat with Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "spruce_chest_boat",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "chest",
        "spruce_boat"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_button",
      "name": "Spruce Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "spruce_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "spruce_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_door",
      "name": "Spruce Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "spruce_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "spruce_planks",
        "spruce_planks",
        "spruce_planks",
        "spruce_planks",
        "spruce_planks",
        "spruce_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_fence",
      "name": "Spruce Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "spruce_fence",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "spruce_planks",
        "stick",
        "spruce_planks",
        "spruce_planks",
        "stick",
        "spruce_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_fence_gate",
      "name": "Spruce Fence Gate",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "spruce_fence_gate",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "spruce_planks",
        "stick",
        "stick",
        "spruce_planks",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_hanging_sign",
      "name": "Spruce Hanging Sign",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "spruce_hanging_sign",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_chain",
        null,
        "iron_chain",
        "stripped_spruce_log",
        "stripped_spruce_log",
        "stripped_spruce_log",
        "stripped_spruce_log",
        "stripped_spruce_log",
        "stripped_spruce_log"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_planks",
      "name": "Spruce Planks",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "spruce_planks",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "spruce_log"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_pressure_plate",
      "name": "Spruce Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "spruce_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "spruce_planks",
        "spruce_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_shelf",
      "name": "Spruce Shelf",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "spruce_shelf",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stripped_spruce_log",
        "stripped_spruce_log",
        "stripped_spruce_log",
        null,
        null,
        null,
        "stripped_spruce_log",
        "stripped_spruce_log",
        "stripped_spruce_log"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_sign",
      "name": "Spruce Sign",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "spruce_sign",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "spruce_planks",
        "spruce_planks",
        "spruce_planks",
        "spruce_planks",
        "spruce_planks",
        "spruce_planks",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_slab",
      "name": "Spruce Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "spruce_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "spruce_planks",
        "spruce_planks",
        "spruce_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_stairs",
      "name": "Spruce Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "spruce_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "spruce_planks",
        null,
        null,
        "spruce_planks",
        "spruce_planks",
        null,
        "spruce_planks",
        "spruce_planks",
        "spruce_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_trapdoor",
      "name": "Spruce Trapdoor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "spruce_trapdoor",
      "outputQuantity": 2,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "spruce_planks",
        "spruce_planks",
        "spruce_planks",
        "spruce_planks",
        "spruce_planks",
        "spruce_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spruce_wood",
      "name": "Spruce Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "spruce_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "spruce_log",
        "spruce_log",
        "spruce_log",
        "spruce_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "spyglass",
      "name": "Spyglass",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "spyglass",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "amethyst_shard",
        null,
        null,
        "copper_ingot",
        null,
        null,
        "copper_ingot",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stick",
      "name": "Stick",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "stick",
      "outputQuantity": 4,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "sticky_piston",
      "name": "Sticky Piston",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "sticky_piston",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "slime_ball",
        "piston"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_axe",
      "name": "Stone Axe",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "stone_axe",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "cobblestone",
        "cobblestone",
        "cobblestone",
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_brick_slab",
      "name": "Stone Brick Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "stone_brick_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "stone_bricks",
        "stone_bricks",
        "stone_bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_brick_stairs",
      "name": "Stone Brick Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "stone_brick_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stone_bricks",
        null,
        null,
        "stone_bricks",
        "stone_bricks",
        null,
        "stone_bricks",
        "stone_bricks",
        "stone_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_brick_wall",
      "name": "Stone Brick Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "stone_brick_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stone_bricks",
        "stone_bricks",
        "stone_bricks",
        "stone_bricks",
        "stone_bricks",
        "stone_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_bricks",
      "name": "Stone Bricks",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "stone_bricks",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "stone",
        "stone",
        "stone",
        "stone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_button",
      "name": "Stone Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "stone_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "stone"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_hoe",
      "name": "Stone Hoe",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "stone_hoe",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "cobblestone",
        "cobblestone",
        null,
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_pickaxe",
      "name": "Stone Pickaxe",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "stone_pickaxe",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "cobblestone",
        "cobblestone",
        "cobblestone",
        null,
        "stick",
        null,
        null,
        "stick",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_pressure_plate",
      "name": "Stone Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "stone_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "stone",
        "stone"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_shovel",
      "name": "Stone Shovel",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "stone_shovel",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "cobblestone",
        "stick",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_slab",
      "name": "Stone Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "stone_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "stone",
        "stone",
        "stone"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_spear",
      "name": "Stone Spear",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "stone_spear",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        null,
        "cobblestone",
        null,
        "stick",
        null,
        "stick",
        null,
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_stairs",
      "name": "Stone Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "stone_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stone",
        null,
        null,
        "stone",
        "stone",
        null,
        "stone",
        "stone",
        "stone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stone_sword",
      "name": "Stone Sword",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "stone_sword",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "cobblestone",
        "cobblestone",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stonecutter",
      "name": "Stonecutter",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "stonecutter",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        null,
        "iron_ingot",
        null,
        "stone",
        "stone",
        "stone"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stripped_acacia_wood",
      "name": "Stripped Acacia Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "stripped_acacia_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "stripped_acacia_log",
        "stripped_acacia_log",
        "stripped_acacia_log",
        "stripped_acacia_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stripped_birch_wood",
      "name": "Stripped Birch Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "stripped_birch_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "stripped_birch_log",
        "stripped_birch_log",
        "stripped_birch_log",
        "stripped_birch_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stripped_cherry_wood",
      "name": "Stripped Cherry Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "stripped_cherry_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "stripped_cherry_log",
        "stripped_cherry_log",
        "stripped_cherry_log",
        "stripped_cherry_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stripped_crimson_hyphae",
      "name": "Stripped Crimson Hyphae",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "stripped_crimson_hyphae",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "stripped_crimson_stem",
        "stripped_crimson_stem",
        "stripped_crimson_stem",
        "stripped_crimson_stem"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stripped_dark_oak_wood",
      "name": "Stripped Dark Oak Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "stripped_dark_oak_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "stripped_dark_oak_log",
        "stripped_dark_oak_log",
        "stripped_dark_oak_log",
        "stripped_dark_oak_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stripped_jungle_wood",
      "name": "Stripped Jungle Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "stripped_jungle_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "stripped_jungle_log",
        "stripped_jungle_log",
        "stripped_jungle_log",
        "stripped_jungle_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stripped_mangrove_wood",
      "name": "Stripped Mangrove Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "stripped_mangrove_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "stripped_mangrove_log",
        "stripped_mangrove_log",
        "stripped_mangrove_log",
        "stripped_mangrove_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stripped_oak_wood",
      "name": "Stripped Oak Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "stripped_oak_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "stripped_oak_log",
        "stripped_oak_log",
        "stripped_oak_log",
        "stripped_oak_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stripped_pale_oak_wood",
      "name": "Stripped Pale Oak Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "stripped_pale_oak_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "stripped_pale_oak_log",
        "stripped_pale_oak_log",
        "stripped_pale_oak_log",
        "stripped_pale_oak_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stripped_spruce_wood",
      "name": "Stripped Spruce Wood",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "stripped_spruce_wood",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "stripped_spruce_log",
        "stripped_spruce_log",
        "stripped_spruce_log",
        "stripped_spruce_log"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "stripped_warped_hyphae",
      "name": "Stripped Warped Hyphae",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "stripped_warped_hyphae",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "stripped_warped_stem",
        "stripped_warped_stem",
        "stripped_warped_stem",
        "stripped_warped_stem"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "sugar_from_honey_bottle",
      "name": "Sugar",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "sugar",
      "outputQuantity": 3,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "honey_bottle"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "suspicious_stew_from_allium",
      "name": "Suspicious Stew",
      "description": "4 ingredients using 4 unique materials.",
      "outputItemId": "suspicious_stew",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": false,
      "grid": [
        "bowl",
        "brown_mushroom",
        "red_mushroom",
        "allium"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "target",
      "name": "Target",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "target",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "redstone",
        null,
        "redstone",
        "hay_block",
        "redstone",
        null,
        "redstone",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "tinted_glass",
      "name": "Tinted Glass",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "tinted_glass",
      "outputQuantity": 2,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "amethyst_shard",
        null,
        "amethyst_shard",
        "glass",
        "amethyst_shard",
        null,
        "amethyst_shard",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "tipped_arrow",
      "name": "Tipped Arrow",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "tipped_arrow",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "arrow",
        "arrow",
        "arrow",
        "arrow",
        "lingering_potion",
        "arrow",
        "arrow",
        "arrow",
        "arrow"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "tnt",
      "name": "TNT",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "tnt",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "gunpowder",
        "sand",
        "gunpowder",
        "sand",
        "gunpowder",
        "sand",
        "gunpowder",
        "sand",
        "gunpowder"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "torch",
      "name": "Torch",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "torch",
      "outputQuantity": 4,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "coal",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "trapped_chest",
      "name": "Trapped Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "trapped_chest",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "chest",
        "tripwire_hook"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "tripwire_hook",
      "name": "Tripwire Hook",
      "description": "3 ingredients using 3 unique materials.",
      "outputItemId": "tripwire_hook",
      "outputQuantity": 2,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_ingot",
        "stick",
        "oak_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "tuff_brick_slab",
      "name": "Tuff Brick Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "tuff_brick_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "tuff_bricks",
        "tuff_bricks",
        "tuff_bricks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "tuff_brick_stairs",
      "name": "Tuff Brick Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "tuff_brick_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "tuff_bricks",
        null,
        null,
        "tuff_bricks",
        "tuff_bricks",
        null,
        "tuff_bricks",
        "tuff_bricks",
        "tuff_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "tuff_brick_wall",
      "name": "Tuff Brick Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "tuff_brick_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "tuff_bricks",
        "tuff_bricks",
        "tuff_bricks",
        "tuff_bricks",
        "tuff_bricks",
        "tuff_bricks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "tuff_bricks",
      "name": "Tuff Bricks",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "tuff_bricks",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "polished_tuff",
        "polished_tuff",
        "polished_tuff",
        "polished_tuff"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "tuff_slab",
      "name": "Tuff Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "tuff_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "tuff",
        "tuff",
        "tuff"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "tuff_stairs",
      "name": "Tuff Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "tuff_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "tuff",
        null,
        null,
        "tuff",
        "tuff",
        null,
        "tuff",
        "tuff",
        "tuff"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "tuff_wall",
      "name": "Tuff Wall",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "tuff_wall",
      "outputQuantity": 6,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "tuff",
        "tuff",
        "tuff",
        "tuff",
        "tuff",
        "tuff"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "turtle_helmet",
      "name": "Turtle Shell",
      "description": "5 ingredients using 1 unique material.",
      "outputItemId": "turtle_helmet",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "turtle_scute",
        "turtle_scute",
        "turtle_scute",
        "turtle_scute",
        null,
        "turtle_scute"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_button",
      "name": "Warped Button",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "warped_button",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "warped_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_door",
      "name": "Warped Door",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "warped_door",
      "outputQuantity": 3,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "warped_planks",
        "warped_planks",
        "warped_planks",
        "warped_planks",
        "warped_planks",
        "warped_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_fence",
      "name": "Warped Fence",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "warped_fence",
      "outputQuantity": 3,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "warped_planks",
        "stick",
        "warped_planks",
        "warped_planks",
        "stick",
        "warped_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_fence_gate",
      "name": "Warped Fence Gate",
      "description": "6 ingredients using 2 unique materials.",
      "outputItemId": "warped_fence_gate",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "stick",
        "warped_planks",
        "stick",
        "stick",
        "warped_planks",
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_fungus_on_a_stick",
      "name": "Warped Fungus on a Stick",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "warped_fungus_on_a_stick",
      "outputQuantity": 1,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "fishing_rod",
        null,
        null,
        "warped_fungus"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_hanging_sign",
      "name": "Warped Hanging Sign",
      "description": "8 ingredients using 2 unique materials.",
      "outputItemId": "warped_hanging_sign",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "iron_chain",
        null,
        "iron_chain",
        "stripped_warped_stem",
        "stripped_warped_stem",
        "stripped_warped_stem",
        "stripped_warped_stem",
        "stripped_warped_stem",
        "stripped_warped_stem"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_hyphae",
      "name": "Warped Hyphae",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "warped_hyphae",
      "outputQuantity": 3,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "warped_stem",
        "warped_stem",
        "warped_stem",
        "warped_stem"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_planks",
      "name": "Warped Planks",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "warped_planks",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "warped_stem"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_pressure_plate",
      "name": "Warped Pressure Plate",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "warped_pressure_plate",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "warped_planks",
        "warped_planks"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_shelf",
      "name": "Warped Shelf",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "warped_shelf",
      "outputQuantity": 6,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "stripped_warped_stem",
        "stripped_warped_stem",
        "stripped_warped_stem",
        null,
        null,
        null,
        "stripped_warped_stem",
        "stripped_warped_stem",
        "stripped_warped_stem"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_sign",
      "name": "Warped Sign",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "warped_sign",
      "outputQuantity": 3,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "warped_planks",
        "warped_planks",
        "warped_planks",
        "warped_planks",
        "warped_planks",
        "warped_planks",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_slab",
      "name": "Warped Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "warped_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "warped_planks",
        "warped_planks",
        "warped_planks"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_stairs",
      "name": "Warped Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "warped_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "warped_planks",
        null,
        null,
        "warped_planks",
        "warped_planks",
        null,
        "warped_planks",
        "warped_planks",
        "warped_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "warped_trapdoor",
      "name": "Warped Trapdoor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "warped_trapdoor",
      "outputQuantity": 2,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "warped_planks",
        "warped_planks",
        "warped_planks",
        "warped_planks",
        "warped_planks",
        "warped_planks"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_copper_block_from_honeycomb",
      "name": "Waxed Block of Copper",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_copper_block",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "copper_block",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_chiseled_copper",
      "name": "Waxed Chiseled Copper",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "waxed_chiseled_copper",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        null,
        "waxed_cut_copper_slab",
        null,
        null,
        "waxed_cut_copper_slab",
        null
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_copper_bars_from_honeycomb",
      "name": "Waxed Copper Bars",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_copper_bars",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "copper_bars",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_copper_bulb_from_honeycomb",
      "name": "Waxed Copper Bulb",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_copper_bulb",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "copper_bulb",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_copper_chain_from_honeycomb",
      "name": "Waxed Copper Chain",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_copper_chain",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "copper_chain",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_copper_chest_from_honeycomb",
      "name": "Waxed Copper Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_copper_chest",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "copper_chest",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_copper_door_from_honeycomb",
      "name": "Waxed Copper Door",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_copper_door",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "copper_door",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_copper_golem_statue_from_honeycomb",
      "name": "Waxed Copper Golem Statue",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_copper_golem_statue",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "copper_golem_statue",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_copper_grate",
      "name": "Waxed Copper Grate",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "waxed_copper_grate",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "waxed_copper_block",
        null,
        "waxed_copper_block",
        null,
        "waxed_copper_block",
        null,
        "waxed_copper_block",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_copper_lantern_from_honeycomb",
      "name": "Waxed Copper Lantern",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_copper_lantern",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "copper_lantern",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_copper_trapdoor_from_honeycomb",
      "name": "Waxed Copper Trapdoor",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_copper_trapdoor",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "copper_trapdoor",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_cut_copper",
      "name": "Waxed Cut Copper",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "waxed_cut_copper",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "waxed_copper_block",
        "waxed_copper_block",
        "waxed_copper_block",
        "waxed_copper_block"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_cut_copper_slab",
      "name": "Waxed Cut Copper Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "waxed_cut_copper_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "waxed_cut_copper",
        "waxed_cut_copper",
        "waxed_cut_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_cut_copper_stairs_from_honeycomb",
      "name": "Waxed Cut Copper Stairs",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_cut_copper_stairs",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "cut_copper_stairs",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_chiseled_copper",
      "name": "Waxed Exposed Chiseled Copper",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "waxed_exposed_chiseled_copper",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        null,
        "waxed_exposed_cut_copper_slab",
        null,
        null,
        "waxed_exposed_cut_copper_slab",
        null
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_copper_from_honeycomb",
      "name": "Waxed Exposed Copper",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_exposed_copper",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "exposed_copper",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_copper_bars_from_honeycomb",
      "name": "Waxed Exposed Copper Bars",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_exposed_copper_bars",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "exposed_copper_bars",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_copper_bulb_from_honeycomb",
      "name": "Waxed Exposed Copper Bulb",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_exposed_copper_bulb",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "exposed_copper_bulb",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_copper_chain_from_honeycomb",
      "name": "Waxed Exposed Copper Chain",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_exposed_copper_chain",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "exposed_copper_chain",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_copper_chest_from_honeycomb",
      "name": "Waxed Exposed Copper Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_exposed_copper_chest",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "exposed_copper_chest",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_copper_door_from_honeycomb",
      "name": "Waxed Exposed Copper Door",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_exposed_copper_door",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "exposed_copper_door",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_copper_golem_statue_from_honeycomb",
      "name": "Waxed Exposed Copper Golem Statue",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_exposed_copper_golem_statue",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "exposed_copper_golem_statue",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_copper_grate",
      "name": "Waxed Exposed Copper Grate",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "waxed_exposed_copper_grate",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "waxed_exposed_copper",
        null,
        "waxed_exposed_copper",
        null,
        "waxed_exposed_copper",
        null,
        "waxed_exposed_copper",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_copper_lantern_from_honeycomb",
      "name": "Waxed Exposed Copper Lantern",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_exposed_copper_lantern",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "exposed_copper_lantern",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_copper_trapdoor_from_honeycomb",
      "name": "Waxed Exposed Copper Trapdoor",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_exposed_copper_trapdoor",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "exposed_copper_trapdoor",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_cut_copper",
      "name": "Waxed Exposed Cut Copper",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "waxed_exposed_cut_copper",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "waxed_exposed_copper",
        "waxed_exposed_copper",
        "waxed_exposed_copper",
        "waxed_exposed_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_cut_copper_slab",
      "name": "Waxed Exposed Cut Copper Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "waxed_exposed_cut_copper_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "waxed_exposed_cut_copper",
        "waxed_exposed_cut_copper",
        "waxed_exposed_cut_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_cut_copper_stairs_from_honeycomb",
      "name": "Waxed Exposed Cut Copper Stairs",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_exposed_cut_copper_stairs",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "exposed_cut_copper_stairs",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_exposed_lightning_rod_from_honeycomb",
      "name": "Waxed Exposed Lightning Rod",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_exposed_lightning_rod",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "exposed_lightning_rod",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_lightning_rod_from_honeycomb",
      "name": "Waxed Lightning Rod",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_lightning_rod",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "lightning_rod",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_chiseled_copper",
      "name": "Waxed Oxidized Chiseled Copper",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "waxed_oxidized_chiseled_copper",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        null,
        "waxed_oxidized_cut_copper_slab",
        null,
        null,
        "waxed_oxidized_cut_copper_slab",
        null
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_copper_from_honeycomb",
      "name": "Waxed Oxidized Copper",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_oxidized_copper",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "oxidized_copper",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_copper_bars_from_honeycomb",
      "name": "Waxed Oxidized Copper Bars",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_oxidized_copper_bars",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "oxidized_copper_bars",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_copper_bulb_from_honeycomb",
      "name": "Waxed Oxidized Copper Bulb",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_oxidized_copper_bulb",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "oxidized_copper_bulb",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_copper_chain_from_honeycomb",
      "name": "Waxed Oxidized Copper Chain",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_oxidized_copper_chain",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "oxidized_copper_chain",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_copper_chest_from_honeycomb",
      "name": "Waxed Oxidized Copper Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_oxidized_copper_chest",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "oxidized_copper_chest",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_copper_door_from_honeycomb",
      "name": "Waxed Oxidized Copper Door",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_oxidized_copper_door",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "oxidized_copper_door",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_copper_golem_statue_from_honeycomb",
      "name": "Waxed Oxidized Copper Golem Statue",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_oxidized_copper_golem_statue",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "oxidized_copper_golem_statue",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_copper_grate",
      "name": "Waxed Oxidized Copper Grate",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "waxed_oxidized_copper_grate",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "waxed_oxidized_copper",
        null,
        "waxed_oxidized_copper",
        null,
        "waxed_oxidized_copper",
        null,
        "waxed_oxidized_copper",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_copper_lantern_from_honeycomb",
      "name": "Waxed Oxidized Copper Lantern",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_oxidized_copper_lantern",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "oxidized_copper_lantern",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_copper_trapdoor_from_honeycomb",
      "name": "Waxed Oxidized Copper Trapdoor",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_oxidized_copper_trapdoor",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "oxidized_copper_trapdoor",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_cut_copper",
      "name": "Waxed Oxidized Cut Copper",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "waxed_oxidized_cut_copper",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "waxed_oxidized_copper",
        "waxed_oxidized_copper",
        "waxed_oxidized_copper",
        "waxed_oxidized_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_cut_copper_slab",
      "name": "Waxed Oxidized Cut Copper Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "waxed_oxidized_cut_copper_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "waxed_oxidized_cut_copper",
        "waxed_oxidized_cut_copper",
        "waxed_oxidized_cut_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_cut_copper_stairs_from_honeycomb",
      "name": "Waxed Oxidized Cut Copper Stairs",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_oxidized_cut_copper_stairs",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "oxidized_cut_copper_stairs",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_oxidized_lightning_rod_from_honeycomb",
      "name": "Waxed Oxidized Lightning Rod",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_oxidized_lightning_rod",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "oxidized_lightning_rod",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_chiseled_copper",
      "name": "Waxed Weathered Chiseled Copper",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "waxed_weathered_chiseled_copper",
      "outputQuantity": 1,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        null,
        "waxed_weathered_cut_copper_slab",
        null,
        null,
        "waxed_weathered_cut_copper_slab",
        null
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_copper_from_honeycomb",
      "name": "Waxed Weathered Copper",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_weathered_copper",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "weathered_copper",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_copper_bars_from_honeycomb",
      "name": "Waxed Weathered Copper Bars",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_weathered_copper_bars",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "weathered_copper_bars",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_copper_bulb_from_honeycomb",
      "name": "Waxed Weathered Copper Bulb",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_weathered_copper_bulb",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "weathered_copper_bulb",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_copper_chain_from_honeycomb",
      "name": "Waxed Weathered Copper Chain",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_weathered_copper_chain",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "weathered_copper_chain",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_copper_chest_from_honeycomb",
      "name": "Waxed Weathered Copper Chest",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_weathered_copper_chest",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "weathered_copper_chest",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_copper_door_from_honeycomb",
      "name": "Waxed Weathered Copper Door",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_weathered_copper_door",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "weathered_copper_door",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_copper_golem_statue_from_honeycomb",
      "name": "Waxed Weathered Copper Golem Statue",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_weathered_copper_golem_statue",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "weathered_copper_golem_statue",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_copper_grate",
      "name": "Waxed Weathered Copper Grate",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "waxed_weathered_copper_grate",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "waxed_weathered_copper",
        null,
        "waxed_weathered_copper",
        null,
        "waxed_weathered_copper",
        null,
        "waxed_weathered_copper",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_copper_lantern_from_honeycomb",
      "name": "Waxed Weathered Copper Lantern",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_weathered_copper_lantern",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "weathered_copper_lantern",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_copper_trapdoor_from_honeycomb",
      "name": "Waxed Weathered Copper Trapdoor",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_weathered_copper_trapdoor",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "weathered_copper_trapdoor",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_cut_copper",
      "name": "Waxed Weathered Cut Copper",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "waxed_weathered_cut_copper",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "waxed_weathered_copper",
        "waxed_weathered_copper",
        "waxed_weathered_copper",
        "waxed_weathered_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_cut_copper_slab",
      "name": "Waxed Weathered Cut Copper Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "waxed_weathered_cut_copper_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "waxed_weathered_cut_copper",
        "waxed_weathered_cut_copper",
        "waxed_weathered_cut_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_cut_copper_stairs_from_honeycomb",
      "name": "Waxed Weathered Cut Copper Stairs",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_weathered_cut_copper_stairs",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "weathered_cut_copper_stairs",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "waxed_weathered_lightning_rod_from_honeycomb",
      "name": "Waxed Weathered Lightning Rod",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "waxed_weathered_lightning_rod",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "weathered_lightning_rod",
        "honeycomb"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "weathered_chiseled_copper",
      "name": "Weathered Chiseled Copper",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "weathered_chiseled_copper",
      "outputQuantity": 1,
      "width": 1,
      "height": 2,
      "shaped": true,
      "grid": [
        "weathered_cut_copper_slab",
        "weathered_cut_copper_slab"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "weathered_copper_bulb",
      "name": "Weathered Copper Bulb",
      "description": "5 ingredients using 3 unique materials.",
      "outputItemId": "weathered_copper_bulb",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "weathered_copper",
        null,
        "weathered_copper",
        "blaze_rod",
        "weathered_copper",
        null,
        "redstone",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "weathered_copper_grate",
      "name": "Weathered Copper Grate",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "weathered_copper_grate",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        "weathered_copper",
        null,
        "weathered_copper",
        null,
        "weathered_copper",
        null,
        "weathered_copper",
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "weathered_cut_copper",
      "name": "Weathered Cut Copper",
      "description": "4 ingredients using 1 unique material.",
      "outputItemId": "weathered_cut_copper",
      "outputQuantity": 4,
      "width": 2,
      "height": 2,
      "shaped": true,
      "grid": [
        "weathered_copper",
        "weathered_copper",
        "weathered_copper",
        "weathered_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "weathered_cut_copper_slab",
      "name": "Weathered Cut Copper Slab",
      "description": "3 ingredients using 1 unique material.",
      "outputItemId": "weathered_cut_copper_slab",
      "outputQuantity": 6,
      "width": 3,
      "height": 1,
      "shaped": true,
      "grid": [
        "weathered_cut_copper",
        "weathered_cut_copper",
        "weathered_cut_copper"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "weathered_cut_copper_stairs",
      "name": "Weathered Cut Copper Stairs",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "weathered_cut_copper_stairs",
      "outputQuantity": 4,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "weathered_cut_copper",
        null,
        null,
        "weathered_cut_copper",
        "weathered_cut_copper",
        null,
        "weathered_cut_copper",
        "weathered_cut_copper",
        "weathered_cut_copper"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "wheat",
      "name": "Wheat",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "wheat",
      "outputQuantity": 9,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "hay_block"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "white_banner",
      "name": "White Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "white_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "white_wool",
        "white_wool",
        "white_wool",
        "white_wool",
        "white_wool",
        "white_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_white_bed",
      "name": "White Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "white_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "white_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "white_bundle",
      "name": "White Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "white_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "white_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "white_candle",
      "name": "White Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "white_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "white_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "white_carpet",
      "name": "White Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "white_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "white_wool",
        "white_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "white_concrete_powder",
      "name": "White Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "white_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "white_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "white_dye",
      "name": "White Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "white_dye",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "bone_meal"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_white_harness",
      "name": "White Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "white_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "white_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "white_shulker_box",
      "name": "White Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "white_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "white_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "white_stained_glass",
      "name": "White Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "white_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "white_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "white_stained_glass_pane",
      "name": "White Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "white_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "white_stained_glass",
        "white_stained_glass",
        "white_stained_glass",
        "white_stained_glass",
        "white_stained_glass",
        "white_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "white_terracotta",
      "name": "White Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "white_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "white_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_white_wool",
      "name": "White Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "white_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "white_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "wind_charge",
      "name": "Wind Charge",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "wind_charge",
      "outputQuantity": 4,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "breeze_rod"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "wolf_armor",
      "name": "Wolf Armor",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "wolf_armor",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "armadillo_scute",
        null,
        null,
        "armadillo_scute",
        "armadillo_scute",
        "armadillo_scute",
        "armadillo_scute",
        null,
        "armadillo_scute"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "wooden_axe",
      "name": "Wooden Axe",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "wooden_axe",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "wooden_hoe",
      "name": "Wooden Hoe",
      "description": "4 ingredients using 2 unique materials.",
      "outputItemId": "wooden_hoe",
      "outputQuantity": 1,
      "width": 2,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        null,
        "stick",
        null,
        "stick"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "wooden_pickaxe",
      "name": "Wooden Pickaxe",
      "description": "5 ingredients using 2 unique materials.",
      "outputItemId": "wooden_pickaxe",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "oak_planks",
        null,
        "stick",
        null,
        null,
        "stick",
        null
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "wooden_shovel",
      "name": "Wooden Shovel",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "wooden_shovel",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "stick",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "wooden_spear",
      "name": "Wooden Spear",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "wooden_spear",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        null,
        null,
        "oak_planks",
        null,
        "stick",
        null,
        "stick",
        null,
        null
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "wooden_sword",
      "name": "Wooden Sword",
      "description": "3 ingredients using 2 unique materials.",
      "outputItemId": "wooden_sword",
      "outputQuantity": 1,
      "width": 1,
      "height": 3,
      "shaped": true,
      "grid": [
        "oak_planks",
        "oak_planks",
        "stick"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "yellow_banner",
      "name": "Yellow Banner",
      "description": "7 ingredients using 2 unique materials.",
      "outputItemId": "yellow_banner",
      "outputQuantity": 1,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "yellow_wool",
        "yellow_wool",
        "yellow_wool",
        "yellow_wool",
        "yellow_wool",
        "yellow_wool",
        null,
        "stick",
        null
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_yellow_bed",
      "name": "Yellow Bed",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "yellow_bed",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "yellow_dye",
        "black_bed"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "yellow_bundle",
      "name": "Yellow Bundle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "yellow_bundle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "bundle",
        "yellow_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "yellow_candle",
      "name": "Yellow Candle",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "yellow_candle",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "candle",
        "yellow_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "yellow_carpet",
      "name": "Yellow Carpet",
      "description": "2 ingredients using 1 unique material.",
      "outputItemId": "yellow_carpet",
      "outputQuantity": 3,
      "width": 2,
      "height": 1,
      "shaped": true,
      "grid": [
        "yellow_wool",
        "yellow_wool"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "yellow_concrete_powder",
      "name": "Yellow Concrete Powder",
      "description": "9 ingredients using 3 unique materials.",
      "outputItemId": "yellow_concrete_powder",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": false,
      "grid": [
        "yellow_dye",
        "sand",
        "sand",
        "sand",
        "sand",
        "gravel",
        "gravel",
        "gravel",
        "gravel"
      ],
      "difficulty": 5,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "yellow_dye_from_dandelion",
      "name": "Yellow Dye",
      "description": "1 ingredient using 1 unique material.",
      "outputItemId": "yellow_dye",
      "outputQuantity": 1,
      "width": 1,
      "height": 1,
      "shaped": false,
      "grid": [
        "dandelion"
      ],
      "difficulty": 1,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_yellow_harness",
      "name": "Yellow Harness",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "yellow_harness",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "yellow_dye",
        "black_harness"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "yellow_shulker_box",
      "name": "Yellow Shulker Box",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "yellow_shulker_box",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "shulker_box",
        "yellow_dye"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "yellow_stained_glass",
      "name": "Yellow Stained Glass",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "yellow_stained_glass",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "glass",
        "glass",
        "glass",
        "glass",
        "yellow_dye",
        "glass",
        "glass",
        "glass",
        "glass"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "yellow_stained_glass_pane",
      "name": "Yellow Stained Glass Pane",
      "description": "6 ingredients using 1 unique material.",
      "outputItemId": "yellow_stained_glass_pane",
      "outputQuantity": 16,
      "width": 3,
      "height": 2,
      "shaped": true,
      "grid": [
        "yellow_stained_glass",
        "yellow_stained_glass",
        "yellow_stained_glass",
        "yellow_stained_glass",
        "yellow_stained_glass",
        "yellow_stained_glass"
      ],
      "difficulty": 3,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "yellow_terracotta",
      "name": "Yellow Terracotta",
      "description": "9 ingredients using 2 unique materials.",
      "outputItemId": "yellow_terracotta",
      "outputQuantity": 8,
      "width": 3,
      "height": 3,
      "shaped": true,
      "grid": [
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta",
        "yellow_dye",
        "terracotta",
        "terracotta",
        "terracotta",
        "terracotta"
      ],
      "difficulty": 4,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    },
    {
      "id": "dye_yellow_wool",
      "name": "Yellow Wool",
      "description": "2 ingredients using 2 unique materials.",
      "outputItemId": "yellow_wool",
      "outputQuantity": 1,
      "width": 2,
      "height": 1,
      "shaped": false,
      "grid": [
        "yellow_dye",
        "black_wool"
      ],
      "difficulty": 2,
      "modes": [
        "practice",
        "casual",
        "ranked"
      ]
    }
  ]
}
